msgid ""
msgstr ""
"POT-Creation-Date: 2024-06-04 17:25-0300\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: es\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/features/gateAdministration/components/GateMovementBanner.tsx:75
msgid "!ATENCIÓN! La compuerta <0>{gateName}</0> ha comenzado a moverse"
msgstr "!ATENCIÓN! La compuerta <0>{gateName}</0> ha comenzado a moverse"

#: src/features/debtsAlert/components/DebtsAlertBanner.tsx:48
msgid "¡Acción requerida! Cuenta con saldo pendiente. Favor contactar al equipo comercial <0>aquí.</0>"
msgstr "¡Acción requerida! Cuenta con saldo pendiente. Favor contactar al equipo comercial <0>aquí.</0>"

#: src/features/debtsAlert/components/DebtsAlertBanner.tsx:34
msgid "¡Acción requerida! Esta cuenta en AMARU presenta un saldo pendiente. Para evitar limitaciones en el servicio, favor contáctenos al <0>+56 9 9222 1736</0> o enviar correo a <1>cs@captahydro.com</1>."
msgstr "¡Acción requerida! Esta cuenta en AMARU presenta un saldo pendiente. Para evitar limitaciones en el servicio, favor contáctenos al <0>+56 9 9222 1736</0> o enviar correo a <1>cs@captahydro.com</1>."

#: src/features/dga/components/modals/reports/TableModal.tsx:276
#: src/features/sma/components/TableModal.tsx:287
msgid "¡Comprobante copiado!"
msgstr "¡Comprobante copiado!"

#: src/features/api/components/dialogs/GeneratedUserApiSummary.tsx:14
msgid "¡La credencial ha sido creado con éxito!"
msgstr "¡La credencial ha sido creado con éxito!"

#: src/features/userProfileUpdate/components/DisableUserModal.tsx:65
msgid "¿Deseas deshabilitar el usuario {userId}?"
msgstr "¿Deseas deshabilitar el usuario {userId}?"

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:154
msgid "¿Deseas eliminar el dispositivo {deviceId}?"
msgstr "¿Deseas eliminar el dispositivo {deviceId}?"

#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:82
msgid "¿Eliminar Anuncio?"
msgstr "¿Eliminar Anuncio?"

#: src/features/notifications/components/NotificationsDeleteModal.tsx:70
msgid "¿Eliminar notificación?"
msgstr "¿Eliminar notificación?"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:92
msgid "¿Está <0>seguro</0> que quiere eliminar la credencial con el nombre de usuario <1>{0}</1> de la API?"
msgstr "¿Está <0>seguro</0> que quiere eliminar la credencial con el nombre de usuario <1>{0}</1> de la API?"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:347
msgid "¿Está seguro que desea desactivar las alertas del dispositivo {0}?"
msgstr "¿Está seguro que desea desactivar las alertas del dispositivo {0}?"

#: src/features/gateAdministration/components/DeleteRequestModal.tsx:20
msgid "¿Está seguro que desea eliminar la solicitud de movimiento?"
msgstr "¿Está seguro que desea eliminar la solicitud de movimiento?"

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:111
msgid "¿Está seguro que quiere crear un nuevo reporte?"
msgstr "¿Está seguro que quiere crear un nuevo reporte?"

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:119
msgid "¿Está seguro que quiere eliminar esta programación?"
msgstr "¿Está seguro que quiere eliminar esta programación?"

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:89
msgid "¿Estás <0>seguro</0> que deseas deshabilitar la credencial con el nombre de usuario <1>{0}</1> de la API?"
msgstr "¿Estás <0>seguro</0> que deseas deshabilitar la credencial con el nombre de usuario <1>{0}</1> de la API?"

#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:92
msgid "¿Estás <0>seguro</0> que deseas eliminar la credencial con el nombre de usuario <1>{0}</1> de la API?"
msgstr "¿Estás <0>seguro</0> que deseas eliminar la credencial con el nombre de usuario <1>{0}</1> de la API?"

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:92
msgid "¿Estás <0>seguro</0> que deseas habilitar la credencial del usuario <1>{0}</1> de la API?"
msgstr "¿Estás <0>seguro</0> que deseas habilitar la credencial del usuario <1>{0}</1> de la API?"

#: src/components/modal/ConfirmationModal.tsx:38
msgid "¿Estás seguro de que deseas continuar?"
msgstr "¿Estás seguro de que deseas continuar?"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:48
msgid "¿Estás seguro de que deseas eliminar esta organización?"
msgstr "¿Estás seguro de que deseas eliminar esta organización?"

#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:56
msgid "¿Estás seguro de que quieres borrar la configuración de este equipo?"
msgstr "¿Estás seguro de que quieres borrar la configuración de este equipo?"

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:121
msgid "¿Estás seguro que deseas <0>archivar</0> el dispositivo {deviceId}?"
msgstr "¿Estás seguro que deseas <0>archivar</0> el dispositivo {deviceId}?"

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:117
msgid "¿Estás seguro que deseas <0>eliminar</0> el dispositivo {deviceId}?"
msgstr "¿Estás seguro que deseas <0>eliminar</0> el dispositivo {deviceId}?"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:119
msgid "¿Estás seguro que deseas actualizar estos permisos?"
msgstr "¿Estás seguro que deseas actualizar estos permisos?"

#: src/components/modal/ConfirmationModal.tsx:43
msgid "¿Estás seguro que deseas cambiar de pestaña?"
msgstr "¿Estás seguro que deseas cambiar de pestaña?"

#: src/components/modal/ConfirmationModal.tsx:49
msgid "¿Estás seguro que deseas cerrar el formulario?"
msgstr "¿Estás seguro que deseas cerrar el formulario?"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:112
msgid "¿Estás seguro que deseas crear un nuevo usuario temporal?"
msgstr "¿Estás seguro que deseas crear un nuevo usuario temporal?"

#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:65
msgid "¿Estás seguro que deseas desactivar las alertas para el dispositivo con id <0><1>{0}</1></0>?"
msgstr "¿Estás seguro que deseas desactivar las alertas para el dispositivo con id <0><1>{0}</1></0>?"

#: src/features/users/components/modals/DeleteUserModal.tsx:48
msgid "¿Estás seguro que deseas eliminar al usuario con id <0>{userId}</0>?"
msgstr "¿Estás seguro que deseas eliminar al usuario con id <0>{userId}</0>?"

#: src/features/irrigations/components/DeleteIrrigation.tsx:50
msgid "¿Estás seguro que deseas eliminar el canal de irrigación {0}?"
msgstr "¿Estás seguro que deseas eliminar el canal de irrigación {0}?"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/DeleteCurveModal.tsx:26
msgid "¿Estás seguro que deseas eliminar esta curva de aforo?"
msgstr "¿Estás seguro que deseas eliminar esta curva de aforo?"

#: src/features/deviceCommands/components/calendar/DeleteScheduleCommandKeyDialog.tsx:61
msgid "¿Estás seguro que deseas eliminar este comando programado para el día {commandDate} a las {commandTime}?"
msgstr "¿Estás seguro que deseas eliminar este comando programado para el día {commandDate} a las {commandTime}?"

#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:57
msgid "¿Estás seguro que deseas eliminar la configuración de reporte <0>\"{0}\"</0>?"
msgstr "¿Estás seguro que deseas eliminar la configuración de reporte <0>\"{0}\"</0>?"

#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:77
msgid "¿Estás seguro que deseas eliminar la configuración DGA para el dispositivo {deviceId}?"
msgstr "¿Estás seguro que deseas eliminar la configuración DGA para el dispositivo {deviceId}?"

#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:82
msgid "¿Estás seguro que deseas eliminar la siguiente observación?"
msgstr "¿Estás seguro que deseas eliminar la siguiente observación?"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:124
msgid "¿Estás seguro que deseas realizar esta acción?"
msgstr "¿Estás seguro que deseas realizar esta acción?"

#: src/features/users/components/modals/SimulateUserModal.tsx:63
msgid "¿Estás seguro que deseas simular al usuario <0>{fullName}</0>?"
msgstr "¿Estás seguro que deseas simular al usuario <0>{fullName}</0>?"

#: src/pages/authentication/index.tsx:97
msgid "¿Olvidaste tu contraseña?"
msgstr "¿Olvidaste tu contraseña?"

#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:70
msgid "¿Por cuánto tiempo deseas extender la duración del usuario?"
msgstr "¿Por cuánto tiempo deseas extender la duración del usuario?"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:42
msgid "¿Qué significa Debug/Aforo?"
msgstr "¿Qué significa Debug/Aforo?"

#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:56
msgid "¿Quieres reintentar la publicación de todos los reportes fallidos del <0><1>dispositivo con id {deviceId}</1></0>?"
msgstr "¿Quieres reintentar la publicación de todos los reportes fallidos del <0><1>dispositivo con id {deviceId}</1></0>?"

#: src/features/access/components/devicesTab/DevicesListItem.tsx:94
#: src/features/access/components/organizationsTab/OrganizationsListItem.tsx:47
#: src/features/access/components/usersTab/UsersListItem.tsx:101
#: src/features/deviceProfile/components/page/Observations.tsx:75
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:365
msgid "(editado)"
msgstr "(editado)"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:98
msgid "(Este paso NO puede ser anulado)"
msgstr "(Este paso NO puede ser anulado)"

#: src/features/metricsViews/components/MetricsViewList.tsx:56
msgid "(maestro)"
msgstr "(maestro)"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:155
msgid "{0, plural, one {1 Dispositivo} other {# Dispositivos}}"
msgstr "{0, plural, one {1 Dispositivo} other {# Dispositivos}}"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:134
msgid "{0, plural, one {1 Organización} other {# Organizaciones}}"
msgstr "{0, plural, one {1 Organización} other {# Organizaciones}}"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:174
msgid "{0, plural, one {1 Usuario} other {# Usuarios}}"
msgstr "{0, plural, one {1 Usuario} other {# Usuarios}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:171
msgid "{0, plural, one {Al <0>usuario de ID {userId} </0>se le cambió el acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le cambió el acceso sobre los dispositivos de{2}}}"
msgstr "{0, plural, one {Al <0>usuario de ID {userId} </0>se le cambió el acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le cambió el acceso sobre los dispositivos de{2}}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:197
msgid "{0, plural, one {Al <0>usuario de ID {userId} </0>se le denegó el acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le denegó el acceso sobre los dispositivos de{2}}}"
msgstr "{0, plural, one {Al <0>usuario de ID {userId} </0>se le denegó el acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le denegó el acceso sobre los dispositivos de{2}}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:223
msgid "{0, plural, one {Al <0>usuario de ID {userId} </0>se le otorgó acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le denegó acceso sobre los dispositivos de{2}}}"
msgstr "{0, plural, one {Al <0>usuario de ID {userId} </0>se le otorgó acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le denegó acceso sobre los dispositivos de{2}}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:61
msgid "{0, plural, one {Se cambió el acceso sobre el <0>dispositivo con ID {deviceId} </0>al usuario de <1>ID {1}</1>} other {Se cambió el acceso sobre el <2>dispositivo con ID {deviceId} </2> a los usuarios de {2}}}"
msgstr "{0, plural, one {Se cambió el acceso sobre el <0>dispositivo con ID {deviceId} </0>al usuario de <1>ID {1}</1>} other {Se cambió el acceso sobre el <2>dispositivo con ID {deviceId} </2> a los usuarios de {2}}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:86
msgid "{0, plural, one {Se denegó acceso sobre el <0>dispositivo <1/> ID {deviceId}</0> al usuario de <2>ID {1} </2>} other {Se denegó acceso sobre el <3>dispositivo de ID {deviceId} </3> a los usuarios de {2}}}"
msgstr "{0, plural, one {Se denegó acceso sobre el <0>dispositivo <1/> ID {deviceId}</0> al usuario de <2>ID {1} </2>} other {Se denegó acceso sobre el <3>dispositivo de ID {deviceId} </3> a los usuarios de {2}}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:113
msgid "{0, plural, one {Se otorgó acceso sobre el <0>dispositivo de ID {deviceId} </0>al usuario de <1>ID {1} </1>} other {Se otorgó acceso sobre el <2>dispositivo de ID {deviceId} </2> a los usuarios de {2}}}"
msgstr "{0, plural, one {Se otorgó acceso sobre el <0>dispositivo de ID {deviceId} </0>al usuario de <1>ID {1} </1>} other {Se otorgó acceso sobre el <2>dispositivo de ID {deviceId} </2> a los usuarios de {2}}}"

#: src/features/reports/components/ReportHistory.tsx:182
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:74
msgid "{0, plural, zero {No hay dispositivos} one {# dispositivo} other {# dispositivos}}"
msgstr "{0, plural, zero {No hay dispositivos} one {# dispositivo} other {# dispositivos}}"

#: src/features/reports/components/ReportHistory.tsx:190
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:82
msgid "{0, plural, zero {No hay métricas} one {# métrica} other {# métricas}}"
msgstr "{0, plural, zero {No hay métricas} one {# métrica} other {# métricas}}"

#: src/features/metricsViews/components/MetricsView.tsx:329
#: src/features/metricsViews/components/MetricsViewList.tsx:62
msgid "{0} dispositivos"
msgstr "{0} dispositivos"

#: src/features/audit/components/AuditLogsTimeline.tsx:231
#: src/features/userProfile/components/UserProfileAuditLogs.tsx:78
msgid "{0} en"
msgstr "{0} en"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:74
#: src/features/notifications/components/Notifications.tsx:144
msgid "{0} usuarios"
msgstr "{0} usuarios"

#: src/features/billing/components/table/DevicesTable.tsx:208
#: src/features/billing/components/table/ProjectsTable.tsx:199
msgid "{0} y {1} más"
msgstr "{0} y {1} más"

#: src/components/TablePaginationActions.tsx:74
#: src/components/TablePaginationActions.tsx:120
msgid "{0}-{1} de {count}"
msgstr "{0}-{1} de {count}"

#: src/features/standardDesign/components/autocomplete/StandardAutocomplete.tsx:57
#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:70
msgid "{count, plural, one {Dispositivo} other {Dispositivos}}"
msgstr "{count, plural, one {Dispositivo} other {Dispositivos}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:105
msgid "{count, plural, one {Moneda} other {Monedas}}"
msgstr "{count, plural, one {Moneda} other {Monedas}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocomplete.tsx:64
#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:77
msgid "{count, plural, one {Organización} other {Organizaciones}}"
msgstr "{count, plural, one {Organización} other {Organizaciones}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:98
msgid "{count, plural, one {Proyecto} other {Proyectos}}"
msgstr "{count, plural, one {Proyecto} other {Proyectos}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocomplete.tsx:71
#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:84
msgid "{count, plural, one {Red de canales} other {Redes de canales}}"
msgstr "{count, plural, one {Red de canales} other {Redes de canales}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:112
msgid "{count, plural, one {Servicio} other {Servicios}}"
msgstr "{count, plural, one {Servicio} other {Servicios}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocomplete.tsx:78
#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:91
msgid "{count, plural, one {Usuario} other {Usuarios}}"
msgstr "{count, plural, one {Usuario} other {Usuarios}}"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:93
#: src/features/deviceProfile/components/page/DGAInfo.tsx:100
msgid "{days} días"
msgstr "{days} días"

#: src/utils/devices/formatSourceColor.ts:35
msgid "{deviceSource} del ({deviceSourceInfo})"
msgstr "{deviceSource} del ({deviceSourceInfo})"

#: src/features/integrations/components/devicesList/index.tsx:138
msgid "{label}"
msgstr "{label}"

#: src/features/sma/utils/echartOptions.ts:17
msgid "{marker} {dateString}: <b>En reintento</b>"
msgstr "{marker} {dateString}: <b>En reintento</b>"

#: src/features/sma/utils/echartOptions.ts:15
msgid "{marker} {dateString}: <b>Publicado</>"
msgstr "{marker} {dateString}: <b>Publicado</>"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:467
msgid "{usersNumber, plural, one {El usuario {users} recibió un <0>mensaje</0> por <1>{notificationType}</1>} other {Los usuarios {users} {0, plural, one {} other {y <2># más</2>}} recibieron un <3>mensaje</3> por <4>{notificationType}</4>}}"
msgstr "{usersNumber, plural, one {El usuario {users} recibió un <0>mensaje</0> por <1>{notificationType}</1>} other {Los usuarios {users} {0, plural, one {} other {y <2># más</2>}} recibieron un <3>mensaje</3> por <4>{notificationType}</4>}}"

#: src/features/deviceProfile/components/page/events/EventsChart.tsx:69
msgid "{value} eventos"
msgstr "{value} eventos"

#: src/features/billing/components/payments/PaymentSummary.tsx:134
msgid "* Está editando el registro de pago creado por"
msgstr "* Está editando el registro de pago creado por"

#: src/utils/getUnitTranslation.ts:55
#: src/utils/units.ts:86
msgid "%"
msgstr "%"

#: src/utils/getUnitTranslation.ts:51
#: src/utils/units.ts:81
msgid "°"
msgstr "°"

#: src/utils/getUnitTranslation.ts:91
#: src/utils/units.ts:131
msgid "°C"
msgstr "°C"

#: src/utils/getUnitTranslation.ts:95
#: src/utils/units.ts:136
msgid "°F"
msgstr "°F"

#: src/features/reports/components/creationSection/CreateReportsSection.tsx:27
msgid "+ SOLICITAR REPORTE"
msgstr "+ SOLICITAR REPORTE"

#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:150
msgid "<0>¡PRECAUCIÓN!</0> Activar esto causará que los datos del dispositivo se guarden como 0."
msgstr "<0>¡PRECAUCIÓN!</0> Activar esto causará que los datos del dispositivo se guarden como 0."

#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:73
msgid "<0>{0}</0> dispositivos con acceso"
msgstr "<0>{0}</0> dispositivos con acceso"

#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:114
msgid "<0>{0}</0> usuarios con acceso"
msgstr "<0>{0}</0> usuarios con acceso"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:310
msgid "<0>{0}</0> usuarios seleccionados de <1>{1}</1>"
msgstr "<0>{0}</0> usuarios seleccionados de <1>{1}</1>"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:496
msgid "<0>{usersNumber}</0> usuarios recibieron un <1>mensaje</1> por <2>{notificationType}</2>:"
msgstr "<0>{usersNumber}</0> usuarios recibieron un <1>mensaje</1> por <2>{notificationType}</2>:"

#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:124
msgid "<0>{withAccessNumber}</0> usuarios con acceso de <1>{totalNumber}</1>"
msgstr "<0>{withAccessNumber}</0> usuarios con acceso de <1>{totalNumber}</1>"

#: src/features/api/components/APIMainText.tsx:15
msgid "<0>En Capta Hydro tenemos ahora disponible nuestra API para hacer consultas y escrituras a sus dispositivos sin tener que hacer uso de Amaru. Entre las funcionalidades que tiene disponible son:</0><1><2>Chequear sus equipos disponibles</2><3>Consultar datos de sus equipos</3><4>Escribir datos de nivel y/o caudal en dispositivos</4></1><5>Para poder utilizar de manera correcta la API, vaya a la sección de <6>documentacion</6></5>"
msgstr "<0>En Capta Hydro tenemos ahora disponible nuestra API para hacer consultas y escrituras a sus dispositivos sin tener que hacer uso de Amaru. Entre las funcionalidades que tiene disponible son:</0><1><2>Chequear sus equipos disponibles</2><3>Consultar datos de sus equipos</3><4>Escribir datos de nivel y/o caudal en dispositivos</4></1><5>Para poder utilizar de manera correcta la API, vaya a la sección de <6>documentacion</6></5>"

#: src/features/debtsAlert/components/DebtsAlertPopover.tsx:58
msgid "<0>Estimado cliente,</0><1>Hemos detectado que la cuenta de AMARU presenta un saldo pendiente. Favor contactar al servicio de post-venta de Capta Hydro:</1><2><3><4>Cristóbal Matamala</4></3><5><6><7/></6><8><9>+56 9 9222 1736</9></8></5><10><11><12/></11><13><14>cs@captahydro.com</14></13></10></2><15>Regularice ahora y evite limitaciones en el servicio.</15><16>Equipo Capta Hydro</16>"
msgstr "<0>Estimado cliente,</0><1>Hemos detectado que la cuenta de AMARU presenta un saldo pendiente. Favor contactar al servicio de post-venta de Capta Hydro:</1><2><3><4>Cristóbal Matamala</4></3><5><6><7/></6><8><9>+56 9 9222 1736</9></8></5><10><11><12/></11><13><14>cs@captahydro.com</14></13></10></2><15>Regularice ahora y evite limitaciones en el servicio.</15><16>Equipo Capta Hydro</16>"

#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:86
msgid "<0>Nota:</0> La credencial generada solo va a tener permisos de lectura de dispositivos. Para los permisos de escritura comuniquese con el equipo de Capta Hydro."
msgstr "<0>Nota:</0> La credencial generada solo va a tener permisos de lectura de dispositivos. Para los permisos de escritura comuniquese con el equipo de Capta Hydro."

#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:43
msgid "<0>Para los clientes, ahora tenemos disponible nuestra API que permite hacer consultas y escrituras a los dispositivos en que son dueños. Entre las funcionalidades que tienen disponibles son:</0><1><2>Chequear sus equipos disponibles</2><3>Consultar datos de sus equipos</3><4>Escribir datos de nivel y/o caudal en dispositivos</4></1><5>En esta sección podrás obtener toda la información para dar soporte al cliente con respecto a la API</5>"
msgstr "<0>Para los clientes, ahora tenemos disponible nuestra API que permite hacer consultas y escrituras a los dispositivos en que son dueños. Entre las funcionalidades que tienen disponibles son:</0><1><2>Chequear sus equipos disponibles</2><3>Consultar datos de sus equipos</3><4>Escribir datos de nivel y/o caudal en dispositivos</4></1><5>En esta sección podrás obtener toda la información para dar soporte al cliente con respecto a la API</5>"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:32
#: src/features/controlCenter/slices/controlCenterSlice.ts:21
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:58
#: src/features/reports/utils/meanWindowOptions.ts:43
msgid "1 día"
msgstr "1 día"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:12
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:28
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:46
#: src/features/reports/utils/meanWindowOptions.ts:31
msgid "1 hora"
msgstr "1 hora"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:52
msgid "1 mes"
msgstr "1 mes"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:12
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:26
#: src/features/reports/utils/meanWindowOptions.ts:11
msgid "1 minuto"
msgstr "1 minuto"

#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:34
#: src/features/reports/utils/meanWindowOptions.ts:19
msgid "10 minutos"
msgstr "10 minutos"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:27
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:54
#: src/features/reports/utils/meanWindowOptions.ts:39
#: src/features/userPreferences/components/RegionTab.tsx:251
msgid "12 horas"
msgstr "12 horas"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:47
msgid "15 días"
msgstr "15 días"

#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:38
#: src/features/reports/utils/meanWindowOptions.ts:23
msgid "15 minutos"
msgstr "15 minutos"

#: src/features/userPreferences/components/RegionTab.tsx:275
msgid "2 dígitos"
msgstr "2 dígitos"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:16
msgid "2 minutos"
msgstr "2 minutos"

#: src/features/userPreferences/components/RegionTab.tsx:251
msgid "24 horas"
msgstr "24 horas"

#: src/features/users/components/UsersTable.tsx:82
msgid "2FA"
msgstr "2FA"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:37
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:62
#: src/features/reports/utils/meanWindowOptions.ts:47
msgid "3 días"
msgstr "3 días"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:17
msgid "3 horas"
msgstr "3 horas"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:24
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:42
#: src/features/reports/utils/meanWindowOptions.ts:27
msgid "30 minutos"
msgstr "30 minutos"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:20
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:30
#: src/features/reports/utils/meanWindowOptions.ts:15
msgid "5 minutos"
msgstr "5 minutos"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:22
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:50
#: src/features/reports/utils/meanWindowOptions.ts:35
msgid "6 horas"
msgstr "6 horas"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:42
msgid "7 días"
msgstr "7 días"

#: src/utils/getUnitTranslation.ts:59
#: src/utils/units.ts:91
msgid "A"
msgstr "A"

#: src/features/api/components/ApiKeysList.tsx:28
msgid "A continuación se encuentran las API Keys de cada una de nuestros clientes:"
msgstr "A continuación se encuentran las API Keys de cada una de nuestros clientes:"

#: src/features/api/components/CaptaApiUsersList.tsx:79
msgid "A continuación se encuentran las credenciales de API de todas las organizaciones. Usted puede, crear, editar, eliminar, habilitar y deshabilitar, las credenciales de API de cada una de estas."
msgstr "A continuación se encuentran las credenciales de API de todas las organizaciones. Usted puede, crear, editar, eliminar, habilitar y deshabilitar, las credenciales de API de cada una de estas."

#: src/features/api/components/ApiUsersList.tsx:50
msgid "A continuación se encuentran las credenciales de API que su organización ha creado:"
msgstr "A continuación se encuentran las credenciales de API que su organización ha creado:"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:304
msgid "a las"
msgstr "a las"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:934
msgid "Abajo"
msgstr "Abajo"

#: src/features/controlCenter/components/window/StationListItem.tsx:476
msgid "Abertura compuerta admisión"
msgstr "Abertura compuerta admisión"

#: src/features/controlCenter/components/window/StationListItem.tsx:485
msgid "Abertura compuerta restitución"
msgstr "Abertura compuerta restitución"

#: src/features/gateAdministration/components/index.tsx:422
msgid "Abertura compuerta: {0}"
msgstr "Abertura compuerta: {0}"

#: src/features/controlCenter/components/panel/Minicharts.tsx:234
#: src/features/devicesAnalysis/components/panel/Chart.tsx:295
#: src/features/gateAdministration/components/GatePositionChart.tsx:132
#: src/features/gates/components/list/GateListItemMetrics.tsx:48
msgid "Abertura de compuerta"
msgstr "Abertura de compuerta"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:10
msgid "abertura de la compuerta (en cm)"
msgstr "abertura de la compuerta (en cm)"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:60
msgid "Abertura final"
msgstr "Abertura final"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:56
msgid "Abertura inicial"
msgstr "Abertura inicial"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:55
msgid "Abertura máxima"
msgstr "Abertura máxima"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:42
msgid "Abertura mínima"
msgstr "Abertura mínima"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:49
msgid "Abertura solicitada"
msgstr "Abertura solicitada"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:20
msgid "Abril"
msgstr "Abril"

#: src/features/deviceProfile/components/page/General.tsx:87
msgid "Abrir en Google Maps"
msgstr "Abrir en Google Maps"

#: src/features/gateAdministration/components/index.tsx:526
msgid "Abrir gráfico avanzado"
msgstr "Abrir gráfico avanzado"

#: src/features/gateAdministration/components/MovementHistory.tsx:44
msgid "Abrir historial completo"
msgstr "Abrir historial completo"

#: src/features/controlCenter/components/window/Window.tsx:283
msgid "Abrir menú de opciones"
msgstr "Abrir menú de opciones"

#: src/components/tooltips/DeviceTooltip.tsx:53
#: src/components/tooltips/UserTooltip.tsx:50
#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:134
#: src/features/users/components/tableCells/UserPictureCell.tsx:56
msgid "Abrir perfil"
msgstr "Abrir perfil"

#: src/features/controlCenter/components/window/Window.tsx:78
msgid "Abrir ventana de dispositivos"
msgstr "Abrir ventana de dispositivos"

#: src/features/users/utils/filterOptions.ts:123
msgid "Accedió los últimos 30 días"
msgstr "Accedió los últimos 30 días"

#: src/features/users/utils/filterOptions.ts:118
msgid "Accedió los últimos 7 días"
msgstr "Accedió los últimos 7 días"

#: src/features/audit/utils/parseProperty.ts:119
msgid "acceso"
msgstr "acceso"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:228
msgid "Acceso"
msgstr "Acceso"

#: src/features/access/components/usersTab/UsersTab.tsx:110
msgid "Acceso a dispositivos para usuario {selectedUserId}"
msgstr "Acceso a dispositivos para usuario {selectedUserId}"

#: src/features/access/components/devicesTab/DevicesTab.tsx:111
msgid "Acceso de usuarios para <0><1>dispositivo {selectedDeviceId}</1></0>"
msgstr "Acceso de usuarios para <0><1>dispositivo {selectedDeviceId}</1></0>"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:168
msgid "Accesor"
msgstr "Accesor"

#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:86
#: src/pages/access/index.tsx:9
msgid "Accesos"
msgstr "Accesos"

#: src/features/audit/components/AuditLogDetails.tsx:86
#: src/features/audit/components/AuditLogsSidebar.tsx:194
msgid "Acción"
msgstr "Acción"

#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:326
#: src/features/deviceConfiguration/data/tableColumns.ts:25
#: src/features/metricsViews/components/MetricsViewList.tsx:38
#: src/features/notifications/components/Notifications.tsx:94
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:318
msgid "Acciones"
msgstr "Acciones"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:482
msgid "Activada"
msgstr "Activada"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:148
#: src/utils/devices/getDeviceStatusFormat.ts:7
msgid "Activar"
msgstr "Activar"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:363
msgid "Activar autenticación en dos pasos"
msgstr "Activar autenticación en dos pasos"

#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:147
msgid "Activar canal seco"
msgstr "Activar canal seco"

#: src/features/deviceConfigurationModal/components/publicTab/index.tsx:38
msgid "Activar dispositivo público para la organización <0>{0}</0>"
msgstr "Activar dispositivo público para la organización <0>{0}</0>"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:202
msgid "Activar o desactivar deudor"
msgstr "Activar o desactivar deudor"

#: src/features/organizationsManagement/components/OrganizationSwitchStatus.tsx:13
msgid "Activar o desactivar organización"
msgstr "Activar o desactivar organización"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:191
msgid "Activar o desactivar organización en dos pasos a todos los usuarios de la organización"
msgstr "Activar o desactivar organización en dos pasos a todos los usuarios de la organización"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:45
#: src/pages/activate-user/index.tsx:12
msgid "Activar usuario temporal"
msgstr "Activar usuario temporal"

#: src/features/deviceProfile/components/DeviceProfileModal.tsx:69
#: src/features/userProfile/components/UserProfileAuditLogs.tsx:48
#: src/features/userProfile/components/UserProfileAuditLogsSkeleton.tsx:7
msgid "Actividad reciente"
msgstr "Actividad reciente"

#: src/features/audit/utils/parseProperty.ts:145
msgid "activo"
msgstr "activo"

#: src/features/users/utils/filterOptions.ts:108
#: src/utils/devices/getDeviceStatusFormat.ts:8
#: src/utils/i18n/getDeviceStatus.ts:14
msgid "Activo"
msgstr "Activo"

#: src/components/filters/StatusFilter.tsx:20
#: src/features/devices2/components/DevicesHeader.tsx:121
#: src/features/deviceSupport/data/status.ts:8
#: src/features/gates/components/Gates.tsx:90
msgid "Activos"
msgstr "Activos"

#: src/features/gateAdministration/components/MoveGate.tsx:198
msgid "Actual"
msgstr "Actual"

#: src/components/Reload.tsx:35
#: src/features/controlCenter/components/window/Window.tsx:265
msgid "Actualizado"
msgstr "Actualizado"

#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:30
msgid "Actualizado correctamente"
msgstr "Actualizado correctamente"

#: src/features/audit/utils/parseProperty.ts:150
msgid "actualizado el"
msgstr "actualizado el"

#: src/features/announcements/components/AnnouncementsViewModal.tsx:78
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:560
msgid "Actualizado el"
msgstr "Actualizado el"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:85
msgid "Actualizando permisos de la credencial con nombre de usuario <0>{0}</0>"
msgstr "Actualizando permisos de la credencial con nombre de usuario <0>{0}</0>"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:144
msgid "Actualizar"
msgstr "Actualizar"

#: src/features/audit/components/AuditLogDetailsRow.tsx:13
msgid "ACTUALIZAR"
msgstr "ACTUALIZAR"

#: src/features/audit/utils/getActionTypeOptions.ts:88
msgid "Actualizar Acceso de Dispositivo"
msgstr "Actualizar Acceso de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:127
msgid "Actualizar Acceso de Organización"
msgstr "Actualizar Acceso de Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:160
msgid "Actualizar Acceso de Usuario"
msgstr "Actualizar Acceso de Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:91
msgid "Actualizar Alarmas de Dispositivo"
msgstr "Actualizar Alarmas de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:163
msgid "Actualizar Alarmas de Usuario"
msgstr "Actualizar Alarmas de Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:94
msgid "Actualizar Alertas de Dispositivo"
msgstr "Actualizar Alertas de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:166
msgid "Actualizar Alertas de Usuario"
msgstr "Actualizar Alertas de Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:205
msgid "Actualizar Alias de Dispositivo"
msgstr "Actualizar Alias de Dispositivo"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:133
msgid "Actualizar alias de organizaciones asociadas al dispositivo <0>{0}</0> con ID <1>{1}</1>"
msgstr "Actualizar alias de organizaciones asociadas al dispositivo <0>{0}</0> con ID <1>{1}</1>"

#: src/features/audit/utils/getActionTypeOptions.ts:79
msgid "Actualizar API para Organización"
msgstr "Actualizar API para Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:85
msgid "Actualizar Calibración"
msgstr "Actualizar Calibración"

#: src/features/audit/utils/getActionTypeOptions.ts:196
msgid "Actualizar Campos de Configuración de Soporte del Usuario"
msgstr "Actualizar Campos de Configuración de Soporte del Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:121
msgid "Actualizar Canal de Irrigación"
msgstr "Actualizar Canal de Irrigación"

#: src/features/audit/utils/getActionTypeOptions.ts:139
msgid "Actualizar Clase de Canal de SIRA"
msgstr "Actualizar Clase de Canal de SIRA"

#: src/features/deviceCommands/components/calendar/UpdateCommandKeyDialog.tsx:66
msgid "Actualizar Comando Programado"
msgstr "Actualizar Comando Programado"

#: src/features/audit/utils/getActionTypeOptions.ts:103
msgid "Actualizar Configuración de Calendario para Dispositivo"
msgstr "Actualizar Configuración de Calendario para Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:241
msgid "Actualizar Configuración de DGA"
msgstr "Actualizar Configuración de DGA"

#: src/features/deviceProfile/components/modal/Status.tsx:170
#: src/features/deviceProfile/components/modal/Status.tsx:190
msgid "Actualizar configuración de hardware"
msgstr "Actualizar configuración de hardware"

#: src/features/audit/utils/getActionTypeOptions.ts:175
msgid "Actualizar Configuración de Hardware de Dispositivo"
msgstr "Actualizar Configuración de Hardware de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:259
msgid "Actualizar Configuración de Notificación de DGA"
msgstr "Actualizar Configuración de Notificación de DGA"

#: src/features/audit/utils/getActionTypeOptions.ts:130
msgid "Actualizar Configuración de Organización"
msgstr "Actualizar Configuración de Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:247
msgid "Actualizar Configuración de Recurrencia de Envío de DGA"
msgstr "Actualizar Configuración de Recurrencia de Envío de DGA"

#: src/features/deviceProfile/components/modal/Status.tsx:225
#: src/features/deviceProfile/components/modal/Status.tsx:245
#: src/features/deviceProfile/components/modal/Status.tsx:262
msgid "Actualizar configuración DGA"
msgstr "Actualizar configuración DGA"

#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:86
msgid "Actualizar contraseña credencial API"
msgstr "Actualizar contraseña credencial API"

#: src/features/audit/utils/getActionTypeOptions.ts:82
msgid "Actualizar Contraseña de API para Organización"
msgstr "Actualizar Contraseña de API para Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:136
msgid "Actualizar Curvas de Aforo"
msgstr "Actualizar Curvas de Aforo"

#. Análisis de estaciones - tooltip de botón para actualizar datos
#: src/components/Reload.tsx:19
#: src/features/controlCenter/components/window/Window.tsx:267
#: src/features/devicesAnalysis/components/LastData.tsx:108
#: src/features/gateAdministration/components/index.tsx:444
msgid "Actualizar datos"
msgstr "Actualizar datos"

#: src/features/audit/utils/getActionTypeOptions.ts:142
msgid "Actualizar Distribución de SIRA"
msgstr "Actualizar Distribución de SIRA"

#: src/features/audit/utils/getActionTypeOptions.ts:145
msgid "Actualizar Distribución de SIRA Maipo"
msgstr "Actualizar Distribución de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:148
msgid "Actualizar Dotación Mínima de Distribución de SIRA Maipo"
msgstr "Actualizar Dotación Mínima de Distribución de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:109
msgid "Actualizar Estado de Dispositivo"
msgstr "Actualizar Estado de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:190
msgid "Actualizar Estado de Soporte del Dispositivo"
msgstr "Actualizar Estado de Soporte del Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:193
msgid "Actualizar Filtros de Configuración de Soporte del Usuario"
msgstr "Actualizar Filtros de Configuración de Soporte del Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:106
msgid "Actualizar Filtros de Dispositivo"
msgstr "Actualizar Filtros de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:118
msgid "Actualizar Información"
msgstr "Actualizar Información"

#: src/features/audit/utils/getActionTypeOptions.ts:112
msgid "Actualizar Información de DGA (deprecado)"
msgstr "Actualizar Información de DGA (deprecado)"

#: src/features/audit/utils/getActionTypeOptions.ts:268
msgid "Actualizar información del pago"
msgstr "Actualizar información del pago"

#: src/features/audit/utils/getActionTypeOptions.ts:262
msgid "Actualizar la periodicidad del cobro"
msgstr "Actualizar la periodicidad del cobro"

#: src/features/audit/utils/getActionTypeOptions.ts:115
msgid "Actualizar Límites de Flujo"
msgstr "Actualizar Límites de Flujo"

#: src/features/audit/utils/getActionTypeOptions.ts:214
msgid "Actualizar Modelado Matemático"
msgstr "Actualizar Modelado Matemático"

#: src/features/audit/utils/getActionTypeOptions.ts:100
msgid "Actualizar Notificaciones de Alerta de Dispositivo"
msgstr "Actualizar Notificaciones de Alerta de Dispositivo"

#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:111
#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:69
#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:96
msgid "Actualizar observación"
msgstr "Actualizar observación"

#: src/features/audit/utils/getActionTypeOptions.ts:124
msgid "Actualizar Organización"
msgstr "Actualizar Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:133
msgid "Actualizar Parámetros de Radar"
msgstr "Actualizar Parámetros de Radar"

#: src/features/audit/utils/getActionTypeOptions.ts:151
msgid "Actualizar Participaciones de Distribución de SIRA Maipo"
msgstr "Actualizar Participaciones de Distribución de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:235
msgid "Actualizar Preferencias de Usuario"
msgstr "Actualizar Preferencias de Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:229
msgid "Actualizar Programación de Reporte"
msgstr "Actualizar Programación de Reporte"

#: src/pages/billing/UpdatePaymentView.tsx:11
msgid "Actualizar Registro de Pago"
msgstr "Actualizar Registro de Pago"

#: src/features/audit/utils/getActionTypeOptions.ts:220
msgid "Actualizar Reporte"
msgstr "Actualizar Reporte"

#: src/features/audit/utils/getActionTypeOptions.ts:286
msgid "Actualizar servicio de facturación"
msgstr "Actualizar servicio de facturación"

#: src/features/audit/utils/getActionTypeOptions.ts:277
msgid "Actualizar servicio de para proyecto de facturación"
msgstr "Actualizar servicio de para proyecto de facturación"

#: src/features/audit/utils/getActionTypeOptions.ts:157
msgid "Actualizar Usuario"
msgstr "Actualizar Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:154
msgid "Actualizar Usuario de SIRA a Notificar"
msgstr "Actualizar Usuario de SIRA a Notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:237
msgid "actualizó el acceso a la organización"
msgstr "actualizó el acceso a la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:52
msgid "actualizó el acceso al dispositivo"
msgstr "actualizó el acceso al dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:141
msgid "actualizó el acceso del usuario"
msgstr "actualizó el acceso del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:108
msgid "actualizó el alias del dispositivo"
msgstr "actualizó el alias del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:331
msgid "actualizó el cronograma del reporte"
msgstr "actualizó el cronograma del reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:100
msgid "actualizó el estado de soporte del dispositivo"
msgstr "actualizó el estado de soporte del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:40
msgid "actualizó el estado del dispositivo"
msgstr "actualizó el estado del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:32
msgid "actualizó el modelado matemático"
msgstr "actualizó el modelado matemático"

#: src/features/audit/utils/getDisplayNameActionType.ts:319
msgid "actualizó el reporte"
msgstr "actualizó el reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:133
msgid "actualizó el usuario"
msgstr "actualizó el usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:216
msgid "actualizó el usuario de SIRA para notificar"
msgstr "actualizó el usuario de SIRA para notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:253
msgid "actualizó la API para la organización"
msgstr "actualizó la API para la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:12
msgid "actualizó la calibración"
msgstr "actualizó la calibración"

#: src/features/audit/utils/getDisplayNameActionType.ts:204
msgid "actualizó la clase de canal de SIRA"
msgstr "actualizó la clase de canal de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:394
msgid "actualizó la configuración de DGA"
msgstr "actualizó la configuración de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:241
msgid "actualizó la configuración de la organización"
msgstr "actualizó la configuración de la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:414
msgid "actualizó la configuración de notificación de DGA"
msgstr "actualizó la configuración de notificación de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:410
msgid "actualizó la configuración de recurrencia de envío de DGA"
msgstr "actualizó la configuración de recurrencia de envío de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:72
msgid "actualizó la configuración del calendario del dispositivo"
msgstr "actualizó la configuración del calendario del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:88
msgid "actualizó la configuración del hardware del dispositivo"
msgstr "actualizó la configuración del hardware del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:257
msgid "actualizó la contraseña de la API para la organización"
msgstr "actualizó la contraseña de la API para la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:191
msgid "actualizó la distribución de SIRA"
msgstr "actualizó la distribución de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:285
msgid "actualizó la distribución de SIRA Maipo"
msgstr "actualizó la distribución de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:293
msgid "actualizó la dotación mínima de la distribución de SIRA Maipo"
msgstr "actualizó la dotación mínima de la distribución de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:36
msgid "actualizó la información"
msgstr "actualizó la información"

#: src/features/audit/utils/getDisplayNameActionType.ts:381
msgid "actualizó la información de DGA"
msgstr "actualizó la información de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:344
msgid "actualizó la información del pago de un proyecto."
msgstr "actualizó la información del pago de un proyecto."

#: src/features/audit/utils/getDisplayNameActionType.ts:186
msgid "actualizó la irrigación"
msgstr "actualizó la irrigación"

#: src/features/audit/utils/getDisplayNameActionType.ts:233
msgid "actualizó la organización"
msgstr "actualizó la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:336
msgid "actualizó la periodicidad del cobro recurrente del proyecto"
msgstr "actualizó la periodicidad del cobro recurrente del proyecto"

#: src/features/audit/utils/getDisplayNameActionType.ts:289
msgid "actualizó las acciones de la distribución de SIRA Maipo"
msgstr "actualizó las acciones de la distribución de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:64
msgid "actualizó las alarmas del dispositivo"
msgstr "actualizó las alarmas del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:149
msgid "actualizó las alarmas del usuario"
msgstr "actualizó las alarmas del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:56
msgid "actualizó las alertas del dispositivo"
msgstr "actualizó las alertas del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:145
msgid "actualizó las alertas del usuario"
msgstr "actualizó las alertas del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:28
msgid "actualizó las curvas de aforo"
msgstr "actualizó las curvas de aforo"

#: src/features/audit/utils/getDisplayNameActionType.ts:68
msgid "actualizó las notificaciones de alerta del dispositivo"
msgstr "actualizó las notificaciones de alerta del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:165
msgid "actualizó las preferencias del usuario"
msgstr "actualizó las preferencias del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:157
msgid "actualizó los campos de configuración de soporte del usuario"
msgstr "actualizó los campos de configuración de soporte del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:153
msgid "actualizó los filtros de configuración de soporte del usuario"
msgstr "actualizó los filtros de configuración de soporte del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:20
msgid "actualizó los filtros del dispositivo"
msgstr "actualizó los filtros del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:16
msgid "actualizó los límites de caudal"
msgstr "actualizó los límites de caudal"

#: src/features/audit/utils/getDisplayNameActionType.ts:24
msgid "actualizó los parámetros del radar"
msgstr "actualizó los parámetros del radar"

#: src/features/audit/utils/getDisplayNameActionType.ts:368
msgid "actualizó un nuevo servicio de facturación."
msgstr "actualizó un nuevo servicio de facturación."

#: src/features/audit/utils/getDisplayNameActionType.ts:356
msgid "actualizó un servicio del proyecto."
msgstr "actualizó un servicio del proyecto."

#: src/pages/systems/administrator.tsx:56
msgid "Administración de sistema"
msgstr "Administración de sistema"

#: src/pages/systems/administrator.tsx:15
msgid "Administración de Sistema"
msgstr "Administración de Sistema"

#: src/pages/users/index.tsx:9
msgid "Administración de usuarios"
msgstr "Administración de usuarios"

#: src/features/audit/utils/parseProperty.ts:88
msgid "administrador"
msgstr "administrador"

#: src/features/deviceConfiguration/data/sectionFields.ts:470
#: src/features/deviceConfiguration/data/sectionInputs.ts:492
#: src/utils/roles.ts:17
msgid "Administrador"
msgstr "Administrador"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:98
msgid "Administradores"
msgstr "Administradores"

#: src/features/integrations/utils/writeExecutionLogSeverityAttributes.ts:45
msgid "Advertencia"
msgstr "Advertencia"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:24
msgid "Agosto"
msgstr "Agosto"

#: src/features/billing/components/service/Administration.tsx:95
msgid "Agregar"
msgstr "Agregar"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:192
msgid "Agregar alias"
msgstr "Agregar alias"

#: src/features/devices2/components/DevicesHeader.tsx:157
msgid "Agregar configuración DGA"
msgstr "Agregar configuración DGA"

#: src/features/metricsViews/components/CreateViewModal.tsx:82
msgid "Agregar configuración para el dispositivo {0}"
msgstr "Agregar configuración para el dispositivo {0}"

#: src/features/devices2/components/DevicesHeader.tsx:163
msgid "Agregar Configuración SMA"
msgstr "Agregar Configuración SMA"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:290
msgid "Agregar curva"
msgstr "Agregar curva"

#: src/features/devices2/components/DevicesHeader.tsx:151
msgid "Agregar Dispositivo"
msgstr "Agregar Dispositivo"

#: src/features/deviceSupport/components/SupportTableBody.tsx:178
msgid "Agregar etiqueta"
msgstr "Agregar etiqueta"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:507
msgid "Agregar filtro"
msgstr "Agregar filtro"

#: src/features/access/components/usersTab/UsersTab.tsx:135
msgid "Agregar más dispositivos"
msgstr "Agregar más dispositivos"

#: src/features/access/components/devicesTab/DevicesTab.tsx:148
msgid "Agregar más usuarios"
msgstr "Agregar más usuarios"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:241
msgid "Agregar nueva relación"
msgstr "Agregar nueva relación"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:233
msgid "Agregar nuevo widget"
msgstr "Agregar nuevo widget"

#: src/features/userSaveModal/components/UserSaveModal.tsx:516
msgid "Agregar organización"
msgstr "Agregar organización"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:357
msgid "Agregar otro intervalo"
msgstr "Agregar otro intervalo"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:122
#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:253
msgid "Agregar relaciones dispositivo-usuario"
msgstr "Agregar relaciones dispositivo-usuario"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1152
msgid "Agregar serie"
msgstr "Agregar serie"

#: src/features/billing/components/administration/Toolbar.tsx:112
#: src/features/billing/components/projectService/Create.tsx:96
msgid "Agregar servicio a proyecto"
msgstr "Agregar servicio a proyecto"

#: src/features/users/components/UsersTableFilters.tsx:74
msgid "Agregar usuario"
msgstr "Agregar usuario"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:340
msgid "Agregar widget"
msgstr "Agregar widget"

#: src/features/metricsViews/components/MetricsView.tsx:264
msgid "Agregar Widget"
msgstr "Agregar Widget"

#: src/features/events/components/EventsTable.tsx:91
msgid "Agrupados por tipo"
msgstr "Agrupados por tipo"

#: src/features/billing/components/administration/Filters.tsx:47
msgid "Agrupar por"
msgstr "Agrupar por"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:96
msgid "Aguas abajo"
msgstr "Aguas abajo"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:76
msgid "Aguas arriba"
msgstr "Aguas arriba"

#: src/hooks/useFormatters.ts:127
#: src/hooks/useFormatters.ts:171
msgid "ahora"
msgstr "ahora"

#: src/features/deviceProfile/components/page/lifeHistory/FigureNode.tsx:160
msgid "Ahora"
msgstr "Ahora"

#: src/features/gates/components/AlarmSystem.tsx:62
msgid "Alarma activa"
msgstr "Alarma activa"

#: src/features/gates/components/AlarmSystem.tsx:49
msgid "Alarma activada"
msgstr "Alarma activada"

#: src/features/gates/components/AlarmSystem.tsx:51
msgid "Alarma desactivada por 30 minutos"
msgstr "Alarma desactivada por 30 minutos"

#: src/features/gates/components/AlarmSystem.tsx:68
msgid "Alarma inactiva"
msgstr "Alarma inactiva"

#: src/features/notifications/utils/entitiesHandlers.tsx:33
msgid "Alerta {0} - dispositivo {1}: {2}"
msgstr "Alerta {0} - dispositivo {1}: {2}"

#: src/features/notifications/utils/entitiesHandlers.tsx:31
msgid "Alerta dispositivo {0}"
msgstr "Alerta dispositivo {0}"

#: src/components/layout/DashboardSidebar.tsx:236
#: src/components/NotificationsPopover.tsx:140
#: src/features/alertsNotificationsHistory/components/Charts.tsx:123
#: src/features/controlCenter/utils/viewModes.ts:17
#: src/features/deviceProfile/components/page/Alerts.tsx:58
#: src/features/deviceProfile/components/page/Alerts.tsx:70
#: src/features/organizationAccess/data/sections.ts:5
msgid "Alertas"
msgstr "Alertas"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:94
msgid "Alertas actualizadas correctamente"
msgstr "Alertas actualizadas correctamente"

#: src/features/deviceProfile/components/modal/Status.tsx:125
#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:205
msgid "Alertas configuradas"
msgstr "Alertas configuradas"

#: src/features/deviceProfile/components/modal/Status.tsx:131
msgid "Alertas configuradas para este dispositivo"
msgstr "Alertas configuradas para este dispositivo"

#: src/features/echarts/utils/commonSeries.ts:56
#: src/features/echarts/utils/commonSeries.ts:56
msgid "Alertas de caudal"
msgstr "Alertas de caudal"

#: src/features/reports/utils/metricHelpers.ts:19
msgid "Alertas de Caudal"
msgstr "Alertas de Caudal"

#: src/features/reports/utils/metricHelpers.ts:17
msgid "Alertas de Distribución"
msgstr "Alertas de Distribución"

#: src/features/echarts/utils/commonSeries.ts:251
#: src/features/echarts/utils/commonSeries.ts:251
msgid "Alertas de nivel"
msgstr "Alertas de nivel"

#: src/features/reports/utils/metricHelpers.ts:21
msgid "Alertas de Nivel"
msgstr "Alertas de Nivel"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:127
#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:19
msgid "Alertas desactivadas correctamente"
msgstr "Alertas desactivadas correctamente"

#: src/features/deviceProfile/components/modal/Status.tsx:140
msgid "Alertas no configuradas"
msgstr "Alertas no configuradas"

#: src/components/gates/StopMovementConfirmation.tsx:71
#: src/components/optionsMenu/dialogs/movementHistory/QueryComponent.tsx:22
msgid "Algo salió mal"
msgstr "Algo salió mal"

#: src/features/deviceCommands/components/custom/SendStandardCommandToDevices.tsx:33
#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:29
msgid "Algo salió mal, por favor intente nuevamente."
msgstr "Algo salió mal, por favor intente nuevamente."

#: src/features/integrations/components/integrationsStatus/index.tsx:39
msgid "Algunas integraciones con problemas"
msgstr "Algunas integraciones con problemas"

#: src/features/integrations/components/integrationsStatus/index.tsx:41
msgid "Algunas integraciones fuera de línea"
msgstr "Algunas integraciones fuera de línea"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:170
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:191
#: src/features/deviceProfile/components/page/General.tsx:31
msgid "Alias"
msgstr "Alias"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:211
msgid "Alias por organización"
msgstr "Alias por organización"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:211
#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:234
msgid "Alias por organización de dispositivo"
msgstr "Alias por organización de dispositivo"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:492
msgid "Alisado"
msgstr "Alisado"

#: src/features/dga/utils/chartOptions.ts:71
msgid "Almacenado por la DGA."
msgstr "Almacenado por la DGA."

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:100
msgid "Alto"
msgstr "Alto"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:12
msgid "altura del pivote (en cm)"
msgstr "altura del pivote (en cm)"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:137
#: src/features/alertsConfiguration/components/AlertTable.tsx:220
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:120
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:129
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:64
msgid "Amaru Lite"
msgstr "Amaru Lite"

#: src/utils/getUnitTranslation.ts:60
#: src/utils/units.ts:92
msgid "ampere"
msgstr "ampere"

#: src/components/layout/DashboardSidebar.tsx:87
msgid "Análisis"
msgstr "Análisis"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:76
msgid "Análisis avanzado de dispositivo"
msgstr "Análisis avanzado de dispositivo"

#: src/pages/advanced-devices-analysis/index.tsx:10
msgid "Análisis avanzado de estaciones"
msgstr "Análisis avanzado de estaciones"

#: src/components/layout/DashboardSidebar.tsx:154
msgid "Análisis Avanzado de Estaciones"
msgstr "Análisis Avanzado de Estaciones"

#. Título de la página de análisis de estaciones
#: src/features/deviceSupport/components/SupportTableBody.tsx:282
#: src/features/organizationAccess/data/sections.ts:13
#: src/pages/devices-analysis/index.tsx:12
msgid "Análisis de estaciones"
msgstr "Análisis de estaciones"

#: src/components/layout/DashboardSidebar.tsx:145
msgid "Análisis de Estaciones"
msgstr "Análisis de Estaciones"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:145
#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:145
msgid "Análisis estaciones"
msgstr "Análisis estaciones"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:67
msgid "Anclaje en concreto/metal"
msgstr "Anclaje en concreto/metal"

#: src/features/userPreferences/components/RegionTab.tsx:273
msgid "Angosto"
msgstr "Angosto"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:428
#: src/features/metricsViews/components/SaveWidgetModal.tsx:819
#: src/features/metricsViews/components/widgets/TableWidget.tsx:107
#: src/features/reports/utils/metricHelpers.ts:9
#: src/utils/i18n/getMetricDisplayName.ts:9
msgid "Ángulo"
msgstr "Ángulo"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:9
msgid "ángulo medido por el inclinómetro (en grados)"
msgstr "ángulo medido por el inclinómetro (en grados)"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:7
msgid "ángulo respecto a la horizontal (en grados)"
msgstr "ángulo respecto a la horizontal (en grados)"

#: src/features/alertsNotificationsHistory/components/Charts.tsx:313
msgid "Año"
msgstr "Año"

#: src/features/audit/utils/parseProperty.ts:87
#: src/features/audit/utils/parseProperty.ts:165
msgid "antena"
msgstr "antena"

#: src/features/deviceConfiguration/data/sectionFields.ts:415
#: src/features/deviceConfiguration/data/sectionInputs.ts:422
msgid "Antena"
msgstr "Antena"

#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:69
msgid "Antiguo"
msgstr "Antiguo"

#: src/features/billing/utils/translations.ts:12
#: src/features/billing/utils/translations.ts:30
msgid "Anual"
msgstr "Anual"

#: src/features/notifications/utils/getNotificationObjectEntityType.ts:12
#: src/pages/announcements/[announcementId].tsx:12
msgid "Anuncio"
msgstr "Anuncio"

#: src/features/notifications/utils/entitiesHandlers.tsx:25
msgid "Anuncio {0} - {1}: {2}"
msgstr "Anuncio {0} - {1}: {2}"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:88
msgid "Anuncio actualizado correctamente"
msgstr "Anuncio actualizado correctamente"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:109
msgid "Anuncio creado correctamente"
msgstr "Anuncio creado correctamente"

#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:27
msgid "Anuncio eliminado correctamente"
msgstr "Anuncio eliminado correctamente"

#: src/components/layout/DashboardSidebar.tsx:212
#: src/features/announcements/components/AnnouncementsView.tsx:64
#: src/pages/announcements/index.tsx:10
msgid "Anuncios"
msgstr "Anuncios"

#: src/features/changeSupportStatus/data/status.ts:26
#: src/features/deviceSupport/data/status.ts:40
#: src/features/deviceSupport/data/status.ts:59
msgid "Apagado"
msgstr "Apagado"

#: src/features/deviceCommands/components/standard/StandardCommandsInformation.tsx:117
msgid "APAGADO"
msgstr "APAGADO"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:55
msgid "Apagado (POWER_SECONDS_OFF): 10 segundos."
msgstr "Apagado (POWER_SECONDS_OFF): 10 segundos."

#: src/features/audit/utils/parseProperty.ts:123
msgid "apellidos"
msgstr "apellidos"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:138
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:301
#: src/features/users/components/modals/SaveUserModal.tsx:124
#: src/features/userSaveModal/components/UserSaveModal.tsx:287
msgid "Apellidos"
msgstr "Apellidos"

#: src/components/layout/DashboardSidebar.tsx:309
#: src/features/api/components/APIMainText.tsx:11
#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:19
#: src/features/organizationAccess/data/sections.ts:17
msgid "API Capta"
msgstr "API Capta"

#: src/features/api/components/ApiKey.tsx:13
#: src/features/api/components/ApiKeysList.tsx:39
#: src/features/api/components/dialogs/GeneratedUserApiSummary.tsx:43
msgid "API Key"
msgstr "API Key"

#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:27
#: src/features/api/components/mainMenu/MenuApiKeys.tsx:18
msgid "API Keys"
msgstr "API Keys"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:210
#: src/features/alertsNotificationsHistory/components/Filters.tsx:366
msgid "Aplicar"
msgstr "Aplicar"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:176
msgid "Aplicar filtros"
msgstr "Aplicar filtros"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:383
msgid "Aplicar nuevos intervalos"
msgstr "Aplicar nuevos intervalos"

#: src/features/standardDesign/components/DateTimeRangePicker.tsx:456
msgid "Aplicar rango"
msgstr "Aplicar rango"

#: src/features/api/components/ApiUsersList.tsx:42
msgid "Aquí se van a encontrar las credenciales de API que su organización haya creado. Por ahora no se ha creado ninguna credencial."
msgstr "Aquí se van a encontrar las credenciales de API que su organización haya creado. Por ahora no se ha creado ninguna credencial."

#: src/features/api/components/CaptaApiUsersList.tsx:66
msgid "Aquí se van a mostrar las credenciales de API de cada uno de nuestros clientes. Sin embargo, aún no se han creado credenciales."
msgstr "Aquí se van a mostrar las credenciales de API de cada uno de nuestros clientes. Sin embargo, aún no se han creado credenciales."

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:166
msgid "Archivar"
msgstr "Archivar"

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:103
msgid "Archivar dispositivo"
msgstr "Archivar dispositivo"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:232
msgid "Archivo KML"
msgstr "Archivo KML"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:901
msgid "Área"
msgstr "Área"

#: src/features/announcements/components/AnnouncementView.tsx:59
msgid "Área de Software"
msgstr "Área de Software"

#: src/components/FileInput.tsx:106
msgid "Arrastra un archivo o haz click para seleccionar uno"
msgstr "Arrastra un archivo o haz click para seleccionar uno"

#: src/features/controlCenter/components/window/DialogDragAndDrop.tsx:130
msgid "Arrastre los dispositivos para ordenarlos"
msgstr "Arrastre los dispositivos para ordenarlos"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:931
msgid "Arriba"
msgstr "Arriba"

#: src/components/filters/OrderDirection.tsx:16
msgid "Ascendente"
msgstr "Ascendente"

#: src/features/billing/utils/translations.ts:37
msgid "Atrasado"
msgstr "Atrasado"

#: src/features/billing/utils/list.ts:42
msgid "Atrasado (+14d)"
msgstr "Atrasado (+14d)"

#: src/components/layout/DashboardSidebar.tsx:220
#: src/features/audit/components/AuditLogsView.tsx:12
#: src/pages/audit/index.tsx:10
msgid "Auditoría"
msgstr "Auditoría"

#: src/features/reports/components/ReportHistory.tsx:60
msgid "Aun no has creado ningún reporte."
msgstr "Aun no has creado ningún reporte."

#: src/features/reports/components/templateSection/ReportTemplateList.tsx:346
msgid "Aun no has creado ninguna plantilla."
msgstr "Aun no has creado ninguna plantilla."

#: src/features/api/components/ApiKey.tsx:19
msgid "Aún no tiene su API Key. Genere una nueva credencial para obtener su API Key"
msgstr "Aún no tiene su API Key. Genere una nueva credencial para obtener su API Key"

#: src/features/users/utils/filterOptions.ts:96
#: src/features/users/utils/filterOptions.ts:101
msgid "Autenticación en 2 pasos"
msgstr "Autenticación en 2 pasos"

#: src/features/users/components/tableCells/User2FACell.tsx:47
msgid "Autenticación en 2 pasos activada por organización"
msgstr "Autenticación en 2 pasos activada por organización"

#: src/features/users/components/UsersTable.tsx:83
#: src/pages/authentication/index.tsx:67
msgid "Autenticación en dos pasos"
msgstr "Autenticación en dos pasos"

#: src/features/userProfile/components/UserProfile.tsx:125
msgid "Autenticación en dos pasos <0>activada</0>"
msgstr "Autenticación en dos pasos <0>activada</0>"

#: src/features/userProfile/components/UserProfile.tsx:133
msgid "Autenticación en dos pasos <0>desactivada</0>"
msgstr "Autenticación en dos pasos <0>desactivada</0>"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:227
msgid "Autor"
msgstr "Autor"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:126
msgid "Avanzado"
msgstr "Avanzado"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:94
msgid "Bajo"
msgstr "Bajo"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:89
msgid "Bajo límite de caudal últimos 30d"
msgstr "Bajo límite de caudal últimos 30d"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:365
msgid "Balancear intervalos dentro del rango de observación"
msgstr "Balancear intervalos dentro del rango de observación"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:904
msgid "Barra"
msgstr "Barra"

#: src/features/controlCenter/utils/viewModes.ts:13
msgid "Básico"
msgstr "Básico"

#: src/features/controlCenter/components/panel/Minicharts.tsx:416
#: src/features/deviceConfiguration/data/sectionFields.ts:151
#: src/features/deviceConfiguration/data/sectionInputs.ts:153
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:77
#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:326
#: src/features/deviceSupport/data/column.ts:65
#: src/features/deviceSupport/data/column.ts:73
#: src/features/deviceSupport/data/column.ts:81
#: src/features/deviceSupport/data/column.ts:89
#: src/features/gates/components/list/GateListItemMinichart.tsx:92
#: src/features/metricsViews/components/SaveWidgetModal.tsx:430
#: src/features/metricsViews/components/SaveWidgetModal.tsx:834
#: src/features/metricsViews/components/widgets/TableWidget.tsx:111
#: src/utils/i18n/getMetricDisplayName.ts:16
msgid "Batería"
msgstr "Batería"

#: src/features/devices2/utils/getOrderByOptions.ts:24
msgid "Batería (Asc)"
msgstr "Batería (Asc)"

#: src/features/devices2/utils/getOrderByOptions.ts:28
msgid "Batería (Desc)"
msgstr "Batería (Desc)"

#: src/features/deviceProfile/components/page/Support.tsx:111
msgid "Batería actual {0}"
msgstr "Batería actual {0}"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:126
#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:63
#: src/features/irrigations/components/DeleteIrrigation.tsx:71
#: src/features/organizationDelete/components/DeleteOrganization.tsx:66
msgid "Borrar"
msgstr "Borrar"

#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:50
msgid "Borrar configuración del equipo {0}"
msgstr "Borrar configuración del equipo {0}"

#: src/features/access/components/devicesTab/DevicesList.tsx:62
#: src/features/access/components/devicesTab/DevicesList.tsx:113
#: src/features/access/components/organizationsTab/OrganizationsList.tsx:50
#: src/features/access/components/organizationsTab/OrganizationsList.tsx:93
#: src/features/access/components/usersTab/UsersList.tsx:60
#: src/features/access/components/usersTab/UsersList.tsx:121
#: src/features/controlCenter/components/window/Window.tsx:342
#: src/features/devicesAccessInputs/components/DevicesAccessForUserInput.tsx:74
#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:103
#: src/features/organizationsManagement/components/OrganizationsFilter.tsx:63
#: src/features/standardDesign/components/listView/StandardListViewHeader.tsx:115
msgid "Buscar"
msgstr "Buscar"

#: src/features/gates/components/Gates.tsx:59
msgid "Buscar Compuerta"
msgstr "Buscar Compuerta"

#: src/components/filters/SearchDevice.tsx:18
#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:69
#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:162
#: src/features/deviceConfiguration/components/DeviceConfiguration.tsx:194
#: src/features/devices2/components/DevicesHeader.tsx:88
#: src/features/deviceSupport/data/filter.ts:7
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:125
msgid "Buscar dispositivo"
msgstr "Buscar dispositivo"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:67
msgid "Buscar Dispositivo"
msgstr "Buscar Dispositivo"

#: src/features/organizationsManagement/components/OrganizationsFilter.tsx:49
msgid "Buscar organización"
msgstr "Buscar organización"

#: src/features/deviceConfiguration/components/DeviceConfiguration.tsx:205
msgid "Buscar proyecto"
msgstr "Buscar proyecto"

#: src/features/irrigations/components/Toolbar.tsx:57
msgid "Buscar red de canal"
msgstr "Buscar red de canal"

#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:110
#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:173
msgid "Buscar usuario"
msgstr "Buscar usuario"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:78
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:180
#: src/utils/i18n/getDgaTranslations.ts:42
msgid "Cada hora"
msgstr "Cada hora"

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:52
msgid "Cada par (\"Tipo de Mensaje\", \"Variable\") debe ser único"
msgstr "Cada par (\"Tipo de Mensaje\", \"Variable\") debe ser único"

#: src/pages/device-commands/calendar.tsx:9
msgid "Calendario"
msgstr "Calendario"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:36
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:62
msgid "Calibración <0><1>{0}</1></0> <2>(sensor: {1})</2>"
msgstr "Calibración <0><1>{0}</1></0> <2>(sensor: {1})</2>"

#: src/features/audit/utils/parseProperty.ts:6
msgid "calibración de nivel"
msgstr "calibración de nivel"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:29
msgid "Calibración dispositivos hijos"
msgstr "Calibración dispositivos hijos"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:79
msgid "Calibración nivel"
msgstr "Calibración nivel"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:99
msgid "Calibración posición"
msgstr "Calibración posición"

#: src/pages/water-quality.tsx:14
msgid "Calidad de agua"
msgstr "Calidad de agua"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:308
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:124
#: src/features/metricsViews/components/SaveWidgetModal.tsx:426
#: src/features/metricsViews/components/SaveWidgetModal.tsx:825
msgid "Calidad de señal"
msgstr "Calidad de señal"

#: src/features/reports/utils/metricHelpers.ts:27
msgid "Calidad de Señal"
msgstr "Calidad de Señal"

#: src/features/metricsViews/components/widgets/TableWidget.tsx:109
msgid "Calidad señal"
msgstr "Calidad señal"

#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:147
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:375
#: src/pages/change-password/index.tsx:15
#: src/pages/change-password/index.tsx:48
msgid "Cambiar contraseña"
msgstr "Cambiar contraseña"

#: src/features/api/components/CaptaApiUsersList.tsx:213
msgid "Cambiar Contraseña"
msgstr "Cambiar Contraseña"

#: src/components/modal/ConfirmationModal.tsx:45
msgid "Cambiar de pestaña"
msgstr "Cambiar de pestaña"

#: src/features/deviceConfigurationModal/components/statusTab/index.tsx:27
msgid "Cambiar estado"
msgstr "Cambiar estado"

#: src/features/deviceConfigurationModal/components/updateDeviceStatusModal/index.tsx:102
msgid "Cambiar estado de dispositivo"
msgstr "Cambiar estado de dispositivo"

#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:97
msgid "Cambio de Estado de Soporte"
msgstr "Cambio de Estado de Soporte"

#: src/features/deviceSupport/components/FieldsConfig.tsx:45
msgid "Campos actualizados correctamente"
msgstr "Campos actualizados correctamente"

#: src/features/controlCenter/components/window/StationListItem.tsx:458
msgid "Canal admisión"
msgstr "Canal admisión"

#: src/features/deviceProfile/components/page/General.tsx:65
msgid "Canal de irrigación"
msgstr "Canal de irrigación"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:61
msgid "Canal de irrigación actualizado correctamente"
msgstr "Canal de irrigación actualizado correctamente"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:48
msgid "Canal de irrigación creado correctamente"
msgstr "Canal de irrigación creado correctamente"

#: src/features/irrigations/components/DeleteIrrigation.tsx:18
msgid "Canal de irrigación eliminado correctamente"
msgstr "Canal de irrigación eliminado correctamente"

#: src/features/audit/utils/getDisplayNameEntity.ts:12
msgid "canal de SIRA"
msgstr "canal de SIRA"

#: src/features/controlCenter/components/window/StationListItem.tsx:467
msgid "Canal restitución"
msgstr "Canal restitución"

#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:154
msgid "CANAL SECO"
msgstr "CANAL SECO"

#: src/components/ActionButtons.tsx:34
#: src/components/gates/StopMovementConfirmation.tsx:91
#: src/components/modal/ConfirmationModal.tsx:40
#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:91
#: src/features/announcements/components/AnnouncementsSaveModal.tsx:322
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:192
#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:118
#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:112
#: src/features/api/components/dialogs/EditApiUserDialog.tsx:129
#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:115
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:123
#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:127
#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:115
#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:112
#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:81
#: src/features/controlCenter/components/window/DialogDragAndDrop.tsx:175
#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:358
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/DeleteCurveModal.tsx:36
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:431
#: src/features/deviceSupport/components/FieldsConfig.tsx:110
#: src/features/deviceSupport/components/FilterAdvance.tsx:193
#: src/features/deviceSupport/components/FilterConfig.tsx:105
#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:83
#: src/features/gateAdministration/components/DeleteRequestModal.tsx:32
#: src/features/gateAdministration/components/MoveGateValidate.tsx:24
#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:296
#: src/features/irrigations/components/DeleteIrrigation.tsx:63
#: src/features/metricsViews/components/CreateViewModal.tsx:113
#: src/features/metricsViews/components/EditViewModal.tsx:127
#: src/features/metricsViews/components/MetricsView.tsx:268
#: src/features/metricsViews/components/SaveWidgetModal.tsx:337
#: src/features/notifications/components/NotificationsDeleteModal.tsx:80
#: src/features/notifications/components/NotificationsSaveModal.tsx:244
#: src/features/organizationDelete/components/DeleteOrganization.tsx:63
#: src/features/reports/components/creationSection/CreateReportDialog.tsx:117
#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:204
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:156
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:199
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:311
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:389
#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:65
#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:125
#: src/features/userProfileUpdate/components/DisableUserModal.tsx:95
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:442
#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:116
#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:86
#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:74
#: src/features/userSaveModal/components/UserSaveModal.tsx:537
msgid "Cancelar"
msgstr "Cancelar"

#: src/features/billing/components/administration/SpiderChart.tsx:58
#: src/features/billing/components/administration/SpiderChart.tsx:110
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:61
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:81
#: src/features/events/components/HeaderTable.tsx:13
msgid "Cantidad"
msgstr "Cantidad"

#: src/features/audit/utils/parseProperty.ts:67
msgid "cantidad de baterías"
msgstr "cantidad de baterías"

#: src/features/deviceConfiguration/data/sectionFields.ts:163
#: src/features/deviceConfiguration/data/sectionInputs.ts:167
msgid "Cantidad de baterías"
msgstr "Cantidad de baterías"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:275
msgid "Cantidad de eventos"
msgstr "Cantidad de eventos"

#: src/features/audit/utils/parseProperty.ts:72
msgid "cantidad de paneles solares"
msgstr "cantidad de paneles solares"

#: src/features/deviceConfiguration/data/sectionFields.ts:211
#: src/features/deviceConfiguration/data/sectionInputs.ts:213
msgid "Cantidad de paneles solares"
msgstr "Cantidad de paneles solares"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:89
msgid "Capacidad"
msgstr "Capacidad"

#: src/features/audit/utils/parseProperty.ts:70
msgid "capacidad de batería"
msgstr "capacidad de batería"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:8
msgid "Capacidad de batería"
msgstr "Capacidad de batería"

#: src/features/audit/utils/parseProperty.ts:156
msgid "capacidad de la batería"
msgstr "capacidad de la batería"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:53
msgid "Capas acero blindado"
msgstr "Capas acero blindado"

#: src/utils/devices/formatSourceColor.ts:21
#: src/utils/formatSource.ts:12
msgid "Capta"
msgstr "Capta"

#: src/utils/roles.ts:16
msgid "Capta Hydro"
msgstr "Capta Hydro"

#: src/features/users/components/UsersTableFilters.tsx:88
msgid "Características"
msgstr "Características"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:35
#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:41
msgid "Carcasa acero"
msgstr "Carcasa acero"

#: src/features/deviceSupport/data/column.ts:71
msgid "Carga diaria (%/día)"
msgstr "Carga diaria (%/día)"

#: src/features/deviceProfile/components/page/Support.tsx:122
#: src/features/deviceSupport/data/fields.ts:14
msgid "Carga diaria de batería"
msgstr "Carga diaria de batería"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:311
msgid "Carga y Descarga de Pagos"
msgstr "Carga y Descarga de Pagos"

#: src/features/billing/components/modals/ServiceFileManager.tsx:257
msgid "Carga y descarga de servicios"
msgstr "Carga y descarga de servicios"

#: src/features/deviceCommands/components/custom/DevicesSelector.tsx:25
#: src/features/deviceCommands/components/custom/DevicesSelector.tsx:30
#: src/features/deviceCommands/components/DeviceSelector.tsx:43
msgid "Cargando dispositivos..."
msgstr "Cargando dispositivos..."

#: src/features/devices2/components/list/itemPanel/DeviceItemPicture.tsx:106
msgid "Cargando imagen..."
msgstr "Cargando imagen..."

#: src/components/LastDistributionData.tsx:91
#: src/components/LastDistributionData.tsx:112
#: src/components/LastDistributionData.tsx:133
#: src/components/LastDistributionData.tsx:166
#: src/components/NotificationsPopover.tsx:150
#: src/components/NotificationsPopover.tsx:220
#: src/components/TableLoading.tsx:21
#: src/features/standardDesign/components/autocomplete/StandardAutocomplete.tsx:100
msgid "Cargando..."
msgstr "Cargando..."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:321
#: src/features/billing/components/modals/ServiceFileManager.tsx:267
msgid "Cargar"
msgstr "Cargar"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:279
msgid "Categorías"
msgstr "Categorías"

#: src/features/deviceProfile/components/page/Alerts.tsx:37
msgid "caudal"
msgstr "caudal"

#: src/components/PicturePreview.tsx:148
#: src/components/PicturePreview.tsx:159
#: src/features/alertsConfiguration/components/AlertRow.tsx:42
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:108
#: src/features/controlCenter/components/panel/Minicharts.tsx:262
#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:258
#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:58
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/CurvesPreview.tsx:88
#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:36
#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:288
#: src/features/devicesAnalysis/components/panel/Chart.tsx:291
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAlertLevelsCheckboxList.tsx:33
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarDGACheckboxList.tsx:26
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:41
#: src/features/dga/components/modals/reports/TableModal.tsx:231
#: src/features/metricsViews/components/SaveWidgetModal.tsx:423
#: src/features/metricsViews/components/SaveWidgetModal.tsx:810
#: src/features/sma/components/TableModal.tsx:263
#: src/utils/i18n/getMetricDisplayName.ts:6
msgid "Caudal"
msgstr "Caudal"

#: src/features/reports/utils/metricHelpers.ts:7
msgid "Caudal (Q)"
msgstr "Caudal (Q)"

#: src/features/echarts/utils/commonSeries.ts:156
msgid "Caudal alto"
msgstr "Caudal alto"

#: src/features/echarts/utils/commonSeries.ts:155
msgid "Caudal bajo"
msgstr "Caudal bajo"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:291
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:25
msgid "Caudal bruto"
msgstr "Caudal bruto"

#: src/features/audit/utils/parseProperty.ts:136
msgid "caudal de desborde"
msgstr "caudal de desborde"

#: src/features/audit/utils/parseProperty.ts:108
msgid "caudal de río"
msgstr "caudal de río"

#: src/features/echarts/utils/commonSeries.ts:157
msgid "Caudal desborde"
msgstr "Caudal desborde"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:316
msgid "Caudal desborde (L/s)"
msgstr "Caudal desborde (L/s)"

#: src/features/reports/utils/metricHelpers.ts:13
msgid "Caudal DGA"
msgstr "Caudal DGA"

#: src/features/audit/utils/parseProperty.ts:135
msgid "caudal máximo"
msgstr "caudal máximo"

#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:129
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:85
msgid "Caudal máximo"
msgstr "Caudal máximo"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:309
msgid "Caudal máximo (L/s)"
msgstr "Caudal máximo (L/s)"

#: src/features/dga/components/modals/tabs/MaxFlowTab.tsx:25
msgid "Caudal máximo actualizado correctamente"
msgstr "Caudal máximo actualizado correctamente"

#: src/features/echarts/utils/commonSeries.ts:170
#: src/features/echarts/utils/commonSeries.ts:171
msgid "Caudal máximo de reparto"
msgstr "Caudal máximo de reparto"

#: src/features/dga/components/modals/tabs/MaxFlowTab.tsx:79
msgid "Caudal máximo en L/s"
msgstr "Caudal máximo en L/s"

#: src/features/audit/utils/parseProperty.ts:134
msgid "caudal mínimo"
msgstr "caudal mínimo"

#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:116
msgid "Caudal mínimo"
msgstr "Caudal mínimo"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:302
msgid "Caudal mínimo (L/s)"
msgstr "Caudal mínimo (L/s)"

#: src/utils/getUnitTranslation.ts:92
#: src/utils/units.ts:132
msgid "celsius"
msgstr "celsius"

#: src/features/devices2/components/DevicesHeader.tsx:141
msgid "Cementerio"
msgstr "Cementerio"

#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:192
msgid "Cementerio de dispositivos"
msgstr "Cementerio de dispositivos"

#: src/utils/getUnitTranslation.ts:28
#: src/utils/units.ts:52
msgid "centimeter"
msgstr "centimeter"

#: src/utils/getUnitTranslation.ts:48
#: src/utils/units.ts:77
msgid "centimeter per second"
msgstr "centimeter per second"

#: src/components/layout/DashboardSidebar.tsx:101
#: src/features/organizationAccess/data/sections.ts:21
#: src/pages/control-center/index.tsx:9
msgid "Centro de Control"
msgstr "Centro de Control"

#: src/features/audit/utils/parseProperty.ts:112
msgid "CENTRO LLANO activado"
msgstr "CENTRO LLANO activado"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:60
msgid "Cerradura caja fuerte"
msgstr "Cerradura caja fuerte"

#: src/components/modal/ModalActions.tsx:64
#: src/components/PicturePreview.tsx:78
#: src/components/telemetry/regis/SimplePicturePreview.tsx:31
#: src/features/announcements/components/AnnouncementsViewModal.tsx:99
#: src/features/authorization/components/Unauthorized.tsx:12
#: src/features/debtsAlert/components/DebtsAlertModal.tsx:114
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:101
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:96
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:134
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:545
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:171
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:220
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:377
#: src/features/organizationAccess/components/OrganizationAccess.tsx:119
#: src/features/reports/components/CreatedReportNotification.tsx:118
msgid "Cerrar"
msgstr "Cerrar"

#: src/components/modal/ConfirmationModal.tsx:51
msgid "Cerrar formulario"
msgstr "Cerrar formulario"

#: src/features/controlCenter/components/window/Window.tsx:283
msgid "Cerrar menú de opciones"
msgstr "Cerrar menú de opciones"

#: src/features/userMenu/components/UserMenu.tsx:111
msgid "Cerrar sesión"
msgstr "Cerrar sesión"

#: src/features/controlCenter/components/window/Window.tsx:308
msgid "Cerrar ventana"
msgstr "Cerrar ventana"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1023
msgid "Círculo"
msgstr "Círculo"

#: src/features/billing/components/table/DevicesTable.tsx:158
#: src/features/billing/components/table/OrganizationsTable.tsx:69
#: src/features/deviceSupport/data/column.ts:7
#: src/features/deviceSupport/data/fields.ts:6
msgid "Cliente"
msgstr "Cliente"

#: src/features/billing/components/table/ProjectsTable.tsx:79
msgid "Clientes"
msgstr "Clientes"

#: src/utils/devices/formatSourceColor.ts:22
#: src/utils/formatSource.ts:13
msgid "Clón"
msgstr "Clón"

#: src/utils/devices/formatSourceColor.ts:40
msgid "Clón de {sourceInfo}"
msgstr "Clón de {sourceInfo}"

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:115
msgid "Clonar"
msgstr "Clonar"

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:130
#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:153
#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:135
msgid "Clonar dispositivo"
msgstr "Clonar dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:211
msgid "Clonar Dispositivo"
msgstr "Clonar Dispositivo"

#: src/features/devices2/components/DevicesHeader.tsx:56
msgid "Clones"
msgstr "Clones"

#: src/features/audit/utils/getDisplayNameActionType.ts:116
msgid "clonó el dispositivo"
msgstr "clonó el dispositivo"

#: src/utils/getUnitTranslation.ts:27
#: src/utils/units.ts:51
msgid "cm"
msgstr "cm"

#: src/utils/getUnitTranslation.ts:47
#: src/utils/units.ts:76
msgid "cm/s"
msgstr "cm/s"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:63
#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:53
msgid "Código"
msgstr "Código"

#: src/features/audit/utils/parseProperty.ts:118
msgid "código de llamada"
msgstr "código de llamada"

#: src/features/audit/utils/parseProperty.ts:7
msgid "codigo de obra DGA"
msgstr "codigo de obra DGA"

#: src/features/countryCallingAutocomplete/CallingCodeAutocomplete.tsx:38
#: src/features/countryCallingAutocomplete/index.tsx:39
msgid "Código de país"
msgstr "Código de país"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:34
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:209
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:152
msgid "Código DGA"
msgstr "Código DGA"

#: src/features/login/components/Login.tsx:99
msgid "Código no válido!"
msgstr "Código no válido!"

#: src/features/deviceConfiguration/data/sectionFields.ts:296
msgid "Código Widgetlord"
msgstr "Código Widgetlord"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:240
msgid "Coeficiente A"
msgstr "Coeficiente A"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:253
msgid "Coeficiente B"
msgstr "Coeficiente B"

#: src/features/deviceProfile/components/page/Permissions.tsx:75
msgid "Colapsar"
msgstr "Colapsar"

#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:98
msgid "Coloque la nueva contraseña para el usuario {0}:"
msgstr "Coloque la nueva contraseña para el usuario {0}:"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:963
msgid "Color personalizado"
msgstr "Color personalizado"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:447
msgid "Columnas"
msgstr "Columnas"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:35
msgid "Comando"
msgstr "Comando"

#: src/features/deviceCommands/components/calendar/UpdateCommandKeyDialog.tsx:38
msgid "Comando actualizado correctamente."
msgstr "Comando actualizado correctamente."

#: src/features/gateAdministration/components/MoveGate.tsx:98
msgid "Comando de movimiento enviado correctamente"
msgstr "Comando de movimiento enviado correctamente"

#: src/features/deviceCommands/components/calendar/DeleteScheduleCommandKeyDialog.tsx:35
msgid "Comando eliminado correctamente."
msgstr "Comando eliminado correctamente."

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:27
msgid "Comando enviado correctamente"
msgstr "Comando enviado correctamente"

#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:58
#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:63
msgid "Comando Estándar"
msgstr "Comando Estándar"

#: src/components/NotificationsPopover.tsx:143
msgid "Comentarios"
msgstr "Comentarios"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:461
msgid "Compacto"
msgstr "Compacto"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:72
msgid "COMPLETADO"
msgstr "COMPLETADO"

#: src/features/deviceProfile/components/DeviceProfile.tsx:64
msgid "Componentes modulares"
msgstr "Componentes modulares"

#: src/features/dga/components/modals/reports/TableModal.tsx:270
#: src/features/sma/components/TableModal.tsx:279
msgid "Comprobante: {0}"
msgstr "Comprobante: {0}"

#: src/features/controlCenter/components/window/StationListItem.tsx:321
#: src/pages/gates/administration/[gateId].tsx:20
msgid "Compuerta"
msgstr "Compuerta"

#: src/features/gateAdministration/components/index.tsx:315
msgid "Compuerta en movimiento"
msgstr "Compuerta en movimiento"

#: src/components/layout/DashboardSidebar.tsx:136
#: src/features/organizationAccess/data/sections.ts:25
#: src/pages/gates/index.tsx:11
msgid "Compuertas"
msgstr "Compuertas"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:82
msgid "Con acceso"
msgstr "Con acceso"

#: src/features/devicesAccessInputs/components/DevicesAccessForUserInput.tsx:93
msgid "Con acceso a <0>{withAccessNumber}</0> dispositivos de <1>{totalNumber}</1>"
msgstr "Con acceso a <0>{withAccessNumber}</0> dispositivos de <1>{totalNumber}</1>"

#: src/features/users/utils/filterOptions.ts:98
msgid "Con autenticación en 2 pasos"
msgstr "Con autenticación en 2 pasos"

#: src/features/deviceSupport/data/dga.ts:11
msgid "Con DGA"
msgstr "Con DGA"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:360
msgid "Con esta configuración los próximos reportes se generarían en las siguientes fechas"
msgstr "Con esta configuración los próximos reportes se generarían en las siguientes fechas"

#: src/features/users/utils/filterOptions.ts:88
msgid "Con organizaciones compartidas"
msgstr "Con organizaciones compartidas"

#: src/features/integrations/components/devicesList/index.tsx:111
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:72
msgid "Con problemas"
msgstr "Con problemas"

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:87
msgid "Con zona horaria"
msgstr "Con zona horaria"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:317
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:192
#: src/features/metricsViews/components/SaveWidgetModal.tsx:439
#: src/features/metricsViews/components/SaveWidgetModal.tsx:870
#: src/features/metricsViews/components/widgets/TableWidget.tsx:120
#: src/features/reports/utils/metricHelpers.ts:10
msgid "Conductividad"
msgstr "Conductividad"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:317
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:84
msgid "Conductividad bruta"
msgstr "Conductividad bruta"

#: src/features/echarts/utils/commonSeries.ts:456
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:330
#: src/features/metricsViews/components/widgets/TableWidget.tsx:144
msgid "conectado"
msgstr "conectado"

#: src/features/gateAdministration/components/index.tsx:582
#: src/features/metricsViews/components/widgets/DataWidget.tsx:134
msgid "Conectado"
msgstr "Conectado"

#: src/features/deviceProfile/components/modal/Status.tsx:103
msgid "Conectado recientemente"
msgstr "Conectado recientemente"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:288
#: src/features/deviceConfiguration/data/sectionFields.ts:541
#: src/features/deviceConfiguration/data/sectionInputs.ts:531
#: src/features/deviceProfile/components/page/modularComponents/index.tsx:25
#: src/features/deviceSupport/data/column.ts:97
#: src/features/deviceSupport/data/column.ts:105
#: src/features/deviceSupport/data/column.ts:112
#: src/features/deviceSupport/data/column.ts:120
msgid "Conectividad"
msgstr "Conectividad"

#: src/features/deviceSupport/data/fields.ts:22
msgid "Conectividad 24 Horas"
msgstr "Conectividad 24 Horas"

#: src/features/audit/utils/parseProperty.ts:80
msgid "conexión a internet"
msgstr "conexión a internet"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:52
#: src/features/deviceConfiguration/data/sectionFields.ts:325
#: src/features/deviceConfiguration/data/sectionInputs.ts:337
msgid "Conexión a internet"
msgstr "Conexión a internet"

#: src/components/layout/DashboardSidebar.tsx:92
msgid "Configuración"
msgstr "Configuración"

#: src/features/alertsConfiguration/components/AlertTable.tsx:201
msgid "Configuración alerta"
msgstr "Configuración alerta"

#: src/features/deviceProfile/components/page/Alerts.tsx:88
msgid "Configuración alertas de {0}"
msgstr "Configuración alertas de {0}"

#: src/features/deviceAlertsModal/components/alertConfigurationTab/index.tsx:36
#: src/features/deviceAlertsModal/components/index.tsx:110
msgid "Configuración avanzada"
msgstr "Configuración avanzada"

#: src/features/deviceAlertsModal/components/index.tsx:104
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:147
msgid "Configuración básica"
msgstr "Configuración básica"

#: src/features/organizationAccess/components/OrganizationAccess.tsx:82
msgid "Configuración de acceso por organización"
msgstr "Configuración de acceso por organización"

#: src/features/deviceMenu/components/DeviceMenu.tsx:126
#: src/pages/alerts/index.tsx:13
#: src/pages/alerts/index.tsx:17
msgid "Configuración de alertas"
msgstr "Configuración de alertas"

#: src/features/deviceAlertsModal/components/basicConfigurationTab/useUpdateForm.ts:51
#: src/features/deviceConfigurationModal/components/gateTab/useUpdateForm.ts:38
msgid "Configuración de alertas actualizada correctamente"
msgstr "Configuración de alertas actualizada correctamente"

#: src/features/audit/utils/parseProperty.ts:128
msgid "configuración de Amaru"
msgstr "configuración de Amaru"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:197
msgid "Configuración de curva"
msgstr "Configuración de curva"

#: src/features/deviceMenu/components/DeviceMenu.tsx:104
msgid "Configuración de datos"
msgstr "Configuración de datos"

#: src/features/deviceMenu/components/DeviceMenu.tsx:98
msgid "Configuración de dispositivo"
msgstr "Configuración de dispositivo"

#: src/components/layout/DashboardSidebar.tsx:244
#: src/pages/device-configuration.tsx:10
msgid "Configuración de Equipos"
msgstr "Configuración de Equipos"

#: src/features/deviceCommands/components/standard/StandardButtons.tsx:121
msgid "Configuración de equipos estándar"
msgstr "Configuración de equipos estándar"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:198
msgid "Configuración de fecha"
msgstr "Configuración de fecha"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:358
msgid "Configuración de Filtros Activos"
msgstr "Configuración de Filtros Activos"

#: src/features/deviceMenu/components/DeviceMenu.tsx:115
#: src/features/deviceProfile/components/modal/Status.tsx:155
msgid "Configuración de hardware"
msgstr "Configuración de hardware"

#: src/features/deviceProfile/components/modal/Status.tsx:175
msgid "Configuración de hardware incompleta"
msgstr "Configuración de hardware incompleta"

#: src/features/audit/utils/parseProperty.ts:86
msgid "configuración de IP"
msgstr "configuración de IP"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:220
msgid "Configuración de notificación"
msgstr "Configuración de notificación"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:310
msgid "Configuración del Reporte"
msgstr "Configuración del Reporte"

#: src/features/deviceMenu/components/DeviceMenu.tsx:156
msgid "Configuración DGA"
msgstr "Configuración DGA"

#: src/features/dga/components/modals/tabs/GeneralTab.tsx:72
msgid "Configuración DGA actualizada correctamente"
msgstr "Configuración DGA actualizada correctamente"

#: src/features/deviceProfile/components/modal/Status.tsx:230
msgid "Configuración DGA con envíos activos"
msgstr "Configuración DGA con envíos activos"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:79
msgid "Configuración DGA creada correctamente"
msgstr "Configuración DGA creada correctamente"

#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:32
msgid "Configuración DGA eliminada correctamente"
msgstr "Configuración DGA eliminada correctamente"

#: src/features/deviceProfile/components/modal/Status.tsx:215
msgid "Configuración DGA incompleta"
msgstr "Configuración DGA incompleta"

#: src/features/deviceProfile/components/modal/Status.tsx:250
msgid "Configuración DGA sin envíos activos"
msgstr "Configuración DGA sin envíos activos"

#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:38
msgid "Configuración eliminada correctamente"
msgstr "Configuración eliminada correctamente"

#: src/features/deviceCommands/components/custom/SendStandardCommandToDevices.tsx:29
msgid "Configuración enviada con exito."
msgstr "Configuración enviada con exito."

#: src/features/deviceConfiguration/data/sectionFields.ts:458
#: src/features/deviceConfiguration/data/sectionInputs.ts:478
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:61
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:73
msgid "Configuración IP"
msgstr "Configuración IP"

#: src/features/deviceProfile/components/page/Alerts.tsx:111
msgid "Configurado {relativeTime}"
msgstr "Configurado {relativeTime}"

#: src/features/organizationsManagement/components/OrganizationsFilter.tsx:82
msgid "Configurar accesos de organización"
msgstr "Configurar accesos de organización"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:111
msgid "Configurar alarma"
msgstr "Configurar alarma"

#: src/features/deviceSupport/components/SupportMenu.tsx:63
msgid "Configurar Campos"
msgstr "Configurar Campos"

#: src/features/deviceSupport/components/SupportMenu.tsx:60
msgid "Configurar Filtros"
msgstr "Configurar Filtros"

#: src/features/userPreferences/components/MetricsTab.tsx:286
msgid "Configurar otro tipo de dispositivo"
msgstr "Configurar otro tipo de dispositivo"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:131
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:105
msgid "Configurar ticket"
msgstr "Configurar ticket"

#: src/features/metricsViews/components/MetricsViewErrorBoundary.tsx:23
msgid "Configurar vista"
msgstr "Configurar vista"

#: src/features/metricsViews/components/MetricsView.tsx:260
msgid "Configurar Vista"
msgstr "Configurar Vista"

#: src/features/gateAdministration/components/MoveGateValidate.tsx:9
msgid "Confirma que moverá la compuerta a"
msgstr "Confirma que moverá la compuerta a"

#: src/components/modal/ConfirmationModal.tsx:37
#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:114
msgid "Confirmación"
msgstr "Confirmación"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:107
#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:101
#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:104
#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:104
msgid "confirmar"
msgstr "confirmar"

#: src/components/modal/ConfirmationModal.tsx:39
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:146
#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:135
#: src/features/deviceCommands/components/calendar/DeleteScheduleCommandKeyDialog.tsx:71
#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:148
#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:91
#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:76
#: src/features/gateAdministration/components/MoveGateValidate.tsx:27
#: src/features/reports/components/creationSection/CreateReportDialog.tsx:120
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:209
#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:138
#: src/features/userProfileUpdate/components/DisableUserModal.tsx:104
msgid "Confirmar"
msgstr "Confirmar"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:142
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:112
#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:111
#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:134
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:413
#: src/features/userSaveModal/components/UserSaveModal.tsx:373
msgid "Confirmar contraseña"
msgstr "Confirmar contraseña"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:181
msgid "Confirmar Contraseña"
msgstr "Confirmar Contraseña"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:279
msgid "Constante (C)"
msgstr "Constante (C)"

#: src/features/deviceSupport/data/column.ts:118
msgid "Consumo actual mes"
msgstr "Consumo actual mes"

#: src/features/deviceProfile/components/page/Support.tsx:160
msgid "Consumo de datos"
msgstr "Consumo de datos"

#: src/features/deviceSupport/data/column.ts:110
msgid "Consumo último mes"
msgstr "Consumo último mes"

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:55
msgid "Contador"
msgstr "Contador"

#: src/features/deviceObservations/components/modals/CreateObservationModal.tsx:85
#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:77
msgid "Contenido"
msgstr "Contenido"

#: src/features/audit/utils/parseProperty.ts:40
msgid "conteo de eventos"
msgstr "conteo de eventos"

#: src/features/audit/utils/parseProperty.ts:124
msgid "contraseña"
msgstr "contraseña"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:141
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:173
#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:103
#: src/features/deviceProfile/components/page/DGAInfo.tsx:51
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:236
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:179
#: src/features/userProfileUpdate/components/DisableUserModal.tsx:73
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:388
#: src/features/userSaveModal/components/UserSaveModal.tsx:347
msgid "Contraseña"
msgstr "Contraseña"

#: src/features/audit/utils/parseProperty.ts:126
msgid "contraseña actualizada"
msgstr "contraseña actualizada"

#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:45
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:139
msgid "Contraseña actualizada correctamente"
msgstr "Contraseña actualizada correctamente"

#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:67
msgid "Contraseña cambiada correctamente. Por favor, inicia sesión nuevamente."
msgstr "Contraseña cambiada correctamente. Por favor, inicia sesión nuevamente."

#: src/features/audit/utils/parseProperty.ts:9
msgid "contraseña de obra DGA"
msgstr "contraseña de obra DGA"

#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:99
msgid "Contraseña requerida"
msgstr "Contraseña requerida"

#: src/components/layout/DashboardSidebar.tsx:82
msgid "Control"
msgstr "Control"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:140
msgid "Controles"
msgstr "Controles"

#: src/features/dga/components/modals/reports/TableModal.tsx:272
#: src/features/sma/components/TableModal.tsx:281
msgid "Copiar comprobante"
msgstr "Copiar comprobante"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:129
#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:91
msgid "Copiar link de activación"
msgstr "Copiar link de activación"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:8
msgid "correción ángulo (en grados)"
msgstr "correción ángulo (en grados)"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:125
#: src/features/alertsConfiguration/components/AlertTable.tsx:204
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:111
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:111
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:61
msgid "Correo"
msgstr "Correo"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:140
#: src/features/alertsNotificationsHistory/hooks/useTranslations.ts:16
#: src/features/recoveryPassword/components/RecoveryPassword.tsx:70
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:318
#: src/features/users/components/modals/SaveUserModal.tsx:125
#: src/features/userSaveModal/components/UserSaveModal.tsx:303
msgid "Correo electrónico"
msgstr "Correo electrónico"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:75
msgid "Correo electrónico inválido"
msgstr "Correo electrónico inválido"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:47
msgid "Corriente carga"
msgstr "Corriente carga"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:311
msgid "Corriente Carga"
msgstr "Corriente Carga"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:63
msgid "Corriente Panel"
msgstr "Corriente Panel"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:431
#: src/features/metricsViews/components/SaveWidgetModal.tsx:837
#: src/features/metricsViews/components/widgets/TableWidget.tsx:112
msgid "Corriente panel solar"
msgstr "Corriente panel solar"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:313
msgid "Corriente Panel Solar"
msgstr "Corriente Panel Solar"

#: src/features/userPreferences/components/RegionTab.tsx:272
msgid "Corto"
msgstr "Corto"

#: src/features/billing/components/projectService/Create.tsx:224
msgid "Costo total"
msgstr "Costo total"

#: src/features/audit/utils/parseProperty.ts:75
#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:64
#: src/features/deviceConfiguration/data/sectionFields.ts:280
#: src/features/deviceConfiguration/data/sectionInputs.ts:298
msgid "CPU"
msgstr "CPU"

#: src/features/audit/utils/parseProperty.ts:152
msgid "cpu central"
msgstr "cpu central"

#: src/features/deviceProfile/components/page/lifeHistory/index.tsx:80
msgid "creación"
msgstr "creación"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:81
msgid "Creado"
msgstr "Creado"

#: src/features/deviceProfile/components/modal/Info.tsx:144
msgid "Creado <0>{relativeCreated}</0>"
msgstr "Creado <0>{relativeCreated}</0>"

#: src/features/audit/utils/parseProperty.ts:149
msgid "creado el"
msgstr "creado el"

#: src/features/billing/components/payments/PaymentsTable.tsx:48
msgid "Creador"
msgstr "Creador"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:329
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:201
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:132
#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:157
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:507
#: src/features/notifications/components/NotificationsSaveModal.tsx:247
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:319
#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:118
#: src/features/userSaveModal/components/UserSaveModal.tsx:540
msgid "Crear"
msgstr "Crear"

#: src/features/audit/components/AuditLogDetailsRow.tsx:10
msgid "CREAR"
msgstr "CREAR"

#: src/features/audit/utils/getActionTypeOptions.ts:295
msgid "Crear accesos de dispositivo para un usuario"
msgstr "Crear accesos de dispositivo para un usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:301
msgid "Crear accesos de usuario para un dispositivo"
msgstr "Crear accesos de usuario para un dispositivo"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:90
msgid "Crear alertas avanzadas"
msgstr "Crear alertas avanzadas"

#: src/features/audit/utils/getActionTypeOptions.ts:202
msgid "Crear Alias de Dispositivo"
msgstr "Crear Alias de Dispositivo"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:210
msgid "Crear Anuncio"
msgstr "Crear Anuncio"

#: src/features/audit/utils/getActionTypeOptions.ts:10
msgid "Crear API para Organización"
msgstr "Crear API para Organización"

#: src/features/irrigations/components/Toolbar.tsx:72
msgid "Crear canal de irrigación"
msgstr "Crear canal de irrigación"

#: src/features/audit/utils/getActionTypeOptions.ts:19
#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:181
msgid "Crear Canal de Irrigación"
msgstr "Crear Canal de Irrigación"

#: src/features/audit/utils/getActionTypeOptions.ts:31
msgid "Crear Clase de Canal de SIRA"
msgstr "Crear Clase de Canal de SIRA"

#: src/features/gates/components/Gates.tsx:109
msgid "Crear Compuerta"
msgstr "Crear Compuerta"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:84
#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:225
#: src/features/deviceProfile/components/modal/Status.tsx:150
msgid "Crear configuración de alertas"
msgstr "Crear configuración de alertas"

#: src/features/audit/utils/getActionTypeOptions.ts:16
msgid "Crear Configuración de Calendario para Dispositivo"
msgstr "Crear Configuración de Calendario para Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:238
msgid "Crear Configuración de DGA"
msgstr "Crear Configuración de DGA"

#: src/features/deviceProfile/components/modal/Status.tsx:210
msgid "Crear configuración de hardware"
msgstr "Crear configuración de hardware"

#: src/features/audit/utils/getActionTypeOptions.ts:178
msgid "Crear Configuración de Hardware de Dispositivo"
msgstr "Crear Configuración de Hardware de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:43
msgid "Crear Configuración de Org de Dispositivo de SIRA Maipo"
msgstr "Crear Configuración de Org de Dispositivo de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:34
msgid "Crear Configuración de SIRA Maipo"
msgstr "Crear Configuración de SIRA Maipo"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:294
msgid "Crear configuración DGA"
msgstr "Crear configuración DGA"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:193
msgid "Crear curva de aforo"
msgstr "Crear curva de aforo"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:64
#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:71
msgid "Crear dispositivo"
msgstr "Crear dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:13
msgid "Crear Dispositivo"
msgstr "Crear Dispositivo"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:34
msgid "Crear dispositivo aguas abajo"
msgstr "Crear dispositivo aguas abajo"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:33
msgid "Crear dispositivo aguas arriba"
msgstr "Crear dispositivo aguas arriba"

#: src/features/audit/utils/getActionTypeOptions.ts:37
msgid "Crear Dispositivo de Configuración de SIRA Maipo"
msgstr "Crear Dispositivo de Configuración de SIRA Maipo"

#: src/features/notifications/components/NotificationsSaveModal.tsx:154
msgid "Crear notificación"
msgstr "Crear notificación"

#: src/features/notifications/components/Notifications.tsx:74
msgid "Crear Notificación"
msgstr "Crear Notificación"

#: src/features/audit/utils/getActionTypeOptions.ts:22
msgid "Crear Nueva Distribución de SIRA"
msgstr "Crear Nueva Distribución de SIRA"

#: src/features/audit/utils/getActionTypeOptions.ts:25
msgid "Crear Nueva Distribución de SIRA Maipo"
msgstr "Crear Nueva Distribución de SIRA Maipo"

#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:97
msgid "Crear Nuevo Comando Programado"
msgstr "Crear Nuevo Comando Programado"

#: src/features/deviceObservations/components/CreateObservationButton.tsx:30
#: src/features/deviceObservations/components/modals/CreateObservationModal.tsx:77
msgid "Crear observación"
msgstr "Crear observación"

#: src/features/audit/utils/getActionTypeOptions.ts:40
msgid "Crear Org de Configuración de SIRA Maipo"
msgstr "Crear Org de Configuración de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:28
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:170
#: src/features/organizationsManagement/components/OrganizationsFilter.tsx:94
msgid "Crear Organización"
msgstr "Crear Organización"

#: src/features/billing/components/payments/PaymentSummary.tsx:169
msgid "Crear pago"
msgstr "Crear pago"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:149
msgid "Crear Pagos Desde Archivo .csv"
msgstr "Crear Pagos Desde Archivo .csv"

#: src/features/reports/components/creationSection/CreateReportDataExtraction.tsx:40
#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:180
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:136
msgid "Crear Plantilla"
msgstr "Crear Plantilla"

#: src/features/audit/utils/getActionTypeOptions.ts:226
msgid "Crear Programación de Reporte"
msgstr "Crear Programación de Reporte"

#: src/features/audit/utils/getActionTypeOptions.ts:217
#: src/features/reports/components/creationSection/CreateReportDataExtraction.tsx:27
msgid "Crear Reporte"
msgstr "Crear Reporte"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:184
msgid "Crear reporte desde plantilla"
msgstr "Crear reporte desde plantilla"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:341
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:247
msgid "Crear reporte en formato(s):"
msgstr "Crear reporte en formato(s):"

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:104
msgid "Crear Reporte Instantáneo"
msgstr "Crear Reporte Instantáneo"

#: src/features/audit/utils/getActionTypeOptions.ts:283
msgid "Crear servicio de facturación"
msgstr "Crear servicio de facturación"

#: src/features/audit/utils/getActionTypeOptions.ts:274
msgid "Crear servicio para proyecto de facturación"
msgstr "Crear servicio para proyecto de facturación"

#: src/features/billing/components/modals/ServiceFileManager.tsx:126
msgid "Crear Servicios Desde Archivo .csv"
msgstr "Crear Servicios Desde Archivo .csv"

#: src/features/audit/utils/getActionTypeOptions.ts:265
msgid "Crear un pago"
msgstr "Crear un pago"

#: src/features/users/components/modals/SaveUserModal.tsx:167
msgid "Crear usuario"
msgstr "Crear usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:49
#: src/features/userSaveModal/components/UserSaveModal.tsx:258
msgid "Crear Usuario"
msgstr "Crear Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:46
msgid "Crear Usuario de SIRA a Notificar"
msgstr "Crear Usuario de SIRA a Notificar"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:110
#: src/features/users/components/UsersTableFilters.tsx:69
msgid "Crear usuario temporal"
msgstr "Crear usuario temporal"

#: src/features/metricsViews/components/CreateViewModal.tsx:117
msgid "Crear Visualización"
msgstr "Crear Visualización"

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:39
msgid "Credencial deshabilitada exitosamente."
msgstr "Credencial deshabilitada exitosamente."

#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:41
msgid "Credencial eliminada correctamente"
msgstr "Credencial eliminada correctamente"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:41
msgid "Credencial eliminada correctamente."
msgstr "Credencial eliminada correctamente."

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:41
msgid "Credencial habilitada exitosamente"
msgstr "Credencial habilitada exitosamente"

#: src/features/api/components/ApiUsers.tsx:13
#: src/features/api/components/CaptaApiUsersList.tsx:63
#: src/features/api/components/CaptaApiUsersList.tsx:76
msgid "Credenciales API"
msgstr "Credenciales API"

#: src/features/login/components/Login.tsx:63
msgid "Credenciales inválidas. Verifique el email y la contraseña."
msgstr "Credenciales inválidas. Verifique el email y la contraseña."

#: src/features/audit/utils/getDisplayNameActionType.ts:169
msgid "creó accesos de dispositivos al usuario"
msgstr "creó accesos de dispositivos al usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:120
msgid "creó accesos de usuario para el dispositivo"
msgstr "creó accesos de usuario para el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:104
msgid "creó el alias del dispositivo"
msgstr "creó el alias del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:323
msgid "creó el cronograma del reporte"
msgstr "creó el cronograma del reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:48
msgid "creó el dispositivo"
msgstr "creó el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:311
msgid "creó el reporte"
msgstr "creó el reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:129
msgid "creó el usuario"
msgstr "creó el usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:212
msgid "creó el usuario de SIRA para notificar"
msgstr "creó el usuario de SIRA para notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:245
msgid "creó la API para la organización"
msgstr "creó la API para la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:200
msgid "creó la clase de canal de SIRA"
msgstr "creó la clase de canal de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:385
msgid "creó la configuración de DGA"
msgstr "creó la configuración de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:273
msgid "creó la configuración de la organización para SIRA Maipo"
msgstr "creó la configuración de la organización para SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:261
msgid "creó la configuración de SIRA Maipo"
msgstr "creó la configuración de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:80
msgid "creó la configuración del calendario del dispositivo"
msgstr "creó la configuración del calendario del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:265
msgid "creó la configuración del dispositivo para SIRA Maipo"
msgstr "creó la configuración del dispositivo para SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:269
msgid "creó la configuración del dispositivo u organización para SIRA Maipo"
msgstr "creó la configuración del dispositivo u organización para SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:84
msgid "creó la configuración del hardware del dispositivo"
msgstr "creó la configuración del hardware del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:178
msgid "creó la irrigación"
msgstr "creó la irrigación"

#: src/features/audit/utils/getDisplayNameActionType.ts:225
msgid "creó la organización"
msgstr "creó la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:340
msgid "creó un nuevo pago para un proyecto."
msgstr "creó un nuevo pago para un proyecto."

#: src/features/audit/utils/getDisplayNameActionType.ts:364
msgid "creó un nuevo servicio de facturación."
msgstr "creó un nuevo servicio de facturación."

#: src/features/audit/utils/getDisplayNameActionType.ts:352
msgid "creó un nuevo servicio para el proyecto."
msgstr "creó un nuevo servicio para el proyecto."

#: src/features/audit/utils/getDisplayNameActionType.ts:195
msgid "creó una nueva distribución de SIRA"
msgstr "creó una nueva distribución de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:277
msgid "creó una nueva distribución para SIRA Maipo"
msgstr "creó una nueva distribución para SIRA Maipo"

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:81
msgid "Cristóbal Matamala"
msgstr "Cristóbal Matamala"

#: src/features/changeSupportStatus/data/status.ts:16
#: src/features/deviceSupport/data/status.ts:36
#: src/features/deviceSupport/data/status.ts:57
#: src/features/integrations/utils/writeExecutionLogSeverityAttributes.ts:29
msgid "Crítico"
msgstr "Crítico"

#: src/utils/units.ts:177
msgid "cubic hectometer"
msgstr "cubic hectometer"

#: src/utils/getUnitTranslation.ts:40
#: src/utils/units.ts:67
msgid "cubic meter"
msgstr "cubic meter"

#: src/utils/getUnitTranslation.ts:20
#: src/utils/units.ts:42
msgid "cubic meter per hour"
msgstr "cubic meter per hour"

#: src/utils/getUnitTranslation.ts:16
#: src/utils/units.ts:37
msgid "cubic meter per second"
msgstr "cubic meter per second"

#: src/utils/units.ts:167
msgid "cubic meter per second per action"
msgstr "cubic meter per second per action"

#: src/features/audit/utils/parseProperty.ts:104
msgid "cuenca"
msgstr "cuenca"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:215
#: src/features/irrigations/components/Table.tsx:72
msgid "Cuenca del río"
msgstr "Cuenca del río"

#: src/features/sma/components/forFutureUse/TableSmaUnit.tsx:48
msgid "Cuenta SMA"
msgstr "Cuenta SMA"

#: src/features/deviceConfiguration/data/sectionFields.ts:25
msgid "Cuenta usuario"
msgstr "Cuenta usuario"

#: src/features/deviceDataConfigurationModal/utils/ratingFactory.ts:32
msgid "Curva de aforo inválida"
msgstr "Curva de aforo inválida"

#: src/features/audit/utils/parseProperty.ts:138
msgid "curvas de aforo"
msgstr "curvas de aforo"

#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:85
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:201
msgid "Curvas de Aforo"
msgstr "Curvas de Aforo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:213
msgid "Curvas de aforo creadas"
msgstr "Curvas de aforo creadas"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:278
#: src/features/deviceConfiguration/data/sectionFields.ts:319
#: src/features/deviceConfiguration/data/sectionInputs.ts:331
msgid "Data logger"
msgstr "Data logger"

#: src/features/deviceProfile/components/page/modularComponents/index.tsx:45
msgid "Datalogger"
msgstr "Datalogger"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:219
msgid "Dato"
msgstr "Dato"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:194
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:67
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:53
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:105
msgid "Dato actualizado correctamente"
msgstr "Dato actualizado correctamente"

#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:22
#: src/features/reports/utils/meanWindowOptions.ts:7
msgid "Dato bruto"
msgstr "Dato bruto"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:395
msgid "Datos a Extraer de los Dispositivos"
msgstr "Datos a Extraer de los Dispositivos"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:43
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:62
msgid "Datos actualizados correctamente"
msgstr "Datos actualizados correctamente"

#: src/features/deviceAlertsModal/components/rawDataModal/index.tsx:56
msgid "Datos de alertas leídas desde el pipeline"
msgstr "Datos de alertas leídas desde el pipeline"

#: src/features/billing/components/administration/Stats.tsx:49
msgid "de deuda"
msgstr "de deuda"

#: src/features/billing/utils/validationSchema.ts:12
msgid "Debe agregar al menos un servicio."
msgstr "Debe agregar al menos un servicio."

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:156
msgid "Debe seleccionar un archivo con la extensión .kml"
msgstr "Debe seleccionar un archivo con la extensión .kml"

#: src/features/notifications/components/NotificationsSaveModal.tsx:88
msgid "Debe seleccionar una entidad"
msgstr "Debe seleccionar una entidad"

#: src/features/organizationAccess/components/OrganizationAccess.tsx:66
msgid "Debe seleccionar una organización"
msgstr "Debe seleccionar una organización"

#: src/features/userPreferences/utils/metricsValidationSchema.ts:20
#: src/features/userPreferences/utils/metricsValidationSchema.ts:30
msgid "Debe ser un número"
msgstr "Debe ser un número"

#: src/features/billing/utils/validationSchema.ts:6
msgid "Debes agregar al menos 1 servicio."
msgstr "Debes agregar al menos 1 servicio."

#: src/features/dga/utils/validationSchemas.ts:31
msgid "Debes ingresar un número"
msgstr "Debes ingresar un número"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:114
#: src/features/deviceCommands/components/standard/StandardButtons.tsx:189
msgid "Debug/Aforo"
msgstr "Debug/Aforo"

#: src/features/userPreferences/components/MetricsTab.tsx:187
#: src/features/userPreferences/components/MetricsTab.tsx:266
msgid "Decimales de precisión"
msgstr "Decimales de precisión"

#: src/utils/getUnitTranslation.ts:52
#: src/utils/units.ts:82
msgid "degree"
msgstr "degree"

#: src/components/layout/DashboardNavbar.tsx:113
msgid "Dejar de simular"
msgstr "Dejar de simular"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:326
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:348
msgid "del mes a las"
msgstr "del mes a las"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:486
msgid "Desactivada"
msgstr "Desactivada"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:68
msgid "Desactivados"
msgstr "Desactivados"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:367
#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:47
msgid "Desactivar"
msgstr "Desactivar"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:333
#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:40
#: src/features/deviceAlertsModal/components/index.tsx:154
msgid "Desactivar alertas"
msgstr "Desactivar alertas"

#: src/features/audit/utils/getActionTypeOptions.ts:97
msgid "Desactivar Alertas de Dispositivo"
msgstr "Desactivar Alertas de Dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:60
msgid "desactivó las alertas del dispositivo"
msgstr "desactivó las alertas del dispositivo"

#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:162
msgid "Desarchivar"
msgstr "Desarchivar"

#: src/features/alertsConfiguration/components/AlertRow.tsx:72
#: src/features/alertsConfiguration/components/AlertRow.tsx:103
#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:90
msgid "Desborde"
msgstr "Desborde"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:325
msgid "Descarga compuertas"
msgstr "Descarga compuertas"

#: src/pages/report-download/index.tsx:15
msgid "Descarga de Reporte"
msgstr "Descarga de Reporte"

#: src/features/reportDownload/components/ReportDownload.tsx:46
msgid "Descargando Reporte"
msgstr "Descargando Reporte"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:329
#: src/features/billing/components/modals/ServiceFileManager.tsx:275
#: src/features/billing/components/payments/PaymentRow.tsx:209
#: src/features/dga/components/modals/reports/TableModal.tsx:293
#: src/features/sma/components/TableModal.tsx:304
msgid "Descargar"
msgstr "Descargar"

#: src/features/irrigations/components/Table.tsx:42
msgid "Descargar .KML"
msgstr "Descargar .KML"

#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:38
#: src/features/api/components/mainMenu/MainMenuApiCustomer.tsx:18
msgid "Descargar documentación API"
msgstr "Descargar documentación API"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:281
msgid "Descargar el archivo .KML existente"
msgstr "Descargar el archivo .KML existente"

#: src/features/reports/components/CreatedReportNotification.tsx:100
msgid "Descargar Excel"
msgstr "Descargar Excel"

#: src/features/billing/components/payments/PaymentRow.tsx:199
msgid "Descargar factura"
msgstr "Descargar factura"

#: src/features/reports/components/CreatedReportNotification.tsx:112
msgid "Descargar PDF"
msgstr "Descargar PDF"

#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:76
msgid "Descargar tabla de reportes DGA"
msgstr "Descargar tabla de reportes DGA"

#: src/features/sma/components/SendReportsByEmailModal.tsx:81
msgid "Descargar tabla de reportes SMA"
msgstr "Descargar tabla de reportes SMA"

#: src/features/reports/components/ReportHistory.tsx:88
msgid "Descargas"
msgstr "Descargas"

#: src/components/filters/OrderDirection.tsx:20
msgid "Descendente"
msgstr "Descendente"

#: src/features/echarts/utils/commonSeries.ts:456
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:330
#: src/features/metricsViews/components/widgets/TableWidget.tsx:144
msgid "desconectado"
msgstr "desconectado"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:113
#: src/features/deviceProfile/components/modal/Status.tsx:114
#: src/features/gateAdministration/components/index.tsx:601
#: src/features/metricsViews/components/widgets/DataWidget.tsx:135
msgid "Desconectado"
msgstr "Desconectado"

#: src/features/deviceProfile/components/page/lifeHistory/index.tsx:74
msgid "desconocido"
msgstr "desconocido"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:268
#: src/features/notifications/utils/getNotificationObjectEntityType.ts:13
msgid "Desconocido"
msgstr "Desconocido"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:253
#: src/features/notifications/components/Notifications.tsx:88
#: src/features/notifications/components/NotificationsSaveModal.tsx:233
#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:197
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:149
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:122
msgid "Descripción"
msgstr "Descripción"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:216
msgid "Descuento aplicado al servicio en porcentaje."
msgstr "Descuento aplicado al servicio en porcentaje."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:221
msgid "Descuento aplicado al servicio en valor nominal."
msgstr "Descuento aplicado al servicio en valor nominal."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:181
msgid "Descuento aplicado globalmente a la factura en porcentaje."
msgstr "Descuento aplicado globalmente a la factura en porcentaje."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:186
msgid "Descuento aplicado globalmente a la factura en valor nominal."
msgstr "Descuento aplicado globalmente a la factura en valor nominal."

#: src/features/billing/components/payments/PaymentForm.tsx:124
#: src/features/billing/components/payments/PaymentsTable.tsx:45
msgid "Descuento global nominal"
msgstr "Descuento global nominal"

#: src/features/billing/components/payments/PaymentForm.tsx:111
#: src/features/billing/components/payments/PaymentsTable.tsx:44
msgid "Descuento global porcentual"
msgstr "Descuento global porcentual"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:130
#: src/features/billing/components/payments/PaymentRow.tsx:100
msgid "Descuento nominal"
msgstr "Descuento nominal"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:77
msgid "Descuento Nominal"
msgstr "Descuento Nominal"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:115
#: src/features/billing/components/payments/PaymentRow.tsx:99
msgid "Descuento porcentual"
msgstr "Descuento porcentual"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:76
msgid "Descuento Porcentual"
msgstr "Descuento Porcentual"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:227
#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:200
#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:88
#: src/features/sma/components/SendReportsByEmailModal.tsx:91
msgid "Desde"
msgstr "Desde"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:307
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:156
msgid "Deseleccionar todos"
msgstr "Deseleccionar todos"

#: src/features/api/components/CaptaApiUsersList.tsx:174
#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:120
msgid "Deshabilitar"
msgstr "Deshabilitar"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:345
msgid "Deshabilitar alertas"
msgstr "Deshabilitar alertas"

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:76
msgid "Deshabilitar credencial API"
msgstr "Deshabilitar credencial API"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:438
msgid "Deshabilitar cuenta"
msgstr "Deshabilitar cuenta"

#: src/features/audit/utils/getActionTypeOptions.ts:253
msgid "Deshabilitar Envío de DGA"
msgstr "Deshabilitar Envío de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:406
msgid "deshabilitó el envío de DGA"
msgstr "deshabilitó el envío de DGA"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:196
msgid "Deshacer"
msgstr "Deshacer"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:116
msgid "Despues de 4 horas el equipo cambiara a los valores a modo"
msgstr "Despues de 4 horas el equipo cambiara a los valores a modo"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:293
msgid "Detalle datos informe"
msgstr "Detalle datos informe"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:510
msgid "Detalles"
msgstr "Detalles"

#: src/components/gates/StopMovementConfirmation.tsx:24
msgid "Detener el movimiento de la compuerta {0}"
msgstr "Detener el movimiento de la compuerta {0}"

#: src/components/gates/StopMovementConfirmation.tsx:101
#: src/features/gateAdministration/components/index.tsx:389
msgid "Detener movimiento"
msgstr "Detener movimiento"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:93
msgid "Deuda"
msgstr "Deuda"

#: src/features/events/components/HeaderTable.tsx:22
msgid "Device Id"
msgstr "Device Id"

#: src/features/deviceSupport/components/DevicesFilters.tsx:184
#: src/features/deviceSupport/components/FilterAdvance.tsx:161
#: src/features/deviceSupport/data/column.ts:147
#: src/features/deviceSupport/data/fields.ts:24
#: src/features/deviceSupport/data/filter.ts:14
msgid "DGA"
msgstr "DGA"

#: src/features/audit/utils/parseProperty.ts:37
msgid "DGA activado"
msgstr "DGA activado"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:126
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:228
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:321
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:343
msgid "Día de la semana"
msgstr "Día de la semana"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:142
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:244
msgid "Día del mes"
msgstr "Día del mes"

#: src/features/deviceProfile/components/page/Support.tsx:197
msgid "Diagnóstico"
msgstr "Diagnóstico"

#: src/pages/support.tsx:9
msgid "Diagnóstico de dispositivos"
msgstr "Diagnóstico de dispositivos"

#: src/components/layout/DashboardSidebar.tsx:126
msgid "Diagnóstico de Dispositivos"
msgstr "Diagnóstico de Dispositivos"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1035
msgid "Diamante"
msgstr "Diamante"

#: src/utils/i18n/getDgaTranslations.ts:36
msgid "Diaria ({hourString})"
msgstr "Diaria ({hourString})"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:97
msgid "Diariamente"
msgstr "Diariamente"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:75
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:177
msgid "Diario"
msgstr "Diario"

#: src/features/reports/utils/schedules.ts:43
msgid "Diario a las {hoursMinutesStr} horas."
msgstr "Diario a las {hoursMinutesStr} horas."

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:242
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:268
#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:78
msgid "días"
msgstr "días"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:299
msgid "Días de la semana"
msgstr "Días de la semana"

#: src/features/reports/utils/schedules.ts:45
msgid "Días de semana (lunes a viernes) a las {hoursMinutesStr} horas."
msgstr "Días de semana (lunes a viernes) a las {hoursMinutesStr} horas."

#: src/features/deviceSupport/data/column.ts:79
msgid "Dias restantes"
msgstr "Dias restantes"

#: src/features/deviceSupport/data/fields.ts:15
msgid "Dias restantes de batería"
msgstr "Dias restantes de batería"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:28
msgid "Diciembre"
msgstr "Diciembre"

#: src/features/audit/utils/parseProperty.ts:115
msgid "dirección"
msgstr "dirección"

#: src/components/filters/OrderDirection.tsx:26
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:205
#: src/features/organizationsManagement/components/OrganizationsTable.tsx:72
msgid "Dirección"
msgstr "Dirección"

#: src/features/audit/utils/parseProperty.ts:146
msgid "dirección ip"
msgstr "dirección ip"

#: src/features/audit/utils/parseProperty.ts:144
msgid "dirección mac"
msgstr "dirección mac"

#: src/components/layout/DashboardSidebar.tsx:252
#: src/pages/standard-design/index.tsx:10
msgid "Diseño Amaru"
msgstr "Diseño Amaru"

#: src/features/audit/utils/getDisplayNameEntity.ts:9
msgid "dispositivo"
msgstr "dispositivo"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:163
#: src/features/billing/components/payments/PaymentRow.tsx:96
#: src/features/billing/components/projectService/Delete.tsx:101
#: src/features/billing/utils/list.ts:17
#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:100
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:208
#: src/features/deviceConfiguration/data/tableColumns.ts:5
#: src/features/deviceSupport/data/column.ts:39
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:141
#: src/features/metricsViews/components/SaveWidgetModal.tsx:365
#: src/features/metricsViews/components/SaveWidgetModal.tsx:373
#: src/features/metricsViews/components/SaveWidgetModal.tsx:511
#: src/features/metricsViews/components/SaveWidgetModal.tsx:519
#: src/features/metricsViews/components/SaveWidgetModal.tsx:783
msgid "Dispositivo"
msgstr "Dispositivo"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:59
#: src/features/deviceConfigurationModal/hooks/useUpdateDeviceStatusForm.ts:33
msgid "Dispositivo actualizado correctamente"
msgstr "Dispositivo actualizado correctamente"

#: src/features/audit/components/AuditLogsSidebar.tsx:140
msgid "Dispositivo afectado"
msgstr "Dispositivo afectado"

#: src/features/sma/components/forFutureUse/DialogSmaUnitSummary.tsx:123
msgid "Dispositivo Amaru"
msgstr "Dispositivo Amaru"

#: src/features/deviceSupport/components/SupportTableBody.tsx:257
msgid "Dispositivo con reporte DGA"
msgstr "Dispositivo con reporte DGA"

#: src/features/deviceConfigurationModal/components/publicTab/index.tsx:25
msgid "Dispositivo público"
msgstr "Dispositivo público"

#: src/features/deviceConfigurationModal/components/publicTab/useUpdateForm.ts:35
msgid "Dispositivo público actualizado correctamente"
msgstr "Dispositivo público actualizado correctamente"

#: src/features/deviceSupport/components/SupportTableBody.tsx:259
msgid "Dispositivo sin reporte DGA"
msgstr "Dispositivo sin reporte DGA"

#: src/components/layout/DashboardSidebar.tsx:109
#: src/features/access/components/AccessView.tsx:22
#: src/features/deviceCommands/components/custom/DevicesSelector.tsx:30
#: src/features/integrations/components/devicesList/index.tsx:101
#: src/features/metricsViews/components/MetricsViewList.tsx:35
#: src/features/organizationAccess/data/sections.ts:29
#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:414
#: src/features/reports/components/DeviceMetricsSummary.tsx:18
#: src/features/reports/components/ReportHistory.tsx:82
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:312
#: src/pages/devices2.tsx:9
msgid "Dispositivos"
msgstr "Dispositivos"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarComparisonDevices.tsx:23
msgid "Dispositivos a comparar"
msgstr "Dispositivos a comparar"

#: src/features/organizationAccess/data/sections.ts:33
msgid "Dispositivos Público"
msgstr "Dispositivos Público"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:87
#: src/features/organizationsManagement/components/OrganizationsTable.tsx:166
msgid "Dispositivos públicos"
msgstr "Dispositivos públicos"

#: src/features/deviceProfile/components/page/RelatedDevices.tsx:65
msgid "Dispositivos relacionados"
msgstr "Dispositivos relacionados"

#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:236
msgid "Dispositivos seleccionados"
msgstr "Dispositivos seleccionados"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:307
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:114
#: src/utils/i18n/getMetricDisplayName.ts:15
msgid "Distancia del sensor"
msgstr "Distancia del sensor"

#: src/features/reports/utils/metricHelpers.ts:22
msgid "Distancia del Sensor"
msgstr "Distancia del Sensor"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:337
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:182
#: src/features/reports/utils/metricHelpers.ts:36
msgid "Distancia sensor"
msgstr "Distancia sensor"

#: src/features/audit/utils/getDisplayNameEntity.ts:11
msgid "distribución de SIRA"
msgstr "distribución de SIRA"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:728
msgid "Doble"
msgstr "Doble"

#: src/features/reports/utils/schedules.ts:18
msgid "domingo"
msgstr "domingo"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:133
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:120
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:222
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:87
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:92
#: src/utils/i18n/getDgaTranslations.ts:13
msgid "Domingo"
msgstr "Domingo"

#: src/features/controlCenter/components/panel/Minicharts.tsx:248
#: src/features/controlCenter/utils/viewModes.ts:21
#: src/features/devicesAnalysis/components/panel/Chart.tsx:293
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:340
msgid "Dotación"
msgstr "Dotación"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:294
msgid "Ecuación curva polinomial"
msgstr "Ecuación curva polinomial"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:229
msgid "Ecuación curva potencial"
msgstr "Ecuación curva potencial"

#: src/pages/reports/edit.tsx:12
msgid "Edición de Reporte"
msgstr "Edición de Reporte"

#: src/features/deviceProfile/components/page/Observations.tsx:73
msgid "Editado el {0}"
msgstr "Editado el {0}"

#: src/features/announcements/components/AnnouncementMenu.tsx:59
#: src/features/announcements/components/AnnouncementsSaveModal.tsx:329
#: src/features/billing/components/payments/Options.tsx:49
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:490
#: src/features/deviceProfile/components/modal/ObservationMenu.tsx:26
#: src/features/devices2/components/list/itemPanel/SMAItemMenu.tsx:73
#: src/features/irrigations/components/Table.tsx:78
#: src/features/metricsViews/components/MetricsView.tsx:283
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:254
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:280
#: src/features/users/components/tableCells/UserActionsCell.tsx:47
#: src/features/userSaveModal/components/UserSaveModal.tsx:540
msgid "Editar"
msgstr "Editar"

#: src/features/controlCenter/components/panel/Panel.tsx:99
msgid "Editar alertas"
msgstr "Editar alertas"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:208
msgid "Editar Anuncio {0}"
msgstr "Editar Anuncio {0}"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:179
msgid "Editar Canal de Irrigación"
msgstr "Editar Canal de Irrigación"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:160
msgid "Editar configuración"
msgstr "Editar configuración"

#: src/features/alertsConfiguration/components/AlertTable.tsx:108
#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:223
msgid "Editar configuración de alertas"
msgstr "Editar configuración de alertas"

#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:98
msgid "Editar configuración de notificaciones del dispositivo {0}"
msgstr "Editar configuración de notificaciones del dispositivo {0}"

#: src/features/metricsViews/components/EditViewModal.tsx:91
msgid "Editar configuración de visualización de métricas"
msgstr "Editar configuración de visualización de métricas"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:73
msgid "Editar credencial API"
msgstr "Editar credencial API"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:193
msgid "Editar curva"
msgstr "Editar curva"

#: src/features/alertsConfiguration/components/AlertTable.tsx:124
msgid "Editar notificaciones de alertas"
msgstr "Editar notificaciones de alertas"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:170
msgid "Editar Organización"
msgstr "Editar Organización"

#: src/features/userProfile/components/UserProfile.tsx:92
#: src/features/userProfile/components/UserProfileSkeleton.tsx:37
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:265
msgid "Editar perfil"
msgstr "Editar perfil"

#: src/features/api/components/CaptaApiUsersList.tsx:161
msgid "Editar Permisos"
msgstr "Editar Permisos"

#: src/features/reports/components/creationSection/EditReportTemplate.tsx:47
msgid "Editar Reporte"
msgstr "Editar Reporte"

#: src/features/users/components/modals/SaveUserModal.tsx:167
msgid "Editar usuario"
msgstr "Editar usuario"

#: src/features/userSaveModal/components/UserSaveModal.tsx:258
msgid "Editar Usuario"
msgstr "Editar Usuario"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:118
#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:124
msgid "Editar usuarios a notificar"
msgstr "Editar usuarios a notificar"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:233
msgid "Editar widget"
msgstr "Editar widget"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:97
msgid "Eje X"
msgstr "Eje X"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:97
msgid "Eje Y"
msgstr "Eje Y"

#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:20
msgid "Ejecutada"
msgstr "Ejecutada"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:271
msgid "Ejecutar diariamente a las"
msgstr "Ejecutar diariamente a las"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:315
msgid "Ejecutar en el primer"
msgstr "Ejecutar en el primer"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:337
msgid "Ejecutar en el último"
msgstr "Ejecutar en el último"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:282
msgid "Ejecutar los días de semana (de lunes a viernes) a las"
msgstr "Ejecutar los días de semana (de lunes a viernes) a las"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:293
msgid "Ejecutar semanalmente los días"
msgstr "Ejecutar semanalmente los días"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:236
#: src/features/billing/components/modals/ServiceFileManager.tsx:168
msgid "Ejemplo de contenido del archivo CSV:"
msgstr "Ejemplo de contenido del archivo CSV:"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:94
msgid "Ejes"
msgstr "Ejes"

#: src/utils/getAlertsState.ts:19
msgid "El {msgText} está por debajo del {msgText2} mínimo del canal."
msgstr "El {msgText} está por debajo del {msgText2} mínimo del canal."

#: src/utils/getAlertsState.ts:18
msgid "El {msgText} supera el {msgText2} máximo del canal."
msgstr "El {msgText} supera el {msgText2} máximo del canal."

#: src/utils/getAlertsState.ts:17
msgid "El {msgText} supera la capacidad del canal."
msgstr "El {msgText} supera la capacidad del canal."

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:74
msgid "El apellido debe tener por lo menos 1 caracter"
msgstr "El apellido debe tener por lo menos 1 caracter"

#: src/features/reportDownload/components/ReportDownload.tsx:63
msgid "El archivo ya se ha descargado en su computador. Para volver a descargar haga <0>click aquí</0>."
msgstr "El archivo ya se ha descargado en su computador. Para volver a descargar haga <0>click aquí</0>."

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:59
msgid "El autor es requerido"
msgstr "El autor es requerido"

#: src/features/dga/utils/validationSchemas.ts:90
msgid "El campo 'code' no puede estar vacío"
msgstr "El campo 'code' no puede estar vacío"

#: src/features/dga/utils/validationSchemas.ts:41
#: src/features/dga/utils/validationSchemas.ts:42
msgid "El campo 'Día' debe estar entre 1 y 27"
msgstr "El campo 'Día' debe estar entre 1 y 27"

#: src/features/dga/utils/validationSchemas.ts:39
msgid "El campo 'Día' debe ser un número entero"
msgstr "El campo 'Día' debe ser un número entero"

#: src/features/dga/utils/validationSchemas.ts:34
#: src/features/dga/utils/validationSchemas.ts:35
msgid "El campo 'Hora' debe estar entre 0 y 23"
msgstr "El campo 'Hora' debe estar entre 0 y 23"

#: src/features/dga/utils/validationSchemas.ts:32
msgid "El campo 'Hora' debe ser un número entero"
msgstr "El campo 'Hora' debe ser un número entero"

#: src/features/dga/utils/validationSchemas.ts:27
msgid "El campo 'Inicio de envío' debe ser una fecha valida"
msgstr "El campo 'Inicio de envío' debe ser una fecha valida"

#: src/features/dga/utils/validationSchemas.ts:106
msgid "El campo 'password' no puede estar vacío"
msgstr "El campo 'password' no puede estar vacío"

#: src/utils/getAlertsState.ts:99
msgid "El caudal supera el máximo de {0} L/s permitido por el reparto para este canal."
msgstr "El caudal supera el máximo de {0} L/s permitido por el reparto para este canal."

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:78
msgid "El código de país debe ser válido"
msgstr "El código de país debe ser válido"

#: src/features/organizationCreateOrUpdate/utils/schema.ts:14
#: src/features/userSaveModal/utils/schema.ts:44
msgid "El código de país es requerido."
msgstr "El código de país es requerido."

#: src/features/deviceObservations/components/modals/CreateObservationModal.tsx:25
#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:26
msgid "El contenido debe tener al menos 2 caracteres"
msgstr "El contenido debe tener al menos 2 caracteres"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:71
msgid "El contenido es requerido"
msgstr "El contenido es requerido"

#: src/features/userSaveModal/utils/schema.ts:42
msgid "El correo electrónico es requerido."
msgstr "El correo electrónico es requerido."

#: src/features/billing/utils/validationSchema.ts:14
msgid "El descuento no puede ser mayor al 100 %."
msgstr "El descuento no puede ser mayor al 100 %."

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:43
msgid "El dispositivo {deviceId} ha sido archivado"
msgstr "El dispositivo {deviceId} ha sido archivado"

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:42
msgid "El dispositivo {deviceId} ha sido eliminado"
msgstr "El dispositivo {deviceId} ha sido eliminado"

#: src/utils/getAlertsState.ts:86
msgid "El dispositivo está desconectado."
msgstr "El dispositivo está desconectado."

#: src/features/billing/components/projectService/Create.tsx:63
msgid "El dispositivo no está asociado con el proyecto. Por favor, configure el proyecto desde el perfil del equipo y vuelva a intentarlo."
msgstr "El dispositivo no está asociado con el proyecto. Por favor, configure el proyecto desde el perfil del equipo y vuelva a intentarlo."

#: src/features/deviceProfile/components/modal/Status.tsx:202
msgid "El dispositivo no tiene configuración de hardware configurada"
msgstr "El dispositivo no tiene configuración de hardware configurada"

#: src/features/deviceProfile/components/modal/Status.tsx:120
msgid "El dispositivo no tiene datos las últimas 24 horas"
msgstr "El dispositivo no tiene datos las últimas 24 horas"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/index.tsx:29
msgid "El dispositivo no tiene sensor configurado"
msgstr "El dispositivo no tiene sensor configurado"

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:96
msgid "El dispositivo se clonará con el siguiente nombre"
msgstr "El dispositivo se clonará con el siguiente nombre"

#: src/features/deviceProfile/components/modal/Status.tsx:162
msgid "El dispositivo tiene configuración de hardware completa"
msgstr "El dispositivo tiene configuración de hardware completa"

#: src/features/deviceProfile/components/modal/Status.tsx:182
msgid "El dispositivo tiene configuración de hardware incompleta"
msgstr "El dispositivo tiene configuración de hardware incompleta"

#: src/features/deviceProfile/components/modal/Status.tsx:221
msgid "El dispositivo tiene configuración DGA creada pero faltan datos"
msgstr "El dispositivo tiene configuración DGA creada pero faltan datos"

#: src/features/deviceProfile/components/modal/Status.tsx:109
msgid "El dispositivo tiene datos las últimas 24 horas"
msgstr "El dispositivo tiene datos las últimas 24 horas"

#: src/features/deviceProfile/components/modal/Status.tsx:256
msgid "El dispositivo tiene la configuración DGA completa pero no posee envíos activos"
msgstr "El dispositivo tiene la configuración DGA completa pero no posee envíos activos"

#: src/features/deviceProfile/components/modal/Status.tsx:237
msgid "El dispositivo tiene la configuración DGA completa y posee envíos activos"
msgstr "El dispositivo tiene la configuración DGA completa y posee envíos activos"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:156
msgid "El dispositivo ya tiene una configuración DGA"
msgstr "El dispositivo ya tiene una configuración DGA"

#: src/features/dga/utils/validationSchemas.ts:98
#: src/features/dga/utils/validationSchemas.ts:131
msgid "El formato del RUT no es válido, ej: 12345678-K"
msgstr "El formato del RUT no es válido, ej: 12345678-K"

#: src/features/sma/components/SmaUpsertModal.tsx:46
msgid "El ID de la unidad fiscalizable de la SMA es requerido"
msgstr "El ID de la unidad fiscalizable de la SMA es requerido"

#: src/features/sma/components/SmaUpsertModal.tsx:48
msgid "El ID del dispositivo en la SMA es requerido"
msgstr "El ID del dispositivo en la SMA es requerido"

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:80
msgid "El ID del dispositivo no coincide"
msgstr "El ID del dispositivo no coincide"

#: src/features/sma/components/SmaUpsertModal.tsx:47
msgid "El ID del proceso de la SMA es requerido"
msgstr "El ID del proceso de la SMA es requerido"

#: src/features/reportDownload/components/ReportDownload.tsx:85
msgid "El link de descarga ha expirado o es inválido"
msgstr "El link de descarga ha expirado o es inválido"

#: src/features/deviceAlertsModal/components/basicConfigurationTab/updateSchema.ts:16
#: src/features/deviceConfigurationModal/components/gateTab/updateSchema.ts:13
msgid "El máximo debe ser mayor al mínimo"
msgstr "El máximo debe ser mayor al mínimo"

#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:41
msgid "El máximo no puede ser menor a 0"
msgstr "El máximo no puede ser menor a 0"

#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:35
msgid "El mínimo no puede ser mayor o igual al máximo."
msgstr "El mínimo no puede ser mayor o igual al máximo."

#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:47
msgid "El mínimo no puede ser menor o igual a 0"
msgstr "El mínimo no puede ser menor o igual a 0"

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:38
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:37
msgid "El nombre de la plantilla no puede estar vacío"
msgstr "El nombre de la plantilla no puede estar vacío"

#: src/features/sma/components/SmaUpsertModal.tsx:44
msgid "El nombre de usuario es requerido"
msgstr "El nombre de usuario es requerido"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:73
msgid "El nombre debe tener por lo menos 1 caracter"
msgstr "El nombre debe tener por lo menos 1 caracter"

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:60
msgid "El nombre del dispositivo debe tener al menos 2 caracteres"
msgstr "El nombre del dispositivo debe tener al menos 2 caracteres"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:85
msgid "El nombre es requerido"
msgstr "El nombre es requerido"

#: src/features/organizationCreateOrUpdate/utils/schema.ts:8
#: src/features/userSaveModal/utils/schema.ts:37
msgid "El nombre es requerido."
msgstr "El nombre es requerido."

#: src/features/reportProblem/components/ReportProblemDialog.tsx:45
msgid "El nombre no puede estar vacío"
msgstr "El nombre no puede estar vacío"

#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:67
msgid "El nuevo tiempo de expiración del token será en 2 semanas. ¿Deseas continuar?"
msgstr "El nuevo tiempo de expiración del token será en 2 semanas. ¿Deseas continuar?"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:96
msgid "El número de teléfono no es válido"
msgstr "El número de teléfono no es válido"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:79
msgid "El número de teléfono no puede estar vacío"
msgstr "El número de teléfono no puede estar vacío"

#: src/features/organizationCreateOrUpdate/utils/schema.ts:12
msgid "El número es requerido."
msgstr "El número es requerido."

#: src/features/billing/components/CreatePaymentView.tsx:78
#: src/features/billing/components/UpdatePaymentView.tsx:92
msgid "El proyecto no existe o el dispositivo no está asociado al proyecto."
msgstr "El proyecto no existe o el dispositivo no está asociado al proyecto."

#: src/features/userSaveModal/utils/schema.ts:20
msgid "El rol es requerido."
msgstr "El rol es requerido."

#: src/features/userSaveModal/utils/schema.ts:43
msgid "El teléfono debe ser un número válido."
msgstr "El teléfono debe ser un número válido."

#: src/features/organizationCreateOrUpdate/utils/schema.ts:13
msgid "El teléfono debe ser un número válido. Formato: XXXXXXXXX"
msgstr "El teléfono debe ser un número válido. Formato: XXXXXXXXX"

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:15
#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:14
msgid "El tipo de curva es obligatorio y debe ser function, interval o piecewise"
msgstr "El tipo de curva es obligatorio y debe ser function, interval o piecewise"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:63
msgid "El título es requerido"
msgstr "El título es requerido"

#: src/components/NotificationsPopover.tsx:172
msgid "El usuario"
msgstr "El usuario"

#: src/features/deviceAlertsModal/components/basicConfigurationTab/updateSchema.ts:20
msgid "El valor de desborde debe ser mayor al máximo"
msgstr "El valor de desborde debe ser mayor al máximo"

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:11
#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:10
msgid "El valor debe ser mayor a {number}"
msgstr "El valor debe ser mayor a {number}"

#: src/features/billing/utils/validationSchema.ts:10
msgid "El valor debe ser mayor a 0."
msgstr "El valor debe ser mayor a 0."

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:10
#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:9
msgid "El valor debe ser mayor al del caudal mínimo"
msgstr "El valor debe ser mayor al del caudal mínimo"

#: src/utils/yupValidation.ts:6
msgid "El valor debe ser mayor o igual a {min}"
msgstr "El valor debe ser mayor o igual a {min}"

#: src/features/billing/utils/validationSchema.ts:9
msgid "El valor debe ser mayor o igual a 0."
msgstr "El valor debe ser mayor o igual a 0."

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:9
#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:8
msgid "El valor debe ser menor al del caudal máximo"
msgstr "El valor debe ser menor al del caudal máximo"

#: src/features/billing/utils/validationSchema.ts:8
#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:8
#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:7
msgid "El valor debe ser un número"
msgstr "El valor debe ser un número"

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:13
#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:12
#: src/utils/yupValidation.ts:5
msgid "El valor debe ser uno de: {0}"
msgstr "El valor debe ser uno de: {0}"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:106
msgid "Elige un dispositivo desde los controles"
msgstr "Elige un dispositivo desde los controles"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:254
msgid "Elija la recurrencia en la cual quiere recibir sus reportes:"
msgstr "Elija la recurrencia en la cual quiere recibir sus reportes:"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:328
#: src/features/announcements/components/AnnouncementMenu.tsx:62
#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:94
#: src/features/api/components/CaptaApiUsersList.tsx:201
#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:123
#: src/features/billing/components/payments/DeletePayment.tsx:62
#: src/features/billing/components/payments/Options.tsx:62
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:495
#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:160
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:458
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/DeleteCurveModal.tsx:39
#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:101
#: src/features/deviceProfile/components/modal/ObservationMenu.tsx:38
#: src/features/gateAdministration/components/DeleteRequestModal.tsx:58
#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:263
#: src/features/irrigations/components/Table.tsx:81
#: src/features/notifications/components/NotificationsDeleteModal.tsx:83
#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:78
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:290
#: src/features/users/components/modals/DeleteUserModal.tsx:56
#: src/features/users/components/tableCells/UserActionsCell.tsx:63
msgid "Eliminar"
msgstr "Eliminar"

#: src/features/audit/components/AuditLogDetailsRow.tsx:16
msgid "ELIMINAR"
msgstr "ELIMINAR"

#: src/features/access/components/globalModals/RemoveDeviceUserRelationsModal.tsx:225
msgid "Eliminar {count} registros"
msgstr "Eliminar {count} registros"

#: src/features/audit/utils/getActionTypeOptions.ts:298
msgid "Eliminar accesos de dispositivo para un usuario"
msgstr "Eliminar accesos de dispositivo para un usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:304
msgid "Eliminar accesos de usuario para un dispositivo"
msgstr "Eliminar accesos de usuario para un dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:208
msgid "Eliminar Alias de Dispositivo"
msgstr "Eliminar Alias de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:52
msgid "Eliminar API para Organización"
msgstr "Eliminar API para Organización"

#: src/features/irrigations/components/DeleteIrrigation.tsx:46
msgid "Eliminar canal de irrigación"
msgstr "Eliminar canal de irrigación"

#: src/features/audit/utils/getActionTypeOptions.ts:61
msgid "Eliminar Canal de Irrigación"
msgstr "Eliminar Canal de Irrigación"

#: src/features/audit/utils/getActionTypeOptions.ts:67
msgid "Eliminar Clase de Canal de SIRA"
msgstr "Eliminar Clase de Canal de SIRA"

#: src/features/audit/utils/getActionTypeOptions.ts:58
msgid "Eliminar Configuración de Calendario para Dispositivo"
msgstr "Eliminar Configuración de Calendario para Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:244
msgid "Eliminar Configuración de DGA"
msgstr "Eliminar Configuración de DGA"

#: src/features/audit/utils/getActionTypeOptions.ts:181
msgid "Eliminar Configuración de Hardware de Dispositivo"
msgstr "Eliminar Configuración de Hardware de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:256
msgid "Eliminar Configuración de Recurrencia de Envío de DGA"
msgstr "Eliminar Configuración de Recurrencia de Envío de DGA"

#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:51
msgid "Eliminar Configuración de Reporte"
msgstr "Eliminar Configuración de Reporte"

#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:102
#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:125
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:135
msgid "Eliminar configuración DGA"
msgstr "Eliminar configuración DGA"

#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:79
msgid "Eliminar credenciales API"
msgstr "Eliminar credenciales API"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:79
msgid "Eliminar Credenciales API"
msgstr "Eliminar Credenciales API"

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:102
#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:182
#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:205
#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:143
msgid "Eliminar dispositivo"
msgstr "Eliminar dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:55
msgid "Eliminar Dispositivo"
msgstr "Eliminar Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:70
msgid "Eliminar Distribución de SIRA Maipo"
msgstr "Eliminar Distribución de SIRA Maipo"

#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:79
msgid "Eliminar observación"
msgstr "Eliminar observación"

#: src/features/audit/utils/getActionTypeOptions.ts:64
msgid "Eliminar Organización"
msgstr "Eliminar Organización"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:42
msgid "Eliminar organización {0}"
msgstr "Eliminar organización {0}"

#: src/features/billing/components/payments/DeletePayment.tsx:52
msgid "Eliminar Pago"
msgstr "Eliminar Pago"

#: src/features/audit/utils/getActionTypeOptions.ts:232
msgid "Eliminar Programación de Reporte"
msgstr "Eliminar Programación de Reporte"

#: src/features/access/components/devicesTab/DevicesTab.tsx:153
#: src/features/access/components/usersTab/UsersTab.tsx:140
msgid "Eliminar registros"
msgstr "Eliminar registros"

#: src/features/access/components/globalModals/RemoveDeviceUserRelationsModal.tsx:118
#: src/features/access/components/globalModals/RemoveDeviceUserRelationsModal.tsx:237
msgid "Eliminar relaciones dispositivo-usuario"
msgstr "Eliminar relaciones dispositivo-usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:223
msgid "Eliminar Reporte"
msgstr "Eliminar Reporte"

#: src/features/audit/utils/getActionTypeOptions.ts:289
msgid "Eliminar servicio de facturación"
msgstr "Eliminar servicio de facturación"

#: src/features/billing/components/projectService/Delete.tsx:81
msgid "Eliminar servicio del proyecto"
msgstr "Eliminar servicio del proyecto"

#: src/features/audit/utils/getActionTypeOptions.ts:280
msgid "Eliminar servicio para proyecto de facturación"
msgstr "Eliminar servicio para proyecto de facturación"

#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:51
msgid "Eliminar solicitud de movimiento"
msgstr "Eliminar solicitud de movimiento"

#: src/features/audit/utils/getActionTypeOptions.ts:187
msgid "Eliminar Solicitud de Movimiento en Cola de Compuerta"
msgstr "Eliminar Solicitud de Movimiento en Cola de Compuerta"

#: src/features/audit/utils/getActionTypeOptions.ts:271
msgid "Eliminar un pago"
msgstr "Eliminar un pago"

#: src/features/users/components/modals/DeleteUserModal.tsx:78
msgid "Eliminar usuario"
msgstr "Eliminar usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:76
msgid "Eliminar Usuario"
msgstr "Eliminar Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:73
msgid "Eliminar Usuario de SIRA a Notificar"
msgstr "Eliminar Usuario de SIRA a Notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:173
msgid "eliminó accesos de dispositivos al usuario"
msgstr "eliminó accesos de dispositivos al usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:124
msgid "eliminó accesos de usuario para el dispositivo"
msgstr "eliminó accesos de usuario para el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:112
msgid "eliminó el alias del dispositivo"
msgstr "eliminó el alias del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:327
msgid "eliminó el cronograma del reporte"
msgstr "eliminó el cronograma del reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:44
msgid "eliminó el dispositivo"
msgstr "eliminó el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:315
msgid "eliminó el reporte"
msgstr "eliminó el reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:137
msgid "eliminó el usuario"
msgstr "eliminó el usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:220
msgid "eliminó el usuario de SIRA para notificar"
msgstr "eliminó el usuario de SIRA para notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:249
msgid "eliminó la API para la organización"
msgstr "eliminó la API para la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:208
msgid "eliminó la clase de canal de SIRA"
msgstr "eliminó la clase de canal de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:390
msgid "eliminó la configuración de DGA"
msgstr "eliminó la configuración de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:398
msgid "eliminó la configuración de la recurrencia de envío de DGA"
msgstr "eliminó la configuración de la recurrencia de envío de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:76
msgid "eliminó la configuración del calendario del dispositivo"
msgstr "eliminó la configuración del calendario del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:92
msgid "eliminó la configuración del hardware del dispositivo"
msgstr "eliminó la configuración del hardware del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:281
msgid "eliminó la distribución de SIRA Maipo"
msgstr "eliminó la distribución de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:182
msgid "eliminó la irrigación"
msgstr "eliminó la irrigación"

#: src/features/audit/utils/getDisplayNameActionType.ts:229
msgid "eliminó la organización"
msgstr "eliminó la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:306
msgid "eliminó la solicitud de movimiento en cola de la compuerta"
msgstr "eliminó la solicitud de movimiento en cola de la compuerta"

#: src/features/audit/utils/getDisplayNameActionType.ts:372
msgid "eliminó un nuevo servicio de facturación."
msgstr "eliminó un nuevo servicio de facturación."

#: src/features/audit/utils/getDisplayNameActionType.ts:348
msgid "eliminó un pago del proyecto."
msgstr "eliminó un pago del proyecto."

#: src/features/audit/utils/getDisplayNameActionType.ts:360
msgid "eliminó un servicio del proyecto."
msgstr "eliminó un servicio del proyecto."

#: src/features/gates/components/list/GateListItemInfo.tsx:47
msgid "En {deviceStatus}"
msgstr "En {deviceStatus}"

#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:50
msgid "En cola"
msgstr "En cola"

#: src/features/dga/utils/chartOptions.ts:69
msgid "En cola para ser enviado."
msgstr "En cola para ser enviado."

#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:24
msgid "En ejecución"
msgstr "En ejecución"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:100
msgid "En la primera semana del mes"
msgstr "En la primera semana del mes"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:101
msgid "En la última semana del mes"
msgstr "En la última semana del mes"

#: src/components/filters/StatusFilter.tsx:28
#: src/features/devices2/components/DevicesHeader.tsx:129
#: src/features/gates/components/Gates.tsx:98
#: src/utils/devices/getDeviceStatusFormat.ts:14
#: src/utils/i18n/getDeviceStatus.ts:18
msgid "En mantenimiento"
msgstr "En mantenimiento"

#: src/features/deviceSupport/data/status.ts:10
msgid "En Mantenimiento"
msgstr "En Mantenimiento"

#: src/components/filters/StatusFilter.tsx:24
#: src/features/devices2/components/DevicesHeader.tsx:125
#: src/features/deviceSupport/data/status.ts:9
#: src/features/gates/components/Gates.tsx:94
#: src/utils/devices/getDeviceStatusFormat.ts:22
#: src/utils/i18n/getDeviceStatus.ts:22
msgid "En prueba"
msgstr "En prueba"

#: src/features/sma/utils/echartOptions.ts:28
msgid "En reintento"
msgstr "En reintento"

#: src/features/deviceCommands/components/standard/StandardCommandsInformation.tsx:113
msgid "ENCENDIDO"
msgstr "ENCENDIDO"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:52
msgid "Encendido (POWER_SECONDS_ON): 840 segundos."
msgstr "Encendido (POWER_SECONDS_ON): 840 segundos."

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1101
msgid "End"
msgstr "End"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:110
#: src/features/reports/utils/metricHelpers.ts:18
msgid "Energía"
msgstr "Energía"

#: src/features/audit/utils/parseProperty.ts:60
msgid "energización"
msgstr "energización"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:268
#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:12
#: src/features/deviceConfiguration/data/sectionFields.ts:131
#: src/features/deviceConfiguration/data/sectionFields.ts:274
#: src/features/deviceConfiguration/data/sectionInputs.ts:124
#: src/features/deviceConfiguration/data/sectionInputs.ts:292
#: src/features/deviceProfile/components/page/modularComponents/index.tsx:35
msgid "Energización"
msgstr "Energización"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:17
msgid "Enero"
msgstr "Enero"

#: src/features/notifications/components/Notifications.tsx:85
#: src/features/notifications/components/NotificationsSaveModal.tsx:174
msgid "Entidad"
msgstr "Entidad"

#: src/features/integrations/components/groupedIssuesModal/index.tsx:34
msgid "Entity"
msgstr "Entity"

#: src/features/audit/utils/parseProperty.ts:111
msgid "entrada de excel"
msgstr "entrada de excel"

#: src/features/dga/utils/chartOptions.ts:70
msgid "Enviado a la DGA y esperando su confirmación."
msgstr "Enviado a la DGA y esperando su confirmación."

#: src/features/reports/components/ReportHistory.tsx:292
msgid "Enviado a los emails"
msgstr "Enviado a los emails"

#: src/features/gateAdministration/components/MoveGate.tsx:143
msgid "Enviando comando de movimiento a la compuerta..."
msgstr "Enviando comando de movimiento a la compuerta..."

#: src/components/gates/StopMovementConfirmation.tsx:85
msgid "Enviando comando para detener la compuerta..."
msgstr "Enviando comando para detener la compuerta..."

#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:108
#: src/features/recoveryPassword/components/RecoveryPassword.tsx:80
#: src/features/reportProblem/components/ReportProblemDialog.tsx:168
#: src/features/sma/components/SendReportsByEmailModal.tsx:112
msgid "Enviar"
msgstr "Enviar"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:140
msgid "Enviar comando"
msgstr "Enviar comando"

#: src/features/audit/utils/getActionTypeOptions.ts:184
msgid "Enviar Comando de Configuración a Dispositivo"
msgstr "Enviar Comando de Configuración a Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:172
msgid "Enviar Comando de Detención de Movimiento a Compuerta"
msgstr "Enviar Comando de Detención de Movimiento a Compuerta"

#: src/features/audit/utils/getActionTypeOptions.ts:169
msgid "Enviar Comando de Movimiento a Compuerta"
msgstr "Enviar Comando de Movimiento a Compuerta"

#: src/features/userSaveModal/components/UserSaveModal.tsx:527
msgid "Enviar datos de acceso por correo electrónico"
msgstr "Enviar datos de acceso por correo electrónico"

#: src/components/layout/DashboardSidebar.tsx:260
#: src/pages/device-commands/advanced.tsx:9
#: src/pages/device-commands/calendar.tsx:9
#: src/pages/device-commands/index.tsx:9
msgid "Envío de Comandos"
msgstr "Envío de Comandos"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:88
msgid "Envío no operativo"
msgstr "Envío no operativo"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:86
msgid "Envío operativo"
msgstr "Envío operativo"

#: src/features/audit/utils/getDisplayNameActionType.ts:96
msgid "envió un comando al dispositivo"
msgstr "envió un comando al dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:302
msgid "envió un comando de detención de movimiento a la compuerta"
msgstr "envió un comando de detención de movimiento a la compuerta"

#: src/features/audit/utils/getDisplayNameActionType.ts:298
msgid "envió un comando de movimiento a la compuerta"
msgstr "envió un comando de movimiento a la compuerta"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:55
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:79
msgid "Envíos"
msgstr "Envíos"

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:109
msgid "Equipo Capta Hydro"
msgstr "Equipo Capta Hydro"

#: src/features/controlCenter/components/window/StationListItem.tsx:434
msgid "Equipo con {0} acciones"
msgstr "Equipo con {0} acciones"

#: src/features/controlCenter/components/window/StationListItem.tsx:403
msgid "Equipo con alertas configuradas"
msgstr "Equipo con alertas configuradas"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:128
msgid "Equipo con dotación"
msgstr "Equipo con dotación"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:119
#: src/features/controlCenter/components/window/StationListItem.tsx:424
#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:281
msgid "Equipo conectado"
msgstr "Equipo conectado"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:122
#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:281
msgid "Equipo desconectado"
msgstr "Equipo desconectado"

#: src/features/controlCenter/components/window/StationListItem.tsx:440
msgid "Equipo sin acciones"
msgstr "Equipo sin acciones"

#: src/features/controlCenter/components/window/StationListItem.tsx:399
msgid "Equipo sin alertas configuradas"
msgstr "Equipo sin alertas configuradas"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:131
msgid "Equipo sin dotación"
msgstr "Equipo sin dotación"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:342
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:307
#: src/features/reports/utils/metricHelpers.ts:31
msgid "Equivalente de agua de nieve"
msgstr "Equivalente de agua de nieve"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:344
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:221
msgid "Equivalente de agua de nieve bruto"
msgstr "Equivalente de agua de nieve bruto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:349
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:234
#: src/features/reports/utils/metricHelpers.ts:37
msgid "Equivalente de agua de nieve sin calibrar"
msgstr "Equivalente de agua de nieve sin calibrar"

#: src/features/integrations/utils/writeExecutionLogSeverityAttributes.ts:37
msgid "Error"
msgstr "Error"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:72
msgid "ERROR"
msgstr "ERROR"

#: src/features/deviceConfigurationModal/components/publicTab/useUpdateForm.ts:42
msgid "Error al actualizar dispositivo: {0}"
msgstr "Error al actualizar dispositivo: {0}"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:203
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:76
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:62
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:114
msgid "Error al actualizar el dato"
msgstr "Error al actualizar el dato"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:70
#: src/features/deviceConfigurationModal/hooks/useUpdateDeviceStatusForm.ts:41
msgid "Error al actualizar el dispositivo: {0}"
msgstr "Error al actualizar el dispositivo: {0}"

#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:45
#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:56
#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:84
#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:23
#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:33
msgid "Error al actualizar el estado de soporte"
msgstr "Error al actualizar el estado de soporte"

#: src/features/controlCenter/components/window/DialogDragAndDrop.tsx:105
msgid "Error al actualizar el orden de los dispositivos."
msgstr "Error al actualizar el orden de los dispositivos."

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:168
msgid "Error al actualizar el perfil"
msgstr "Error al actualizar el perfil"

#: src/features/billing/components/service/Update.tsx:41
msgid "Error al actualizar el servicio."
msgstr "Error al actualizar el servicio."

#: src/features/gates/components/AlarmSystem.tsx:38
msgid "Error al actualizar la alarma"
msgstr "Error al actualizar la alarma"

#: src/features/deviceAlertsModal/components/basicConfigurationTab/useUpdateForm.ts:56
#: src/features/deviceConfigurationModal/components/gateTab/useUpdateForm.ts:43
msgid "Error al actualizar la configuración de alertas: {0}"
msgstr "Error al actualizar la configuración de alertas: {0}"

#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:54
msgid "Error al actualizar la contraseña"
msgstr "Error al actualizar la contraseña"

#: src/features/deviceAlertsModal/components/alertConfigurationTab/useUpdateForm.ts:28
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/useUpdateForm.ts:26
msgid "Error al actualizar las notificaciones: {0}"
msgstr "Error al actualizar las notificaciones: {0}"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:83
msgid "Error al actualizar los alias del dispositivo: {0}"
msgstr "Error al actualizar los alias del dispositivo: {0}"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:50
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:73
msgid "Error al actualizar los datos: {0}"
msgstr "Error al actualizar los datos: {0}"

#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:74
msgid "Error al cambiar la contraseña. Por favor, intenta nuevamente o comunícate con soporte@captahydro.com"
msgstr "Error al cambiar la contraseña. Por favor, intenta nuevamente o comunícate con soporte@captahydro.com"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:27
msgid "Error al crear dispositivo: {0}"
msgstr "Error al crear dispositivo: {0}"

#: src/features/billing/components/CreatePaymentView.tsx:80
#: src/features/billing/components/projectService/Create.tsx:65
#: src/features/billing/components/service/Administration.tsx:43
#: src/features/billing/components/service/Delete.tsx:34
#: src/features/billing/components/UpdatePaymentView.tsx:96
msgid "Error al crear el pago."
msgstr "Error al crear el pago."

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:113
#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:139
msgid "Error al crear la plantilla"
msgstr "Error al crear la plantilla"

#: src/features/reportDownload/components/ReportDownload.tsx:81
msgid "Error al descargar el reporte"
msgstr "Error al descargar el reporte"

#: src/features/billing/components/payments/PaymentRow.tsx:161
msgid "Error al descargar la factura."
msgstr "Error al descargar la factura."

#: src/features/billing/components/projectService/Delete.tsx:54
msgid "Error al eliminar el servicio."
msgstr "Error al eliminar el servicio."

#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:40
#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:43
msgid "Error al eliminar la configuración del equipo"
msgstr "Error al eliminar la configuración del equipo"

#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:50
msgid "Error al eliminar la credencial"
msgstr "Error al eliminar la credencial"

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:52
msgid "Error al eliminar la programación"
msgstr "Error al eliminar la programación"

#: src/features/gateAdministration/components/DeleteRequestModal.tsx:46
#: src/features/gateAdministration/components/DeleteRequestModal.tsx:51
msgid "Error al eliminar la solicitud de movimiento"
msgstr "Error al eliminar la solicitud de movimiento"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:47
msgid "Error al enviar el comando"
msgstr "Error al enviar el comando"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:31
msgid "Error al enviar el comando. Por favor, intente nuevamente."
msgstr "Error al enviar el comando. Por favor, intente nuevamente."

#: src/features/reportProblem/components/ReportProblemDialog.tsx:73
msgid "Error al enviar el reporte"
msgstr "Error al enviar el reporte"

#: src/features/deviceCommands/components/calendar/UpdateCommandKeyDialog.tsx:40
msgid "Error al intentar actualizar el comando. Por favor, intente nuevamente."
msgstr "Error al intentar actualizar el comando. Por favor, intente nuevamente."

#: src/features/deviceCommands/components/calendar/DeleteScheduleCommandKeyDialog.tsx:38
msgid "Error al intentar eliminar el comando. Por favor, intente nuevamente."
msgstr "Error al intentar eliminar el comando. Por favor, intente nuevamente."

#: src/features/billing/components/table/ProjectsTable.tsx:117
msgid "Error al modificar la periodicidad: {0}"
msgstr "Error al modificar la periodicidad: {0}"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:180
msgid "Error al programar el reporte"
msgstr "Error al programar el reporte"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:108
msgid "Error al solicitar el reporte. Intente nuevamente."
msgstr "Error al solicitar el reporte. Intente nuevamente."

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:195
msgid "Es el nombre que verán los miembros de tu organización"
msgstr "Es el nombre que verán los miembros de tu organización"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:104
#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:101
msgid "Escriba \"{0}\""
msgstr "Escriba \"{0}\""

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:101
msgid "Escriba {0}"
msgstr "Escriba {0}"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:374
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:232
msgid "Escriba los emails a enviar el reporte"
msgstr "Escriba los emails a enviar el reporte"

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:98
msgid "Escribe \"{0}\""
msgstr "Escribe \"{0}\""

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:127
msgid "Escribe el ID del dispositivo para confirmar"
msgstr "Escribe el ID del dispositivo para confirmar"

#: src/features/api/components/ApiUsersList.tsx:66
#: src/features/api/components/CaptaApiUsersList.tsx:100
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:146
#: src/features/api/components/dialogs/EditApiUserDialog.tsx:113
msgid "Escritura"
msgstr "Escritura"

#: src/features/audit/utils/parseProperty.ts:16
msgid "escritura de dispositivo"
msgstr "escritura de dispositivo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:379
msgid "Especificaciones"
msgstr "Especificaciones"

#: src/components/gates/StopMovementConfirmation.tsx:82
msgid "Esperando la respuesta de la compuerta..."
msgstr "Esperando la respuesta de la compuerta..."

#: src/features/gates/components/AlarmSystem.tsx:76
msgid "Esperando nuevo estado de alarma"
msgstr "Esperando nuevo estado de alarma"

#: src/features/billing/components/payments/PaymentRow.tsx:202
msgid "Está a punto de descargar la factura {number}. Desea continuar?"
msgstr "Está a punto de descargar la factura {number}. Desea continuar?"

#: src/features/billing/components/service/Delete.tsx:49
msgid "Está intentando eliminar el servicio"
msgstr "Está intentando eliminar el servicio"

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:72
msgid "Esta plantilla aún no ha sido programada"
msgstr "Esta plantilla aún no ha sido programada"

#: src/features/billing/components/service/Delete.tsx:52
msgid "Está seguro que quiere eliminar el servicio?"
msgstr "Está seguro que quiere eliminar el servicio?"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:775
msgid "Estación"
msgstr "Estación"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:66
msgid "Estaciones virtuales"
msgstr "Estaciones virtuales"

#: src/features/audit/utils/parseProperty.ts:35
msgid "estado"
msgstr "estado"

#: src/components/filters/StatusFilter.tsx:34
#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:169
#: src/features/billing/components/table/DevicesTable.tsx:165
#: src/features/billing/components/table/OrganizationsTable.tsx:72
#: src/features/billing/components/table/ProjectsTable.tsx:83
#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:37
#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:80
#: src/features/deviceProfile/components/page/General.tsx:39
#: src/features/devices2/components/DevicesHeader.tsx:133
#: src/features/deviceSupport/data/column.ts:41
#: src/features/deviceSupport/data/column.ts:49
#: src/features/deviceSupport/data/column.ts:57
#: src/features/deviceSupport/data/fields.ts:10
#: src/features/deviceSupport/data/filter.ts:11
#: src/features/gates/components/Gates.tsx:102
#: src/features/gates/components/list/GateListItemLastMovement.tsx:72
#: src/features/users/components/UsersTable.tsx:94
#: src/features/users/utils/filterOptions.ts:106
#: src/features/users/utils/filterOptions.ts:111
msgid "Estado"
msgstr "Estado"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:116
msgid "ESTADO"
msgstr "ESTADO"

#: src/features/deviceConfigurationModal/components/statusTab/index.tsx:39
#: src/features/deviceConfigurationModal/components/updateDeviceStatusModal/index.tsx:43
msgid "Estado actual"
msgstr "Estado actual"

#: src/features/metricsViews/components/widgets/TableWidget.tsx:110
msgid "Estado conexión"
msgstr "Estado conexión"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:155
#: src/features/metricsViews/components/SaveWidgetModal.tsx:427
#: src/features/metricsViews/components/SaveWidgetModal.tsx:828
msgid "Estado de conexión"
msgstr "Estado de conexión"

#: src/features/reports/utils/metricHelpers.ts:11
msgid "Estado de Conexión"
msgstr "Estado de Conexión"

#: src/features/billing/components/administration/Filters.tsx:55
msgid "Estado de deuda"
msgstr "Estado de deuda"

#: src/features/audit/utils/parseProperty.ts:38
msgid "estado de soporte"
msgstr "estado de soporte"

#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:103
msgid "Estado de soporte"
msgstr "Estado de soporte"

#: src/features/deviceSupport/components/DevicesFilters.tsx:168
#: src/features/deviceSupport/components/FilterAdvance.tsx:149
#: src/features/deviceSupport/data/filter.ts:12
msgid "Estado de Soporte"
msgstr "Estado de Soporte"

#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:49
msgid "Estado de soporte actualizado correctamente"
msgstr "Estado de soporte actualizado correctamente"

#: src/features/gateAdministration/components/MovementHistory.tsx:79
msgid "Estado solicitud"
msgstr "Estado solicitud"

#: src/features/deviceSupport/data/fields.ts:11
msgid "Estado soporte"
msgstr "Estado soporte"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:330
msgid "Estados de conexión"
msgstr "Estados de conexión"

#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:115
#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:66
#: src/features/metricsViews/components/SaveWidgetModal.tsx:700
msgid "Estándar"
msgstr "Estándar"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:113
msgid "Estas activando el equipo en modo:"
msgstr "Estas activando el equipo en modo:"

#: src/features/metricsViews/components/CreateViewModal.tsx:87
msgid "Estás creando la configuración de visualización de métricas para el dispositivo <0>{id} - {0}</0>. En este formulario puedes seleccionar todos los dispositivos que quieras agregar a la visualización."
msgstr "Estás creando la configuración de visualización de métricas para el dispositivo <0>{id} - {0}</0>. En este formulario puedes seleccionar todos los dispositivos que quieras agregar a la visualización."

#: src/features/metricsViews/components/EditViewModal.tsx:95
msgid "Estás editando la configuración de visualización de métricas del dispositivo <0>{id} - {0}</0>. En este formulario puedes seleccionar todos los dispositivos que quieras agregar a la visualización. Una vez guardada la configuración, podrás configurar los widgets para los dispositivos seleccionados."
msgstr "Estás editando la configuración de visualización de métricas del dispositivo <0>{id} - {0}</0>. En este formulario puedes seleccionar todos los dispositivos que quieras agregar a la visualización. Una vez guardada la configuración, podrás configurar los widgets para los dispositivos seleccionados."

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:120
msgid "Estás por configurar el equipo en modo:"
msgstr "Estás por configurar el equipo en modo:"

#: src/features/billing/utils/validationSchema.ts:5
#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:6
#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:5
#: src/utils/yupValidation.ts:4
msgid "Este campo es obligatorio"
msgstr "Este campo es obligatorio"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:83
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:91
msgid "Este campo es requerido"
msgstr "Este campo es requerido"

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:70
msgid "Estimado cliente,"
msgstr "Estimado cliente,"

#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:85
msgid "Esto eliminará el anuncio con el título: <0>{0}</0>"
msgstr "Esto eliminará el anuncio con el título: <0>{0}</0>"

#: src/features/notifications/components/NotificationsDeleteModal.tsx:73
msgid "Esto eliminará las notificaciones relacionadas con este objeto recibidas por los usuarios."
msgstr "Esto eliminará las notificaciones relacionadas con este objeto recibidas por los usuarios."

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:57
msgid "Ethernet"
msgstr "Ethernet"

#: src/features/deviceSupport/data/column.ts:55
#: src/features/deviceSupport/data/fields.ts:12
msgid "Etiquetas"
msgstr "Etiquetas"

#: src/features/reportProblem/components/ReportProblemDialog.tsx:147
msgid "Evento a reportar"
msgstr "Evento a reportar"

#: src/features/deviceProfile/components/page/events/index.tsx:147
#: src/features/devicesAnalysis/components/panel/Chart.tsx:233
#: src/features/deviceSupport/data/column.ts:155
#: src/features/deviceSupport/data/fields.ts:23
#: src/features/metricsViews/components/SaveWidgetModal.tsx:852
msgid "Eventos"
msgstr "Eventos"

#: src/features/deviceProfile/components/page/events/index.tsx:180
msgid "Eventos con mayor ocurrencia"
msgstr "Eventos con mayor ocurrencia"

#: src/features/deviceProfile/components/page/events/index.tsx:160
msgid "Eventos en el tiempo"
msgstr "Eventos en el tiempo"

#: src/features/gateAdministration/components/MoveGate.tsx:66
msgid "Existe una solicitud de movimiento que aún no se ha ejecutado. Si solicitas una nueva posición, la solicitud anterior será cancelada."
msgstr "Existe una solicitud de movimiento que aún no se ha ejecutado. Si solicitas una nueva posición, la solicitud anterior será cancelada."

#: src/features/organizationCreateOrUpdate/components/SimilarOrganizations.tsx:7
msgid "Existen organizaciones con nombres similares:"
msgstr "Existen organizaciones con nombres similares:"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:40
msgid "Éxito de ayer"
msgstr "Éxito de ayer"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:45
msgid "Éxito último año"
msgstr "Éxito último año"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:47
msgid "Éxito últimos 3 meses"
msgstr "Éxito últimos 3 meses"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:44
msgid "Éxito últimos 30 días"
msgstr "Éxito últimos 30 días"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:49
msgid "Éxito últimos 6 meses"
msgstr "Éxito últimos 6 meses"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:42
msgid "Éxito últimos 7 días"
msgstr "Éxito últimos 7 días"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:91
#: src/utils/i18n/getAlertSuccessOptions.ts:19
msgid "Exitoso"
msgstr "Exitoso"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:137
#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:137
msgid "Expandir gráfico"
msgstr "Expandir gráfico"

#: src/features/billing/components/table/ServicesTable.tsx:56
msgid "Expiración del Servicio"
msgstr "Expiración del Servicio"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:196
msgid "Expresión"
msgstr "Expresión"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:152
msgid "Expresión matemática para calcular el caudal"
msgstr "Expresión matemática para calcular el caudal"

#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:88
#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:76
msgid "Extender"
msgstr "Extender"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:98
msgid "Extender duración de usuario (expira {0})"
msgstr "Extender duración de usuario (expira {0})"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:82
msgid "Extender duración de usuario (expiró {0})"
msgstr "Extender duración de usuario (expiró {0})"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:133
msgid "Extender duración del token (expira {0})"
msgstr "Extender duración del token (expira {0})"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:114
msgid "Extender duración del token (expiró {0})"
msgstr "Extender duración del token (expiró {0})"

#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:64
msgid "Extender duración del token de activación"
msgstr "Extender duración del token de activación"

#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:67
msgid "Extender duración del usuario temporal"
msgstr "Extender duración del usuario temporal"

#: src/features/audit/utils/parseProperty.ts:148
msgid "extracción usb"
msgstr "extracción usb"

#: src/features/deviceConfiguration/data/sectionFields.ts:316
#: src/features/deviceConfiguration/data/sectionInputs.ts:328
msgid "Extracción USB"
msgstr "Extracción USB"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:104
msgid "Extremo"
msgstr "Extremo"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:47
#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:79
msgid "Fácil de instalar"
msgstr "Fácil de instalar"

#: src/features/billing/components/payments/PaymentsTable.tsx:47
msgid "Factura"
msgstr "Factura"

#: src/components/layout/DashboardSidebar.tsx:228
#: src/pages/billing/AdministrationView.tsx:10
msgid "Facturación"
msgstr "Facturación"

#: src/utils/getUnitTranslation.ts:96
#: src/utils/units.ts:137
msgid "fahrenheit"
msgstr "fahrenheit"

#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:32
msgid "Fallida"
msgstr "Fallida"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:92
#: src/utils/i18n/getAlertSuccessOptions.ts:21
msgid "Fallido"
msgstr "Fallido"

#: src/features/alertsNotificationsHistory/hooks/useTranslations.ts:12
msgid "Fallo reporte DGA"
msgstr "Fallo reporte DGA"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:18
msgid "Febrero"
msgstr "Febrero"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:48
#: src/features/alertsNotificationsHistory/components/Filters.tsx:243
#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:160
#: src/features/audit/components/AuditLogsSidebar.tsx:87
#: src/features/billing/components/payments/PaymentsTable.tsx:49
#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:123
#: src/features/dga/components/modals/reports/TableModal.tsx:153
#: src/features/events/components/HeaderTable.tsx:19
#: src/features/gates/components/list/GateListItemLastMovement.tsx:65
#: src/features/metricsViews/components/widgets/TableWidget.tsx:161
#: src/features/sma/components/TableModal.tsx:186
msgid "Fecha"
msgstr "Fecha"

#: src/features/audit/utils/parseProperty.ts:113
msgid "fecha actualizado"
msgstr "fecha actualizado"

#: src/features/audit/utils/parseProperty.ts:41
msgid "fecha creación"
msgstr "fecha creación"

#: src/features/audit/utils/parseProperty.ts:114
msgid "fecha creado"
msgstr "fecha creado"

#: src/features/audit/utils/parseProperty.ts:47
msgid "fecha de acción"
msgstr "fecha de acción"

#: src/features/deviceConfiguration/data/sectionFields.ts:21
#: src/features/deviceConfiguration/data/sectionInputs.ts:30
msgid "Fecha de activación"
msgstr "Fecha de activación"

#: src/features/audit/utils/parseProperty.ts:12
msgid "fecha de creación"
msgstr "fecha de creación"

#: src/features/deviceProfile/components/page/General.tsx:51
#: src/features/reports/components/ReportHistory.tsx:76
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:138
msgid "Fecha de creación"
msgstr "Fecha de creación"

#: src/features/api/components/CaptaApiUsersList.tsx:103
msgid "Fecha de Creación"
msgstr "Fecha de Creación"

#: src/features/devices2/utils/getOrderByOptions.ts:32
msgid "Fecha de creación (Asc)"
msgstr "Fecha de creación (Asc)"

#: src/features/gates/components/Gates.tsx:44
#: src/features/users/utils/filterOptions.ts:49
msgid "Fecha de Creación (Asc)"
msgstr "Fecha de Creación (Asc)"

#: src/features/devices2/utils/getOrderByOptions.ts:36
msgid "Fecha de creación (Desc)"
msgstr "Fecha de creación (Desc)"

#: src/features/gates/components/Gates.tsx:45
#: src/features/users/utils/filterOptions.ts:56
msgid "Fecha de Creación (Desc)"
msgstr "Fecha de Creación (Desc)"

#: src/features/deviceProfile/components/page/Support.tsx:126
msgid "Fecha de descarga"
msgstr "Fecha de descarga"

#: src/features/audit/utils/parseProperty.ts:107
msgid "fecha de inicio"
msgstr "fecha de inicio"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:65
msgid "Fecha de Pago"
msgstr "Fecha de Pago"

#: src/features/billing/components/modals/ServiceFileManager.tsx:58
msgid "Fecha de Próximo Pago"
msgstr "Fecha de Próximo Pago"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:407
msgid "Fecha de realización"
msgstr "Fecha de realización"

#: src/features/audit/utils/parseProperty.ts:13
msgid "fecha de última modificación"
msgstr "fecha de última modificación"

#: src/features/api/components/CaptaApiUsersList.tsx:106
msgid "Fecha de Última Modificación"
msgstr "Fecha de Última Modificación"

#: src/features/billing/components/payments/PaymentForm.tsx:147
msgid "Fecha del pago"
msgstr "Fecha del pago"

#: src/features/reportProblem/components/ReportProblemDialog.tsx:155
msgid "Fecha del reporte"
msgstr "Fecha del reporte"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:226
msgid "Fecha en que comienza el servicio, en formato 'AAAA-MM-DD'."
msgstr "Fecha en que comienza el servicio, en formato 'AAAA-MM-DD'."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:191
msgid "Fecha en que debe realizarse el pago de la factura, en formato 'AAAA-MM-DD'."
msgstr "Fecha en que debe realizarse el pago de la factura, en formato 'AAAA-MM-DD'."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:231
msgid "Fecha en que finaliza el servicio, en formato 'AAAA-MM-DD'."
msgstr "Fecha en que finaliza el servicio, en formato 'AAAA-MM-DD'."

#: src/features/billing/components/payments/PaymentRow.tsx:103
#: src/features/gateAdministration/components/MovementHistory.tsx:85
msgid "Fecha finalización"
msgstr "Fecha finalización"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:66
msgid "Fecha Finalización"
msgstr "Fecha Finalización"

#: src/features/billing/components/payments/PaymentRow.tsx:102
msgid "Fecha inicio"
msgstr "Fecha inicio"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:63
msgid "Fecha Inicio"
msgstr "Fecha Inicio"

#: src/features/audit/utils/parseProperty.ts:42
msgid "fecha modificación"
msgstr "fecha modificación"

#: src/features/billing/components/modals/ServiceFileManager.tsx:163
msgid "Fecha programada para el siguiente pago en formato 'AAAA-MM-DD'."
msgstr "Fecha programada para el siguiente pago en formato 'AAAA-MM-DD'."

#: src/features/gateAdministration/components/MovementHistory.tsx:82
msgid "Fecha solicitud"
msgstr "Fecha solicitud"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:39
msgid "Fecha y Hora"
msgstr "Fecha y Hora"

#: src/components/TablePaginationActions.tsx:94
#: src/components/TablePaginationActions.tsx:99
msgid "Filas"
msgstr "Filas"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:104
msgid "Filtrar"
msgstr "Filtrar"

#: src/features/announcements/components/AnnouncementsView.tsx:109
#: src/features/announcements/components/AnnouncementsView.tsx:139
msgid "Filtrar por categoría"
msgstr "Filtrar por categoría"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:366
msgid "Filtro de Velocidad Fuera de Rango"
msgstr "Filtro de Velocidad Fuera de Rango"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:125
#: src/features/audit/components/AuditLogsSidebar.tsx:82
#: src/features/billing/components/administration/Filters.tsx:41
#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:79
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:321
msgid "Filtros"
msgstr "Filtros"

#: src/features/deviceSupport/components/FilterConfig.tsx:42
msgid "Filtros actualizados correctamente"
msgstr "Filtros actualizados correctamente"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:250
#: src/features/deviceConfiguration/components/DeviceConfiguration.tsx:218
msgid "Filtros avanzados"
msgstr "Filtros avanzados"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:116
msgid "Filtros por características"
msgstr "Filtros por características"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:103
msgid "Filtros por números de lote"
msgstr "Filtros por números de lote"

#: src/features/reports/components/ReportHistory.tsx:280
msgid "Fin"
msgstr "Fin"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:193
msgid "Finalización"
msgstr "Finalización"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:79
msgid "Finalización del Servicio"
msgstr "Finalización del Servicio"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1041
msgid "Flecha"
msgstr "Flecha"

#: src/features/alertsNotificationsHistory/hooks/useTranslations.ts:9
#: src/features/metricsViews/components/widgets/TableWidget.tsx:104
msgid "Flujo"
msgstr "Flujo"

#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:242
msgid "Flujo de desborde: {formattedValue}"
msgstr "Flujo de desborde: {formattedValue}"

#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:252
msgid "Flujo máximo de distribución: {formattedValue}"
msgstr "Flujo máximo de distribución: {formattedValue}"

#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:240
msgid "Flujo máximo: {formattedValue}"
msgstr "Flujo máximo: {formattedValue}"

#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:238
msgid "Flujo mínimo: {formattedValue}"
msgstr "Flujo mínimo: {formattedValue}"

#: src/components/LastDistributionData.tsx:108
msgid "Flujo Total Actual"
msgstr "Flujo Total Actual"

#: src/utils/getUnitTranslation.ts:88
#: src/utils/units.ts:127
msgid "fnu"
msgstr "fnu"

#: src/utils/getUnitTranslation.ts:87
#: src/utils/units.ts:126
msgid "FNU"
msgstr "FNU"

#: src/features/userPreferences/components/RegionTab.tsx:214
msgid "Formato de fecha"
msgstr "Formato de fecha"

#: src/features/userPreferences/components/RegionTab.tsx:253
msgid "Formato de hora"
msgstr "Formato de hora"

#: src/features/userPreferences/components/RegionTab.tsx:279
msgid "Formato de mes"
msgstr "Formato de mes"

#: src/features/userPreferences/components/RegionTab.tsx:172
msgid "Formato de números"
msgstr "Formato de números"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:587
msgid "Fórmula"
msgstr "Fórmula"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:280
#: src/features/users/components/modals/SaveUserModal.tsx:122
#: src/features/userSaveModal/components/UserSaveModal.tsx:268
msgid "Foto de perfil"
msgstr "Foto de perfil"

#: src/features/devices2/components/list/itemPanel/DeviceItemPicture.tsx:113
msgid "Foto del dispositivo"
msgstr "Foto del dispositivo"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:831
msgid "Franjas estado de conexión"
msgstr "Franjas estado de conexión"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:94
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:84
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:186
msgid "Frecuencia"
msgstr "Frecuencia"

#: src/features/deviceProfile/components/modal/Status.tsx:240
msgid "Frecuencia de envíos"
msgstr "Frecuencia de envíos"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:97
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:255
msgid "Frecuencia de notificaciones"
msgstr "Frecuencia de notificaciones"

#: src/features/dga/components/modals/reports/ChartModal.tsx:73
msgid "Frecuencia de reporte cada una hora"
msgstr "Frecuencia de reporte cada una hora"

#: src/features/dga/components/modals/reports/ChartModal.tsx:77
msgid "Frecuencia de reporte diaria"
msgstr "Frecuencia de reporte diaria"

#: src/features/dga/components/modals/reports/ChartModal.tsx:85
msgid "Frecuencia de reporte mensual"
msgstr "Frecuencia de reporte mensual"

#: src/features/dga/components/modals/reports/ChartModal.tsx:81
msgid "Frecuencia de reporte semanal"
msgstr "Frecuencia de reporte semanal"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:263
msgid "Frecuencia para volver a enviar notificaciones"
msgstr "Frecuencia para volver a enviar notificaciones"

#: src/features/audit/utils/parseProperty.ts:28
msgid "fuente"
msgstr "fuente"

#. Origen de un evento en un dispositivo
#: src/features/devicesAnalysis/components/panel/Chart.tsx:263
msgctxt "source"
msgid "Fuente"
msgstr "Fuente"

#: src/features/events/components/HeaderTable.tsx:28
msgid "Fuente"
msgstr "Fuente"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:20
msgid "Fuente de alimentación"
msgstr "Fuente de alimentación"

#: src/features/events/components/EventsFilter.tsx:22
msgid "Fuente de evento"
msgstr "Fuente de evento"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:249
#: src/features/deviceConfiguration/data/sectionFields.ts:36
#: src/features/deviceConfiguration/data/sectionInputs.ts:38
#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:68
#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:67
#: src/features/deviceProfile/components/DeviceProfile.tsx:53
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:73
msgid "General"
msgstr "General"

#: src/features/userSaveModal/components/UserSaveModal.tsx:356
msgid "Generar"
msgstr "Generar"

#: src/features/api/components/ApiUsers.tsx:22
#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:24
msgid "Generar Credencial API"
msgstr "Generar Credencial API"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:695
msgid "Global"
msgstr "Global"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:217
msgid "Gráfico"
msgstr "Gráfico"

#: src/features/devices2/components/list/DGAItem.tsx:93
#: src/features/devices2/components/list/itemPanel/SMAItemMenu.tsx:79
msgid "Gráfico de reportes"
msgstr "Gráfico de reportes"

#: src/features/dga/components/modals/reports/ChartModal.tsx:148
msgid "Gráfico de reportes DGA"
msgstr "Gráfico de reportes DGA"

#: src/features/dga/components/modals/reports/ChartModal.tsx:99
msgid "Gráfico de reportes DGA {0}"
msgstr "Gráfico de reportes DGA {0}"

#: src/features/sma/components/SmaSuccessTableModal.tsx:123
msgid "Gráfico de reportes SMA"
msgstr "Gráfico de reportes SMA"

#: src/features/sma/components/SmaSuccessTableModal.tsx:67
msgid "Gráfico de reportes SMA {0}"
msgstr "Gráfico de reportes SMA {0}"

#: src/features/controlCenter/components/panel/CheckboxList.tsx:29
msgid "Gráficos de energía"
msgstr "Gráficos de energía"

#: src/components/modal/ModalActions.tsx:78
#: src/features/billing/components/modals/PaymentsFileManager.tsx:100
#: src/features/billing/components/modals/ServiceFileManager.tsx:77
#: src/features/billing/components/table/ProjectsTable.tsx:296
#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:123
#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:92
#: src/features/controlCenter/components/window/DialogDragAndDrop.tsx:178
#: src/features/deviceCommands/components/calendar/UpdateCommandKeyDialog.tsx:83
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:109
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:142
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:553
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:179
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:228
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:386
#: src/features/deviceSupport/components/FieldsConfig.tsx:119
#: src/features/deviceSupport/components/FilterAdvance.tsx:202
#: src/features/deviceSupport/components/FilterConfig.tsx:114
#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:305
#: src/features/metricsViews/components/EditViewModal.tsx:131
#: src/features/organizationAccess/components/OrganizationAccess.tsx:130
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:254
#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:213
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:164
#: src/features/userPreferences/components/MetricsTab.tsx:311
#: src/features/userPreferences/components/RegionTab.tsx:319
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:451
msgid "Guardar"
msgstr "Guardar"

#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:196
#: src/features/billing/components/payments/PaymentSummary.tsx:167
#: src/features/metricsViews/components/SaveWidgetModal.tsx:340
msgid "Guardar cambios"
msgstr "Guardar cambios"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:434
msgid "Guardar curva"
msgstr "Guardar curva"

#: src/features/metricsViews/components/MetricsView.tsx:272
msgid "Guardar Layout"
msgstr "Guardar Layout"

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:221
msgid "Guardar y Crear Reporte"
msgstr "Guardar y Crear Reporte"

#: src/components/NotificationsPopover.tsx:193
msgid "ha comentado en"
msgstr "ha comentado en"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:42
msgid "Ha ocurrido un error al actualizar los permisos"
msgstr "Ha ocurrido un error al actualizar los permisos"

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:48
msgid "Ha ocurrido un error al deshabilitar la credencial."
msgstr "Ha ocurrido un error al deshabilitar la credencial."

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:50
msgid "Ha ocurrido un error al habilitar la credencial"
msgstr "Ha ocurrido un error al habilitar la credencial"

#: src/features/gateAdministration/components/GateMovementBanner.tsx:89
msgid "ha sido detenida"
msgstr "ha sido detenida"

#: src/features/gateAdministration/components/GateMovementBanner.tsx:89
msgid "ha terminado de moverse"
msgstr "ha terminado de moverse"

#: src/features/audit/utils/parseProperty.ts:14
msgid "habilitado"
msgstr "habilitado"

#: src/features/api/components/CaptaApiUsersList.tsx:187
#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:123
#: src/features/organizationAccess/components/OrganizationAccessTable.tsx:31
msgid "Habilitar"
msgstr "Habilitar"

#: src/features/deviceSupport/components/FieldsConfig.tsx:74
msgid "Habilitar Campos"
msgstr "Habilitar Campos"

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:79
msgid "Habilitar credencial API"
msgstr "Habilitar credencial API"

#: src/features/audit/utils/getActionTypeOptions.ts:250
msgid "Habilitar Envío de DGA"
msgstr "Habilitar Envío de DGA"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:55
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:157
msgid "Habilitar envíos DGA"
msgstr "Habilitar envíos DGA"

#: src/features/deviceSupport/components/FilterConfig.tsx:71
msgid "Habilitar Filtros"
msgstr "Habilitar Filtros"

#: src/features/audit/utils/getDisplayNameActionType.ts:402
msgid "habilitó el envío de DGA"
msgstr "habilitó el envío de DGA"

#: src/features/deviceConfiguration/data/sectionInputs.ts:355
msgid "hardwareConfiguration.IMEI"
msgstr "hardwareConfiguration.IMEI"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:247
#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:217
#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:97
#: src/features/sma/components/SendReportsByEmailModal.tsx:100
msgid "Hasta"
msgstr "Hasta"

#: src/features/standardDesign/components/DateTimeRangePicker.tsx:416
msgid "Hasta (vacío para 'ahora')"
msgstr "Hasta (vacío para 'ahora')"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:117
msgid "Hasta {0}"
msgstr "Hasta {0}"

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:73
msgid "Hemos detectado que la cuenta de AMARU presenta un saldo pendiente. Favor contactar al servicio de post-venta de Capta Hydro:"
msgstr "Hemos detectado que la cuenta de AMARU presenta un saldo pendiente. Favor contactar al servicio de post-venta de Capta Hydro:"

#: src/features/alertsNotificationsHistory/components/AlertsNotificationsHistory.tsx:49
#: src/pages/alerts/history.tsx:9
msgid "Historial de alertas"
msgstr "Historial de alertas"

#: src/components/optionsMenu/dialogs/movementHistory/GateMovementHistory.tsx:17
msgid "Historial de movimientos"
msgstr "Historial de movimientos"

#: src/pages/billing/PaymentsView.tsx:9
msgid "Historial de Pagos"
msgstr "Historial de Pagos"

#: src/utils/units.ts:176
msgid "hm³"
msgstr "hm³"

#: src/pages/authentication/index.tsx:76
msgid "Hola {0} {1}, hemos enviado un correo a tu email con el código de Autenticación en dos pasos, debes ingresar el código para iniciar sesión de forma segura. En ocasiones los correos se encuentra en la capeta SPAM, no olvides revisarla."
msgstr "Hola {0} {1}, hemos enviado un correo a tu email con el código de Autenticación en dos pasos, debes ingresar el código para iniciar sesión de forma segura. En ocasiones los correos se encuentra en la capeta SPAM, no olvides revisarla."

#: src/features/audit/utils/parseProperty.ts:82
msgid "homologado"
msgstr "homologado"

#: src/features/deviceConfiguration/data/sectionFields.ts:359
#: src/features/deviceConfiguration/data/sectionInputs.ts:382
msgid "Homologado"
msgstr "Homologado"

#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:141
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:163
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:265
msgid "Hora"
msgstr "Hora"

#: src/features/deviceSupport/components/SupportTableBody.tsx:224
msgid "Horas"
msgstr "Horas"

#: src/features/deviceProfile/components/page/Support.tsx:170
#: src/features/deviceSupport/data/column.ts:103
msgid "Horas con datos"
msgstr "Horas con datos"

#: src/features/deviceProfile/components/page/modularComponents/index.tsx:30
msgid "Housing"
msgstr "Housing"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:59
msgid "Hoy"
msgstr "Hoy"

#: src/features/gateAdministration/components/MoveGate.tsx:153
msgid "Hubo un error"
msgstr "Hubo un error"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:66
msgid "Hubo un error al activar el usuario"
msgstr "Hubo un error al activar el usuario"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:56
#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:64
msgid "Hubo un error al actualizar el canal de irrigación"
msgstr "Hubo un error al actualizar el canal de irrigación"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:99
msgid "Hubo un error al actualizar las alertas"
msgstr "Hubo un error al actualizar las alertas"

#: src/features/deviceConfigurationModal/components/gateTab/alarm/UpdateAlarm.tsx:38
msgid "Hubo un error al actualizar: {0}"
msgstr "Hubo un error al actualizar: {0}"

#: src/features/api/components/ApiUsersList.tsx:33
#: src/features/api/components/CaptaApiUsersList.tsx:53
msgid "Hubo un error al cargar sus credenciales de API"
msgstr "Hubo un error al cargar sus credenciales de API"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:44
msgid "Hubo un error al crear el canal de irrigación"
msgstr "Hubo un error al crear el canal de irrigación"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:132
msgid "Hubo un error al desactivar las alertas"
msgstr "Hubo un error al desactivar las alertas"

#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:23
msgid "Hubo un error al desactivar las alertas: {0}"
msgstr "Hubo un error al desactivar las alertas: {0}"

#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:66
msgid "Hubo un error al editar la plantilla. Intente de nuevo."
msgstr "Hubo un error al editar la plantilla. Intente de nuevo."

#: src/features/irrigations/components/DeleteIrrigation.tsx:13
#: src/features/irrigations/components/DeleteIrrigation.tsx:20
#: src/features/irrigations/components/DeleteIrrigation.tsx:27
msgid "Hubo un error al eliminar el canal de irrigación"
msgstr "Hubo un error al eliminar el canal de irrigación"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:50
msgid "Hubo un error al eliminar la credencial."
msgstr "Hubo un error al eliminar la credencial."

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:25
msgid "Hubo un error al generar la url de activación"
msgstr "Hubo un error al generar la url de activación"

#: src/features/login/components/Login.tsx:69
msgid "Hubo un error al iniciar sesión. Por favor, inténtelo de nuevo. Si el problema continúa, por favor contacte soporte."
msgstr "Hubo un error al iniciar sesión. Por favor, inténtelo de nuevo. Si el problema continúa, por favor contacte soporte."

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:52
msgid "Hubo un error en la solicitud del reporte, por favor intente nuevamente"
msgstr "Hubo un error en la solicitud del reporte, por favor intente nuevamente"

#: src/features/reports/components/ReportHistory.tsx:129
msgid "Hubo un error obteniendo el archivo"
msgstr "Hubo un error obteniendo el archivo"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:37
#: src/features/billing/components/modals/PaymentsFileManager.tsx:134
#: src/features/billing/components/modals/ServiceFileManager.tsx:31
#: src/features/billing/components/modals/ServiceFileManager.tsx:111
#: src/features/billing/components/modals/ServiceFileManager.tsx:236
msgid "Hubo un problema al realizar la operación. Por favor, inténtelo nuevamente. Si el problema persiste, contacte al administrador."
msgstr "Hubo un problema al realizar la operación. Por favor, inténtelo nuevamente. Si el problema persiste, contacte al administrador."

#: src/features/audit/utils/parseProperty.ts:143
#: src/features/deviceConfiguration/data/sectionFields.ts:424
#: src/features/deviceConfiguration/data/sectionInputs.ts:435
msgid "ICCID"
msgstr "ICCID"

#: src/features/deviceSupport/data/filter.ts:9
msgid "ICN"
msgstr "ICN"

#: src/features/audit/utils/parseProperty.ts:19
#: src/features/billing/components/table/DevicesTable.tsx:156
#: src/features/deviceConfiguration/data/tableColumns.ts:4
#: src/features/deviceSupport/data/column.ts:15
#: src/features/deviceSupport/data/fields.ts:7
#: src/features/irrigations/components/Table.tsx:63
msgid "ID"
msgstr "ID"

#: src/features/devices2/utils/getOrderByOptions.ts:16
#: src/features/gates/components/Gates.tsx:42
#: src/features/users/utils/filterOptions.ts:21
msgid "ID (Asc)"
msgstr "ID (Asc)"

#: src/features/devices2/utils/getOrderByOptions.ts:20
#: src/features/gates/components/Gates.tsx:43
#: src/features/users/utils/filterOptions.ts:28
msgid "ID (Desc)"
msgstr "ID (Desc)"

#: src/features/audit/utils/parseProperty.ts:23
msgid "ID de componente padre"
msgstr "ID de componente padre"

#: src/features/audit/utils/parseProperty.ts:105
msgid "ID de configuración"
msgstr "ID de configuración"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:416
msgid "ID de confirmación: {confirmationId}"
msgstr "ID de confirmación: {confirmationId}"

#: src/features/audit/utils/parseProperty.ts:45
msgid "ID de dispositivo"
msgstr "ID de dispositivo"

#: src/features/audit/utils/parseProperty.ts:24
msgid "ID de dispositivo lógico"
msgstr "ID de dispositivo lógico"

#: src/features/audit/utils/parseProperty.ts:93
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:48
msgid "ID de Emnify"
msgstr "ID de Emnify"

#: src/features/audit/utils/parseProperty.ts:32
msgid "ID de ICN"
msgstr "ID de ICN"

#: src/features/audit/utils/parseProperty.ts:140
msgid "id de la cuenta"
msgstr "id de la cuenta"

#: src/features/audit/utils/parseProperty.ts:58
msgid "ID de modbus de flujo"
msgstr "ID de modbus de flujo"

#: src/features/audit/utils/parseProperty.ts:50
msgid "ID de modbus de nivel"
msgstr "ID de modbus de nivel"

#: src/features/audit/utils/parseProperty.ts:54
msgid "ID de modbus de velocidad"
msgstr "ID de modbus de velocidad"

#: src/features/audit/utils/parseProperty.ts:17
#: src/features/audit/utils/parseProperty.ts:26
msgid "ID de organización"
msgstr "ID de organización"

#: src/features/audit/utils/parseProperty.ts:129
msgid "ID de rol"
msgstr "ID de rol"

#: src/features/audit/utils/parseProperty.ts:106
msgid "ID de usuario"
msgstr "ID de usuario"

#: src/features/deviceConfigurationModal/components/deleteDeviceModal/DeleteDeviceModal.tsx:139
msgid "ID del dispositivo"
msgstr "ID del dispositivo"

#: src/features/audit/utils/parseProperty.ts:25
msgid "ID del nodo"
msgstr "ID del nodo"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:32
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:162
msgid "ID dispositivo"
msgstr "ID dispositivo"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:73
#: src/features/billing/components/modals/ServiceFileManager.tsx:54
#: src/features/billing/components/table/ServicesTable.tsx:53
msgid "ID Dispositivo"
msgstr "ID Dispositivo"

#: src/features/deviceConfiguration/data/sectionFields.ts:405
#: src/features/deviceConfiguration/data/sectionInputs.ts:408
msgid "ID Emnify"
msgstr "ID Emnify"

#: src/features/billing/components/payments/PaymentsTable.tsx:40
msgid "ID proyecto"
msgstr "ID proyecto"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:63
#: src/features/billing/components/modals/ServiceFileManager.tsx:53
#: src/features/billing/components/table/ServicesTable.tsx:52
msgid "ID Proyecto"
msgstr "ID Proyecto"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:68
msgid "Ideal para analizar dispositivos en terreno."
msgstr "Ideal para analizar dispositivos en terreno."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:176
msgid "Identificador único de la factura."
msgstr "Identificador único de la factura."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:201
#: src/features/billing/components/modals/ServiceFileManager.tsx:138
msgid "Identificador único del dispositivo asociado al servicio."
msgstr "Identificador único del dispositivo asociado al servicio."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:171
msgid "Identificador único del proyecto asociado a la factura."
msgstr "Identificador único del proyecto asociado a la factura."

#: src/features/billing/components/modals/ServiceFileManager.tsx:143
msgid "Identificador único del proyecto relacionado con el servicio."
msgstr "Identificador único del proyecto relacionado con el servicio."

#: src/features/userPreferences/components/RegionTab.tsx:134
msgid "Idioma"
msgstr "Idioma"

#: src/features/userPreferences/components/UserPreferencesModal.tsx:28
msgid "Idioma y región"
msgstr "Idioma y región"

#: src/features/audit/utils/parseProperty.ts:43
msgid "imagen"
msgstr "imagen"

#: src/features/userProfile/components/UserProfile.tsx:152
#: src/features/userProfile/components/UserProfile.tsx:216
msgid "Imagen de organización"
msgstr "Imagen de organización"

#: src/components/ImagePreviewModal.tsx:24
#: src/features/deviceProfile/components/modal/Info.tsx:47
#: src/features/deviceProfile/components/modal/Info.tsx:62
#: src/features/deviceProfile/components/page/Header.tsx:41
#: src/features/userMenu/components/UserMenu.tsx:58
#: src/features/userMenu/components/UserMenu.tsx:83
#: src/features/userProfile/components/UserProfile.tsx:73
msgid "Imagen de perfil"
msgstr "Imagen de perfil"

#: src/components/OrganizationAvatar.tsx:53
#: src/components/UserAvatar.tsx:29
msgid "Imagen de perfil de usuario"
msgstr "Imagen de perfil de usuario"

#: src/components/PicturePreview.tsx:93
msgid "Imagen de telemetría"
msgstr "Imagen de telemetría"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:310
msgid "Imagen del dispositivo"
msgstr "Imagen del dispositivo"

#: src/features/audit/utils/parseProperty.ts:142
msgid "imei"
msgstr "imei"

#: src/features/deviceConfiguration/data/sectionFields.ts:338
msgid "IMEI"
msgstr "IMEI"

#: src/features/users/utils/filterOptions.ts:113
msgid "Inactivo"
msgstr "Inactivo"

#: src/features/integrations/components/integrationBarChart/index.tsx:78
msgid "Incidencias"
msgstr "Incidencias"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:154
msgid "Indica las relaciones que deseas agregar"
msgstr "Indica las relaciones que deseas agregar"

#: src/features/integrations/utils/writeExecutionLogSeverityAttributes.ts:53
msgid "Info"
msgstr "Info"

#: src/features/users/components/UsersTable.tsx:74
msgid "Información"
msgstr "Información"

#: src/features/audit/utils/parseProperty.ts:29
msgid "información de fuente"
msgstr "información de fuente"

#: src/features/deviceCommands/components/calendar/ScheduleDetailsDialog.tsx:64
msgid "Información del Comando Programado"
msgstr "Información del Comando Programado"

#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:108
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:108
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:173
msgid "Información del usuario"
msgstr "Información del usuario"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:107
msgid "Información DGA"
msgstr "Información DGA"

#: src/features/deviceSupport/data/column.ts:9
#: src/features/deviceSupport/data/column.ts:17
#: src/features/deviceSupport/data/column.ts:25
#: src/features/deviceSupport/data/column.ts:33
msgid "Información dispositivo"
msgstr "Información dispositivo"

#: src/features/alertsConfiguration/components/AlertTable.tsx:179
#: src/features/userProfile/components/UserProfile.tsx:101
#: src/features/userProfile/components/UserProfileSkeleton.tsx:44
msgid "Información general"
msgstr "Información general"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:227
msgid "Ingresa una lista de números de lote. No es necesario que sean exactos; por ejemplo, al escribir \"68\", se mostrarán dispositivos con números de lote que contengan esa secuencia, como \"236849\"."
msgstr "Ingresa una lista de números de lote. No es necesario que sean exactos; por ejemplo, al escribir \"68\", se mostrarán dispositivos con números de lote que contengan esa secuencia, como \"236849\"."

#: src/features/deviceMenu/components/DeviceMenu.tsx:136
msgid "Ingreso manual de datos"
msgstr "Ingreso manual de datos"

#: src/pages/authentication/index.tsx:34
#: src/pages/authentication/index.tsx:69
msgid "Iniciar sesión"
msgstr "Iniciar sesión"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:179
#: src/features/reports/components/ReportHistory.tsx:276
msgid "Inicio"
msgstr "Inicio"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:178
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:280
msgid "Inicio de envíos"
msgstr "Inicio de envíos"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:78
msgid "Inicio del Servicio"
msgstr "Inicio del Servicio"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:164
#: src/features/billing/components/modals/ServiceFileManager.tsx:131
msgid "Instrucciones para las columnas del archivo CSV"
msgstr "Instrucciones para las columnas del archivo CSV"

#: src/utils/devices/formatSourceColor.ts:23
#: src/utils/formatSource.ts:14
msgid "Integración"
msgstr "Integración"

#: src/pages/sma/index.tsx:9
msgid "Integración con SMA"
msgstr "Integración con SMA"

#: src/pages/dga.tsx:9
msgid "Integración con Software MEE - DGA"
msgstr "Integración con Software MEE - DGA"

#: src/components/layout/DashboardSidebar.tsx:117
#: src/features/devices2/components/DevicesHeader.tsx:52
#: src/features/organizationAccess/data/sections.ts:37
#: src/pages/integrations/index.tsx:10
msgid "Integraciones"
msgstr "Integraciones"

#: src/features/audit/utils/parseProperty.ts:166
msgid "internet satelital"
msgstr "internet satelital"

#: src/features/gateAdministration/components/index.tsx:540
msgid "Intervalo"
msgstr "Intervalo"

#: src/features/controlCenter/components/window/Window.tsx:445
msgid "Intervalo (segundos)"
msgstr "Intervalo (segundos)"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:43
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:46
msgid "Intervalo de actualización automática"
msgstr "Intervalo de actualización automática"

#: src/features/alertsConfiguration/components/AlertRow.tsx:45
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:112
#: src/features/alertsNotificationsHistory/hooks/useTranslations.ts:11
msgid "Intruso"
msgstr "Intruso"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:293
msgid "Invasivo"
msgstr "Invasivo"

#: src/features/deviceConfiguration/data/sectionFields.ts:436
#: src/features/deviceConfiguration/data/sectionInputs.ts:450
msgid "IP"
msgstr "IP"

#: src/features/gates/components/list/GateListItemMetrics.tsx:46
#: src/features/gates/components/list/GateListItemMetrics.tsx:113
msgid "Ir a análisis de estaciones"
msgstr "Ir a análisis de estaciones"

#: src/features/audit/utils/getDisplayNameEntity.ts:10
msgid "irrigación"
msgstr "irrigación"

#: src/features/deviceProfile/components/modal/Info.tsx:117
msgid "Irrigación"
msgstr "Irrigación"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:84
msgid "Irrigaciones"
msgstr "Irrigaciones"

#: src/features/reports/utils/schedules.ts:15
msgid "jueves"
msgstr "jueves"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:137
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:117
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:219
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:84
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:89
#: src/utils/i18n/getDgaTranslations.ts:10
msgid "Jueves"
msgstr "Jueves"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:23
msgid "Julio"
msgstr "Julio"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:22
msgid "Junio"
msgstr "Junio"

#: src/utils/units.ts:151
msgid "kg"
msgstr "kg"

#: src/utils/units.ts:152
msgid "kilogram"
msgstr "kilogram"

#: src/features/irrigations/components/Table.tsx:75
msgid "KML"
msgstr "KML"

#: src/features/audit/utils/parseProperty.ts:34
msgid "KML de ICN"
msgstr "KML de ICN"

#: src/utils/getUnitTranslation.ts:35
#: src/utils/units.ts:61
msgid "L"
msgstr "L"

#: src/utils/getUnitTranslation.ts:11
#: src/utils/units.ts:31
msgid "L/s"
msgstr "L/s"

#: src/utils/units.ts:161
msgid "L/s por acc"
msgstr "L/s por acc"

#: src/features/gateAdministration/components/GateMovementBanner.tsx:88
msgid "La compuerta"
msgstr "La compuerta"

#: src/features/gateAdministration/components/GateMovementBanner.tsx:81
msgid "La compuerta <0>{gateName}</0> se está moviendo"
msgstr "La compuerta <0>{gateName}</0> se está moviendo"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:134
msgid "La configuración de notificaciones DGA ha sido actualizada"
msgstr "La configuración de notificaciones DGA ha sido actualizada"

#: src/features/metricsViews/components/CreateViewModal.tsx:36
#: src/features/metricsViews/components/EditViewModal.tsx:46
msgid "La configuración de visualización de métricas ha sido guardada correctamente"
msgstr "La configuración de visualización de métricas ha sido guardada correctamente"

#: src/features/userSaveModal/utils/schema.ts:50
msgid "La confirmación de contraseña es requerida."
msgstr "La confirmación de contraseña es requerida."

#: src/features/userSaveModal/utils/schema.ts:29
msgid "La contraseña debe tener al menos 10 caracteres, una mayúscula, una minúscula, un número y un caracter especial."
msgstr "La contraseña debe tener al menos 10 caracteres, una mayúscula, una minúscula, un número y un caracter especial."

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:76
msgid "La contraseña debe tener por lo menos 6 caracteres"
msgstr "La contraseña debe tener por lo menos 6 caracteres"

#: src/features/sma/components/SmaUpsertModal.tsx:45
msgid "La contraseña es requerida"
msgstr "La contraseña es requerida"

#: src/features/userSaveModal/utils/schema.ts:47
msgid "La contraseña es requerida."
msgstr "La contraseña es requerida."

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:97
msgid "La cuenca del río es requerida"
msgstr "La cuenca del río es requerida"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:67
msgid "La descripción es requerida"
msgstr "La descripción es requerida"

#: src/features/organizationCreateOrUpdate/utils/schema.ts:9
msgid "La direccion es requerida."
msgstr "La direccion es requerida."

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:104
msgid "La expresión matemática es inválida: {0}"
msgstr "La expresión matemática es inválida: {0}"

#: src/features/billing/utils/validationSchema.ts:16
msgid "La fecha de finalización no puede ser igual o anterior a la fecha de inicio."
msgstr "La fecha de finalización no puede ser igual o anterior a la fecha de inicio."

#: src/features/alertsNotificationsHistory/components/Filters.tsx:36
msgid "La fecha no puede ser mayor a la fecha actual."
msgstr "La fecha no puede ser mayor a la fecha actual."

#: src/features/organizationCreateOrUpdate/utils/schema.ts:18
#: src/features/userSaveModal/utils/schema.ts:56
msgid "La imagen debe pesar menos de 5MB."
msgstr "La imagen debe pesar menos de 5MB."

#: src/features/organizationCreateOrUpdate/utils/schema.ts:23
#: src/features/userSaveModal/utils/schema.ts:61
msgid "La imagen debe ser un archivo de tipo JPG, JPEG o PNG."
msgstr "La imagen debe ser un archivo de tipo JPG, JPEG o PNG."

#: src/features/integrations/components/devicesList/index.tsx:50
msgid "La integración no tiene dispositivos asociados"
msgstr "La integración no tiene dispositivos asociados"

#: src/components/gates/StopMovementConfirmation.tsx:64
msgid "La operación compuerta {gateName} no pudo ser cancelada."
msgstr "La operación compuerta {gateName} no pudo ser cancelada."

#: src/features/userSaveModal/utils/schema.ts:13
msgid "La organización es requerida."
msgstr "La organización es requerida."

#: src/features/organizationsManagement/components/Organizations.tsx:70
msgid "La organización ha sido actualizada correctamente"
msgstr "La organización ha sido actualizada correctamente"

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:128
msgid "La plantilla ha sido creada correctamente"
msgstr "La plantilla ha sido creada correctamente"

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:101
msgid "La plantilla ha sido creada correctamente y su reporte será enviado por correo electrónico en breve"
msgstr "La plantilla ha sido creada correctamente y su reporte será enviado por correo electrónico en breve"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:91
msgid "La región es requerida"
msgstr "La región es requerida"

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:41
msgid "La solicitud de reporte a sido enviada correctamente. Pronto recibirá el reporte en los emails seleccionados."
msgstr "La solicitud de reporte a sido enviada correctamente. Pronto recibirá el reporte en los emails seleccionados."

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:378
msgid "La zona horaria utilizada para la programación, es la de su navegador que es"
msgstr "La zona horaria utilizada para la programación, es la de su navegador que es"

#: src/features/userPreferences/components/RegionTab.tsx:271
msgid "Largo"
msgstr "Largo"

#: src/features/userSaveModal/utils/schema.ts:33
msgid "Las contraseñas deben coincidir."
msgstr "Las contraseñas deben coincidir."

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:82
#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:102
msgid "Las contraseñas no coinciden"
msgstr "Las contraseñas no coinciden"

#: src/features/audit/utils/parseProperty.ts:30
msgid "latitud"
msgstr "latitud"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:293
msgid "Latitud"
msgstr "Latitud"

#: src/features/metricsViews/components/MetricsView.tsx:165
msgid "Layout guardado correctamente"
msgstr "Layout guardado correctamente"

#: src/features/api/components/ApiUsersList.tsx:63
#: src/features/api/components/CaptaApiUsersList.tsx:97
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:133
#: src/features/api/components/dialogs/EditApiUserDialog.tsx:100
msgid "Lectura"
msgstr "Lectura"

#: src/features/audit/utils/parseProperty.ts:15
msgid "lectura de dispositivo"
msgstr "lectura de dispositivo"

#: src/features/notifications/components/NotificationsPopup.tsx:231
msgid "Leídos"
msgstr "Leídos"

#: src/hooks/useI18n.ts:41
msgid "Lenguaje actualizado correctamente"
msgstr "Lenguaje actualizado correctamente"

#: src/features/userPreferences/components/RegionTab.tsx:234
msgid "Lenguaje de fecha"
msgstr "Lenguaje de fecha"

#: src/features/userPreferences/components/RegionTab.tsx:192
msgid "Lenguaje de números"
msgstr "Lenguaje de números"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:471
msgid "Límite de filas"
msgstr "Límite de filas"

#: src/features/controlCenter/components/panel/Minicharts.tsx:276
msgid "Límite de reparto de caudal"
msgstr "Límite de reparto de caudal"

#: src/features/echarts/utils/commonSeries.ts:398
#: src/features/echarts/utils/commonSeries.ts:399
msgid "Límite inferior de curvas de aforo"
msgstr "Límite inferior de curvas de aforo"

#: src/features/echarts/utils/commonSeries.ts:385
#: src/features/echarts/utils/commonSeries.ts:386
msgid "Límite superior de curvas de aforo"
msgstr "Límite superior de curvas de aforo"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:35
msgid "Límites de abertura"
msgstr "Límites de abertura"

#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:73
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:106
msgid "Límites de Caudal"
msgstr "Límites de Caudal"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:254
#: src/features/echarts/utils/commonSeries.ts:365
#: src/features/echarts/utils/commonSeries.ts:366
msgid "Límites de curvas de aforo"
msgstr "Límites de curvas de aforo"

#: src/features/reports/utils/metricHelpers.ts:26
msgid "Límites de Curvas de Calibración"
msgstr "Límites de Curvas de Calibración"

#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:74
msgid "Límites y alarma"
msgstr "Límites y alarma"

#: src/features/deviceSupport/components/FilterAdvance.tsx:178
msgid "Limpiar campos"
msgstr "Limpiar campos"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:171
msgid "Limpiar filtros"
msgstr "Limpiar filtros"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:898
msgid "Línea"
msgstr "Línea"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1082
msgid "Línea escalonada"
msgstr "Línea escalonada"

#: src/pages/gates/administration/[gateId].tsx:31
msgid "Lista de compuertas"
msgstr "Lista de compuertas"

#: src/features/billing/components/projectService/Create.tsx:134
msgid "Lista de servicios a agregar"
msgstr "Lista de servicios a agregar"

#: src/pages/systems/administrator.tsx:45
msgid "Lista de sistemas"
msgstr "Lista de sistemas"

#: src/features/metricsViews/components/MetricsView.tsx:279
msgid "Lista de visualizaciones"
msgstr "Lista de visualizaciones"

#: src/features/metricsViews/components/MetricsViewListModal.tsx:17
msgid "Lista de visualizaciones configuradas"
msgstr "Lista de visualizaciones configuradas"

#: src/pages/metrics-views/index.tsx:10
msgid "Lista de visualizaciones de métricas"
msgstr "Lista de visualizaciones de métricas"

#: src/features/events/components/EventsTable.tsx:90
msgid "Listado completo"
msgstr "Listado completo"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:395
msgid "Listado de Filtros"
msgstr "Listado de Filtros"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:139
msgid "Listado de irrigaciones:"
msgstr "Listado de irrigaciones:"

#: src/utils/getUnitTranslation.ts:36
#: src/utils/units.ts:62
msgid "liter"
msgstr "liter"

#: src/utils/getUnitTranslation.ts:12
#: src/utils/units.ts:32
msgid "liter per second"
msgstr "liter per second"

#: src/utils/units.ts:162
msgid "liter per second per action"
msgstr "liter per second per action"

#: src/features/audit/components/AuditLogsTimeline.tsx:351
msgid "Llegaste al inicio de los tiempos"
msgstr "Llegaste al inicio de los tiempos"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:66
msgid "Logo"
msgstr "Logo"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:183
msgid "Logo de la organización (opcional)"
msgstr "Logo de la organización (opcional)"

#: src/features/audit/utils/parseProperty.ts:31
msgid "longitud"
msgstr "longitud"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:305
msgid "Longitud"
msgstr "Longitud"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:72
msgid "Los alias del dispositivo se han actualizado correctamente"
msgstr "Los alias del dispositivo se han actualizado correctamente"

#: src/features/userSaveModal/utils/schema.ts:38
msgid "Los apellidos son requeridos."
msgstr "Los apellidos son requeridos."

#: src/components/modal/ConfirmationModal.tsx:44
#: src/components/modal/ConfirmationModal.tsx:50
msgid "Los cambios que hayas realizado no se guardarán."
msgstr "Los cambios que hayas realizado no se guardarán."

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:98
msgid "Los días de semana"
msgstr "Los días de semana"

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:14
#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:13
msgid "Los elementos de Piecewise deben tener un valor mínimo que coincida con el valor máximo del elemento anterior"
msgstr "Los elementos de Piecewise deben tener un valor mínimo que coincida con el valor máximo del elemento anterior"

#: src/features/deviceCommands/components/calendar/ScheduleDetailsDialog.tsx:69
msgid "Los siguientes comandos están programados para las {scheduleMomentTime} horas del día {scheduleMomentDate}"
msgstr "Los siguientes comandos están programados para las {scheduleMomentTime} horas del día {scheduleMomentDate}"

#: src/features/billing/components/modals/ServiceFileManager.tsx:148
msgid "Los valores aceptados son DGA, SMA, PDA, SOS, INTEGRATION, SIRA, REGIS y RENTAL."
msgstr "Los valores aceptados son DGA, SMA, PDA, SOS, INTEGRATION, SIRA, REGIS y RENTAL."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:53
msgid "Los valores finales serán calculados al crear cada pago."
msgstr "Los valores finales serán calculados al crear cada pago."

#: src/features/reports/utils/schedules.ts:12
msgid "lunes"
msgstr "lunes"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:134
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:114
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:216
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:81
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:86
#: src/utils/i18n/getDgaTranslations.ts:7
msgid "Lunes"
msgstr "Lunes"

#: src/utils/getUnitTranslation.ts:23
#: src/utils/units.ts:46
msgid "m"
msgstr "m"

#: src/utils/getUnitTranslation.ts:39
#: src/utils/units.ts:66
msgid "m³"
msgstr "m³"

#: src/utils/getUnitTranslation.ts:19
#: src/utils/units.ts:41
msgid "m³/h"
msgstr "m³/h"

#: src/utils/getUnitTranslation.ts:15
#: src/utils/units.ts:36
msgid "m³/s"
msgstr "m³/s"

#: src/utils/units.ts:166
msgid "m³/s/acción"
msgstr "m³/s/acción"

#: src/features/deviceConfiguration/data/sectionFields.ts:446
#: src/features/deviceConfiguration/data/sectionInputs.ts:464
msgid "MAC"
msgstr "MAC"

#: src/features/billing/components/administration/Toolbar.tsx:102
#: src/features/billing/components/service/Administration.tsx:59
msgid "Mantenedor de servicios"
msgstr "Mantenedor de servicios"

#: src/features/deviceProfile/components/page/lifeHistory/index.tsx:65
msgid "mantenimiento"
msgstr "mantenimiento"

#: src/utils/devices/getDeviceStatusFormat.ts:13
msgid "Mantenimiento"
msgstr "Mantenimiento"

#: src/features/audit/utils/parseProperty.ts:64
msgid "marca de alimentación"
msgstr "marca de alimentación"

#: src/features/deviceConfiguration/data/sectionInputs.ts:285
msgid "Marca de alimentación"
msgstr "Marca de alimentación"

#: src/features/deviceConfiguration/data/sectionFields.ts:267
msgid "Marca fuente DC"
msgstr "Marca fuente DC"

#: src/features/reports/utils/schedules.ts:13
msgid "martes"
msgstr "martes"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:135
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:115
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:217
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:82
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:87
#: src/utils/i18n/getDgaTranslations.ts:8
msgid "Martes"
msgstr "Martes"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:19
msgid "Marzo"
msgstr "Marzo"

#: src/features/deviceSupport/components/SupportMenu.tsx:57
msgid "Más Filtros"
msgstr "Más Filtros"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:352
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:320
msgid "Masa de nieve"
msgstr "Masa de nieve"

#: src/features/reports/utils/metricHelpers.ts:38
msgid "Masa de Nieve"
msgstr "Masa de Nieve"

#: src/features/alertsConfiguration/components/AlertRow.tsx:63
#: src/features/alertsConfiguration/components/AlertRow.tsx:94
msgid "Máxima"
msgstr "Máxima"

#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:78
#: src/features/deviceProfile/components/page/Alerts.tsx:102
msgid "Máximo"
msgstr "Máximo"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:21
msgid "Mayo"
msgstr "Mayo"

#: src/components/PicturePreview.tsx:173
msgid "Medido"
msgstr "Medido"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:60
#: src/features/dga/components/modals/reports/TableModal.tsx:159
#: src/features/events/components/HeaderTable.tsx:10
#: src/features/events/components/HeaderTable.tsx:25
#: src/features/sma/components/TableModal.tsx:192
msgid "Mensaje"
msgstr "Mensaje"

#: src/features/billing/utils/translations.ts:9
#: src/features/billing/utils/translations.ts:18
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:77
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:179
msgid "Mensual"
msgstr "Mensual"

#: src/utils/i18n/getDgaTranslations.ts:40
msgid "Mensual (día {0} a las {hourString})"
msgstr "Mensual (día {0} a las {hourString})"

#: src/features/reports/utils/schedules.ts:49
msgid "Mensualmente el primer {dayOfWeek} del mes a las {hoursMinutesStr} horas."
msgstr "Mensualmente el primer {dayOfWeek} del mes a las {hoursMinutesStr} horas."

#: src/features/reports/utils/schedules.ts:51
msgid "Mensualmente el último {dayOfWeek} del mes a las {hoursMinutesStr} horas."
msgstr "Mensualmente el último {dayOfWeek} del mes a las {hoursMinutesStr} horas."

#: src/features/alertsNotificationsHistory/components/Charts.tsx:310
msgid "Mes"
msgstr "Mes"

#: src/utils/getUnitTranslation.ts:24
#: src/utils/units.ts:47
msgid "meter"
msgstr "meter"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:574
msgid "Método"
msgstr "Método"

#: src/features/audit/utils/parseProperty.ts:161
msgid "método de conexión a internet"
msgstr "método de conexión a internet"

#: src/features/audit/utils/parseProperty.ts:162
msgid "método de conexión de datos"
msgstr "método de conexión de datos"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:389
msgid "Método utilizado"
msgstr "Método utilizado"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:165
#: src/features/sma/components/forFutureUse/DialogSmaUnitSummary.tsx:126
#: src/features/sma/components/TableModal.tsx:189
msgid "Métrica"
msgstr "Métrica"

#: src/features/dga/components/modals/reports/TableModal.tsx:156
#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:453
#: src/features/reports/components/DeviceMetricsSummary.tsx:29
#: src/features/reports/components/ReportHistory.tsx:85
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:315
msgid "Métricas"
msgstr "Métricas"

#: src/features/deviceProfile/components/page/Metrics.tsx:203
msgid "Métricas disponibles"
msgstr "Métricas disponibles"

#: src/utils/units.ts:156
msgid "mg/L"
msgstr "mg/L"

#: src/utils/getUnitTranslation.ts:104
#: src/utils/units.ts:147
msgid "microsiemens per centimeter"
msgstr "microsiemens per centimeter"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1098
msgid "Middle"
msgstr "Middle"

#: src/features/reports/utils/schedules.ts:14
msgid "miércoles"
msgstr "miércoles"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:136
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:116
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:218
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:83
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:88
#: src/utils/i18n/getDgaTranslations.ts:9
msgid "Miércoles"
msgstr "Miércoles"

#: src/utils/units.ts:157
msgid "milligram per liter"
msgstr "milligram per liter"

#: src/utils/getUnitTranslation.ts:32
#: src/utils/units.ts:57
msgid "millimeter"
msgstr "millimeter"

#: src/utils/getUnitTranslation.ts:44
#: src/utils/units.ts:72
msgid "millimeter per second"
msgstr "millimeter per second"

#: src/utils/units.ts:172
msgid "millisecond"
msgstr "millisecond"

#: src/utils/getUnitTranslation.ts:100
#: src/utils/units.ts:142
msgid "millisiemens per centimeter"
msgstr "millisiemens per centimeter"

#: src/utils/getUnitTranslation.ts:80
#: src/utils/units.ts:117
msgid "millivolt"
msgstr "millivolt"

#: src/features/alertsConfiguration/components/AlertRow.tsx:54
#: src/features/alertsConfiguration/components/AlertRow.tsx:85
msgid "Mínima"
msgstr "Mínima"

#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:66
#: src/features/deviceProfile/components/page/Alerts.tsx:96
msgid "Mínimo"
msgstr "Mínimo"

#: src/utils/getUnitTranslation.ts:31
#: src/utils/units.ts:56
msgid "mm"
msgstr "mm"

#: src/utils/getUnitTranslation.ts:43
#: src/utils/units.ts:71
msgid "mm/s"
msgstr "mm/s"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:417
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:180
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:196
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:215
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:231
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:250
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:266
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:285
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:301
msgid "Modbus ID"
msgstr "Modbus ID"

#: src/features/deviceConfiguration/data/sectionFields.ts:112
msgid "Modbus ID sensor de flujo"
msgstr "Modbus ID sensor de flujo"

#: src/features/deviceConfiguration/data/sectionFields.ts:56
msgid "Modbus ID sensor de nivel"
msgstr "Modbus ID sensor de nivel"

#: src/features/deviceConfiguration/data/sectionFields.ts:84
msgid "Modbus ID sensor de velocidad"
msgstr "Modbus ID sensor de velocidad"

#: src/features/audit/utils/parseProperty.ts:137
msgid "modelado matemático"
msgstr "modelado matemático"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:149
msgid "Modelamiento de caudal"
msgstr "Modelamiento de caudal"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:135
msgid "Modelamientos matemáticos"
msgstr "Modelamientos matemáticos"

#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:91
msgid "Modelamientos Matemáticos"
msgstr "Modelamientos Matemáticos"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:360
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:65
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:176
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:192
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:211
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:227
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:246
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:262
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:281
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:297
msgid "Modelo"
msgstr "Modelo"

#: src/features/audit/utils/parseProperty.ts:65
msgid "modelo controlador paneles"
msgstr "modelo controlador paneles"

#: src/features/audit/utils/parseProperty.ts:62
msgid "modelo de alimentación"
msgstr "modelo de alimentación"

#: src/features/deviceConfiguration/data/sectionInputs.ts:269
msgid "Modelo de alimentación"
msgstr "Modelo de alimentación"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:24
msgid "Modelo de antena"
msgstr "Modelo de antena"

#: src/features/audit/utils/parseProperty.ts:68
msgid "modelo de batería"
msgstr "modelo de batería"

#: src/features/deviceConfiguration/data/sectionFields.ts:175
#: src/features/deviceConfiguration/data/sectionInputs.ts:181
msgid "Modelo de batería"
msgstr "Modelo de batería"

#: src/features/audit/utils/parseProperty.ts:81
#: src/features/audit/utils/parseProperty.ts:163
msgid "modelo de conexión"
msgstr "modelo de conexión"

#: src/features/deviceConfiguration/data/sectionFields.ts:329
#: src/features/deviceConfiguration/data/sectionInputs.ts:342
msgid "Modelo de conexión"
msgstr "Modelo de conexión"

#: src/features/deviceConfiguration/data/sectionFields.ts:219
#: src/features/deviceConfiguration/data/sectionInputs.ts:225
msgid "Modelo de paneles solares"
msgstr "Modelo de paneles solares"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:72
msgid "Modelo de SIM"
msgstr "Modelo de SIM"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:113
msgid "Modelo fuente"
msgstr "Modelo fuente"

#: src/features/deviceConfiguration/data/sectionFields.ts:251
msgid "Modelo fuente DC"
msgstr "Modelo fuente DC"

#: src/features/audit/utils/parseProperty.ts:73
msgid "modelos de paneles solares"
msgstr "modelos de paneles solares"

#: src/features/announcements/components/AnnouncementsGeneralSettings.tsx:47
msgid "Modificar categorías"
msgstr "Modificar categorías"

#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:69
msgid "Modificar etiquetas de"
msgstr "Modificar etiquetas de"

#: src/pages/distribution/history.tsx:13
#: src/pages/distribution/index.tsx:12
msgid "Módulo reparto"
msgstr "Módulo reparto"

#: src/features/billing/components/modals/ServiceFileManager.tsx:56
msgid "Moneda"
msgstr "Moneda"

#: src/components/layout/DashboardSidebar.tsx:77
msgid "Monitoreo"
msgstr "Monitoreo"

#: src/features/billing/components/modals/ServiceFileManager.tsx:158
msgid "Monto del servicio en la moneda indicada."
msgstr "Monto del servicio en la moneda indicada."

#: src/features/deviceProfile/components/page/Permissions.tsx:77
msgid "Mostrar {0} usuarios más"
msgstr "Mostrar {0} usuarios más"

#: src/features/deviceAlertsModal/components/index.tsx:146
msgid "Mostrar configuración leída por el pipeline"
msgstr "Mostrar configuración leída por el pipeline"

#: src/features/audit/utils/parseProperty.ts:39
msgid "mostrar en lista DGA"
msgstr "mostrar en lista DGA"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:314
msgid "Mostrar mapa"
msgstr "Mostrar mapa"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1009
msgid "Mostrar símbolos"
msgstr "Mostrar símbolos"

#: src/features/controlCenter/components/window/Window.tsx:295
msgid "Mostrar sólo dispositivos del reparto"
msgstr "Mostrar sólo dispositivos del reparto"

#: src/features/gateAdministration/components/MoveGate.tsx:255
msgid "Mover"
msgstr "Mover"

#: src/features/gateAdministration/components/index.tsx:387
msgid "Mover compuerta"
msgstr "Mover compuerta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:305
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:172
msgid "Movimiento radial"
msgstr "Movimiento radial"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:306
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:48
msgid "Movimiento radial sin calibrar"
msgstr "Movimiento radial sin calibrar"

#: src/utils/units.ts:171
msgid "ms"
msgstr "ms"

#: src/utils/getUnitTranslation.ts:99
#: src/utils/units.ts:141
msgid "mS/cm"
msgstr "mS/cm"

#: src/utils/getUnitTranslation.ts:79
#: src/utils/units.ts:116
msgid "mV"
msgstr "mV"

#: src/features/deviceProfile/components/page/Alerts.tsx:47
msgid "nivel"
msgstr "nivel"

#: src/components/PicturePreview.tsx:124
#: src/components/PicturePreview.tsx:135
#: src/features/alertsConfiguration/components/AlertRow.tsx:39
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:104
#: src/features/alertsNotificationsHistory/hooks/useTranslations.ts:10
#: src/features/controlCenter/components/panel/Minicharts.tsx:344
#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:258
#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:58
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:53
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:323
#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:46
#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:307
#: src/features/devicesAnalysis/components/panel/Chart.tsx:292
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAlertLevelsCheckboxList.tsx:51
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarDGACheckboxList.tsx:37
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:82
#: src/features/dga/components/modals/reports/TableModal.tsx:242
#: src/features/metricsViews/components/SaveWidgetModal.tsx:424
#: src/features/metricsViews/components/SaveWidgetModal.tsx:813
#: src/features/metricsViews/components/widgets/TableWidget.tsx:105
#: src/utils/i18n/getMetricDisplayName.ts:7
msgid "Nivel"
msgstr "Nivel"

#: src/features/reports/utils/metricHelpers.ts:20
msgid "Nivel (H)"
msgstr "Nivel (H)"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:297
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:161
#: src/features/gateAdministration/components/GatePositionChart.tsx:162
#: src/features/gateAdministration/components/index.tsx:500
#: src/features/gateAdministration/components/index.tsx:512
#: src/features/gates/components/list/GateListItemMetrics.tsx:87
msgid "Nivel aguas abajo"
msgstr "Nivel aguas abajo"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:296
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:153
#: src/features/gateAdministration/components/GatePositionChart.tsx:147
#: src/features/gateAdministration/components/index.tsx:471
#: src/features/gateAdministration/components/index.tsx:483
#: src/features/gates/components/list/GateListItemMetrics.tsx:69
msgid "Nivel aguas arriba"
msgstr "Nivel aguas arriba"

#: src/features/echarts/utils/commonSeries.ts:351
msgid "Nivel alto"
msgstr "Nivel alto"

#: src/features/echarts/utils/commonSeries.ts:350
msgid "Nivel bajo"
msgstr "Nivel bajo"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:292
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:35
msgid "Nivel bruto"
msgstr "Nivel bruto"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:85
msgid "Nivel de calibración"
msgstr "Nivel de calibración"

#: src/features/audit/utils/parseProperty.ts:133
msgid "nivel de desborde"
msgstr "nivel de desborde"

#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:249
msgid "Nivel de desborde: {formattedValue}"
msgstr "Nivel de desborde: {formattedValue}"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:336
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:268
msgid "Nivel de nieve"
msgstr "Nivel de nieve"

#: src/features/reports/utils/metricHelpers.ts:28
msgid "Nivel de Nieve"
msgstr "Nivel de Nieve"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:336
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:169
msgid "Nivel de nieve bruto"
msgstr "Nivel de nieve bruto"

#: src/features/echarts/utils/commonSeries.ts:352
msgid "Nivel desborde"
msgstr "Nivel desborde"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:291
msgid "Nivel desborde (cm)"
msgstr "Nivel desborde (cm)"

#: src/features/reports/utils/metricHelpers.ts:14
msgid "Nivel DGA"
msgstr "Nivel DGA"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:51
msgid "Nivel freático"
msgstr "Nivel freático"

#: src/features/audit/utils/parseProperty.ts:132
msgid "nivel máximo"
msgstr "nivel máximo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:554
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:367
msgid "Nivel máximo"
msgstr "Nivel máximo"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:284
msgid "Nivel máximo (cm)"
msgstr "Nivel máximo (cm)"

#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:247
msgid "Nivel máximo: {formattedValue}"
msgstr "Nivel máximo: {formattedValue}"

#: src/features/audit/utils/parseProperty.ts:131
msgid "nivel mínimo"
msgstr "nivel mínimo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:548
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:351
msgid "Nivel mínimo"
msgstr "Nivel mínimo"

#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:277
msgid "Nivel mínimo (cm)"
msgstr "Nivel mínimo (cm)"

#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:245
msgid "Nivel mínimo: {formattedValue}"
msgstr "Nivel mínimo: {formattedValue}"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:90
msgid "Niveles de Alerta"
msgstr "Niveles de Alerta"

#: src/features/audit/components/AuditLogDetailsRow.tsx:24
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:103
msgid "No"
msgstr "No"

#: src/features/deviceProfile/components/page/common/InformationGrid.tsx:30
#: src/features/deviceProfile/components/page/DGAInfo.tsx:151
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:398
msgid "No asignado"
msgstr "No asignado"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:91
msgid "No configurado"
msgstr "No configurado"

#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:69
msgid "No es posible activar porque faltan valores de configuración. Complete los valores en \"Editar configuración DGA\" y vuelva a intentarlo."
msgstr "No es posible activar porque faltan valores de configuración. Complete los valores en \"Editar configuración DGA\" y vuelva a intentarlo."

#: src/features/devices2/components/list/itemPanel/DeviceItemPicture.tsx:133
msgid "No existe imagen para mostrar."
msgstr "No existe imagen para mostrar."

#: src/features/reports/components/creationSection/EditReportTemplate.tsx:20
msgid "No existe una plantilla con ese identificador"
msgstr "No existe una plantilla con ese identificador"

#: src/features/deviceAlertsModal/components/rawDataModal/index.tsx:33
msgid "No existen configuraciones para este dispositivo"
msgstr "No existen configuraciones para este dispositivo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:227
msgid "No existen curvas de aforo creadas."
msgstr "No existen curvas de aforo creadas."

#: src/features/gates/components/list/GateListItemLastMovement.tsx:21
msgid "No existen datos de movimientos"
msgstr "No existen datos de movimientos"

#: src/features/billing/components/payments/PaymentsTable.tsx:65
msgid "No existen pagos registrados."
msgstr "No existen pagos registrados."

#: src/features/deviceProfile/components/page/Audit.tsx:102
msgid "No existen registros"
msgstr "No existen registros"

#: src/features/deviceProfile/components/page/lifeHistory/index.tsx:75
msgid "No existen registros de estado antes de marzo del 2024"
msgstr "No existen registros de estado antes de marzo del 2024"

#: src/features/billing/components/UpdatePaymentView.tsx:94
msgid "No fue posible actualizar. El periodo de facturación a finalizado para uno o más servicios."
msgstr "No fue posible actualizar. El periodo de facturación a finalizado para uno o más servicios."

#: src/features/billing/components/CreatePaymentView.tsx:189
#: src/features/billing/components/UpdatePaymentView.tsx:225
msgid "No fue posible almacenar la factura."
msgstr "No fue posible almacenar la factura."

#: src/features/billing/components/payments/DeletePayment.tsx:33
msgid "No fue posible eliminar el pago. Intente nuevamente."
msgstr "No fue posible eliminar el pago. Intente nuevamente."

#: src/features/billing/components/payments/DeletePayment.tsx:31
msgid "No fue posible eliminar. El periodo de facturación a finalizado para uno o más servicios."
msgstr "No fue posible eliminar. El periodo de facturación a finalizado para uno o más servicios."

#: src/features/billing/components/payments/PaymentRow.tsx:177
msgid "No fue posible encontrar la dirección de la factura."
msgstr "No fue posible encontrar la dirección de la factura."

#: src/features/users/utils/filterOptions.ts:128
msgid "No ha accedido nunca"
msgstr "No ha accedido nunca"

#: src/features/standardDesign/components/StandardMenu.tsx:69
msgid "No hay acciones disponibles"
msgstr "No hay acciones disponibles"

#: src/features/deviceProfile/components/modal/RecentActivity.tsx:62
#: src/features/userProfile/components/UserProfileAuditLogs.tsx:53
msgid "No hay actividad reciente"
msgstr "No hay actividad reciente"

#: src/features/deviceProfile/components/page/Alerts.tsx:61
#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:200
msgid "No hay alertas configuradas"
msgstr "No hay alertas configuradas"

#: src/features/deviceProfile/components/modal/Status.tsx:146
msgid "No hay alertas configuradas para este dispositivo"
msgstr "No hay alertas configuradas para este dispositivo"

#: src/features/deviceProfile/components/page/Alerts.tsx:153
msgid "No hay alertas gatilladas"
msgstr "No hay alertas gatilladas"

#: src/components/NotificationsPopover.tsx:282
msgid "No hay alertas."
msgstr "No hay alertas."

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/index.tsx:58
msgid "No hay calibraciones para este dispositivo"
msgstr "No hay calibraciones para este dispositivo"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:178
#: src/features/deviceProfile/components/page/Support.tsx:167
#: src/features/devices2/components/list/itemPanel/DGAItemChart.tsx:174
#: src/features/devices2/components/list/itemPanel/SMAItemChart.tsx:67
#: src/features/dga/components/modals/reports/TableModal.tsx:168
#: src/features/events/components/EventsTable.tsx:117
#: src/features/gateAdministration/components/index.tsx:158
#: src/features/gateAdministration/components/index.tsx:437
#: src/features/gateAdministration/components/index.tsx:476
#: src/features/gateAdministration/components/index.tsx:505
#: src/features/gateAdministration/components/MovementHistory.tsx:36
#: src/features/gates/components/list/GateListItemMetrics.tsx:126
#: src/features/metricsViews/components/widgets/DataWidget.tsx:87
#: src/features/metricsViews/components/widgets/DataWidget.tsx:151
#: src/features/metricsViews/components/widgets/TableWidget.tsx:76
#: src/features/sma/components/TableModal.tsx:201
msgid "No hay datos"
msgstr "No hay datos"

#: src/features/gates/components/list/GateListItemMinichart.tsx:118
msgid "No hay datos de energía en las últimas 6 horas"
msgstr "No hay datos de energía en las últimas 6 horas"

#: src/features/deviceProfile/components/page/events/index.tsx:152
msgid "No hay datos de eventos los últimos 3 meses"
msgstr "No hay datos de eventos los últimos 3 meses"

#: src/features/controlCenter/components/panel/Minicharts.tsx:449
msgid "No hay datos en el rango de tiempo seleccionado"
msgstr "No hay datos en el rango de tiempo seleccionado"

#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:374
msgid "No hay datos en las últimas 6 horas"
msgstr "No hay datos en las últimas 6 horas"

#: src/features/gateAdministration/components/GatePositionChart.tsx:24
msgid "No hay datos para mostrar"
msgstr "No hay datos para mostrar"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:120
msgid "no hay datos registrados"
msgstr "no hay datos registrados"

#: src/features/gateAdministration/components/index.tsx:485
#: src/features/gateAdministration/components/index.tsx:514
msgid "No hay datos registrados"
msgstr "No hay datos registrados"

#: src/features/integrations/components/devicesList/index.tsx:52
msgid "No hay dispositivos <0>con problemas</0>"
msgstr "No hay dispositivos <0>con problemas</0>"

#: src/features/devices2/components/DeviceList.tsx:57
msgid "No hay dispositivos que coincidan con los criterios de búsqueda."
msgstr "No hay dispositivos que coincidan con los criterios de búsqueda."

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:420
msgid "No hay dispositivos seleccionados"
msgstr "No hay dispositivos seleccionados"

#: src/features/billing/components/table/DevicesTable.tsx:118
msgid "No hay equipos configurados en este proyecto, dirígete a <0>configuración de equipos</0> para agregar proyectos a los dispositivos."
msgstr "No hay equipos configurados en este proyecto, dirígete a <0>configuración de equipos</0> para agregar proyectos a los dispositivos."

#: src/features/controlCenter/components/window/StationList.tsx:41
msgid "No hay estaciones para mostrar"
msgstr "No hay estaciones para mostrar"

#: src/features/deviceCommands/components/custom/DevicesSelector.tsx:25
msgid "No hay estaciones..."
msgstr "No hay estaciones..."

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:84
msgid "No hay logs disponibles para esta entidad"
msgstr "No hay logs disponibles para esta entidad"

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:80
msgid "No hay logs disponibles para esta integracion"
msgstr "No hay logs disponibles para esta integracion"

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:82
msgid "No hay logs disponibles para este dispositivo"
msgstr "No hay logs disponibles para este dispositivo"

#: src/features/deviceProfile/components/page/Audit.tsx:213
msgid "No hay más registros para este dispositivo"
msgstr "No hay más registros para este dispositivo"

#: src/features/gateAdministration/components/MovementHistory.tsx:140
msgid "No hay movimientos registrados"
msgstr "No hay movimientos registrados"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:321
msgid "No hay notificaciones asociadas a este equipo"
msgstr "No hay notificaciones asociadas a este equipo"

#: src/features/notifications/components/NotificationsPopup.tsx:343
msgid "No hay notificaciones nuevas"
msgstr "No hay notificaciones nuevas"

#: src/components/NotificationsPopover.tsx:212
msgid "No hay notificaciones."
msgstr "No hay notificaciones."

#: src/features/deviceProfile/components/modal/Observations.tsx:93
#: src/features/deviceProfile/components/page/Observations.tsx:100
msgid "No hay observaciones"
msgstr "No hay observaciones"

#: src/features/billing/components/table/ProjectsTable.tsx:140
msgid "No hay recurrentes asociados al proyecto"
msgstr "No hay recurrentes asociados al proyecto"

#: src/features/audit/components/AuditLogsTimeline.tsx:141
msgid "No hay registros de auditoría con los filtros seleccionados"
msgstr "No hay registros de auditoría con los filtros seleccionados"

#: src/features/userProfile/components/UserProfile.tsx:111
msgid "No hay teléfono registrado"
msgstr "No hay teléfono registrado"

#: src/features/deviceProfile/components/page/Permissions.tsx:40
msgid "No hay usuarios con acceso al dispositivo"
msgstr "No hay usuarios con acceso al dispositivo"

#: src/features/users/components/UsersTable.tsx:150
msgid "No hay usuarios que coincidan con los criterios de búsqueda."
msgstr "No hay usuarios que coincidan con los criterios de búsqueda."

#: src/features/metricsViews/components/MetricsView.tsx:363
msgid "No hay widgets configurados"
msgstr "No hay widgets configurados"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:277
msgid "No invasivo"
msgstr "No invasivo"

#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:42
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:49
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:66
msgid "No operativo"
msgstr "No operativo"

#: src/features/billing/utils/translations.ts:38
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:25
msgid "No registrado"
msgstr "No registrado"

#: src/features/announcements/components/AnnouncementView.tsx:33
msgid "No se encontró el anuncio"
msgstr "No se encontró el anuncio"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:427
msgid "No se envió la notificación correctamente"
msgstr "No se envió la notificación correctamente"

#: src/features/metricsViews/components/MetricsViewErrorBoundary.tsx:19
msgid "No se ha configurado la visualización de métricas para este dispositivo"
msgstr "No se ha configurado la visualización de métricas para este dispositivo"

#: src/components/tooltips/UserTooltip.tsx:64
msgid "No se ha encontrado al usuario con id {userId}"
msgstr "No se ha encontrado al usuario con id {userId}"

#: src/features/metricsViews/components/CreateViewModal.tsx:77
#: src/features/metricsViews/components/EditViewModal.tsx:86
msgid "No se ha encontrado el dispositivo {id}"
msgstr "No se ha encontrado el dispositivo {id}"

#: src/components/tooltips/DeviceTooltip.tsx:67
msgid "No se ha encontrado el dispositivo con id {deviceId}"
msgstr "No se ha encontrado el dispositivo con id {deviceId}"

#: src/features/billing/components/projectService/Create.tsx:59
msgid "No se ha encontrado ningún proyecto con el ID ingresado."
msgstr "No se ha encontrado ningún proyecto con el ID ingresado."

#: src/features/reports/components/CreatedReportNotification.tsx:46
msgid "No se ha podido completar la creación de reporte."
msgstr "No se ha podido completar la creación de reporte."

#: src/features/deviceProfile/components/page/Support.tsx:157
msgid "No se ha registrado un proveedor en configuración de equipos"
msgstr "No se ha registrado un proveedor en configuración de equipos"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:405
msgid "No se han configurado filtros."
msgstr "No se han configurado filtros."

#: src/features/dga/components/modals/tabs/MaxFlowTab.tsx:27
#: src/features/dga/components/modals/tabs/MaxFlowTab.tsx:31
msgid "No se pudo actualizar el caudal máximo"
msgstr "No se pudo actualizar el caudal máximo"

#: src/pages/AuthorizationRequired.tsx:35
msgid "No se pudo cerrar sesión"
msgstr "No se pudo cerrar sesión"

#: src/components/gates/StopMovementConfirmation.tsx:77
msgid "No se pudo enviar el comando"
msgstr "No se pudo enviar el comando"

#: src/features/gateAdministration/components/MoveGate.tsx:101
msgid "No se pudo enviar el comando de movimiento a la compuerta"
msgstr "No se pudo enviar el comando de movimiento a la compuerta"

#: src/features/recoveryPassword/components/RecoveryPassword.tsx:37
msgid "No se pudo enviar el correo electrónico. Verifique que el correo sea el correcto"
msgstr "No se pudo enviar el correo electrónico. Verifique que el correo sea el correcto"

#: src/features/users/components/modals/SimulateUserModal.tsx:35
msgid "No se pudo simular al usuario"
msgstr "No se pudo simular al usuario"

#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:63
msgid "No se puede crear. Faltan valores importantes para la creación. Por favor, intente nuevamente."
msgstr "No se puede crear. Faltan valores importantes para la creación. Por favor, intente nuevamente."

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:53
msgid "No se pueden repetir organizaciones"
msgstr "No se pueden repetir organizaciones"

#: src/components/ModalTabs.tsx:139
msgid "No tienes acceso a ninguna de las pestañas"
msgstr "No tienes acceso a ninguna de las pestañas"

#: src/pages/AuthorizationRequired.tsx:56
msgid "No tienes permisos para acceder a esta página"
msgstr "No tienes permisos para acceder a esta página"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:61
msgid "No tienes permisos para realizar esta acción"
msgstr "No tienes permisos para realizar esta acción"

#: src/features/audit/utils/parseProperty.ts:20
msgid "nombre"
msgstr "nombre"

#: src/components/PicturePreview.tsx:115
#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:137
#: src/features/alertsConfiguration/components/AlertTable.tsx:194
#: src/features/billing/components/table/DevicesTable.tsx:157
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:169
#: src/features/deviceProfile/components/page/General.tsx:27
#: src/features/deviceSupport/data/column.ts:23
#: src/features/deviceSupport/data/fields.ts:8
#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:188
#: src/features/irrigations/components/Table.tsx:66
#: src/features/metricsViews/components/MetricsViewList.tsx:32
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:192
#: src/features/organizationsManagement/components/OrganizationsTable.tsx:69
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:309
#: src/features/sma/components/forFutureUse/TableSmaUnit.tsx:39
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:288
#: src/features/users/components/modals/SaveUserModal.tsx:123
#: src/features/userSaveModal/components/UserSaveModal.tsx:275
msgid "Nombre"
msgstr "Nombre"

#: src/features/devices2/utils/getOrderByOptions.ts:8
#: src/features/gates/components/Gates.tsx:40
#: src/features/users/utils/filterOptions.ts:35
msgid "Nombre (A-Z)"
msgstr "Nombre (A-Z)"

#: src/features/devices2/utils/getOrderByOptions.ts:12
#: src/features/gates/components/Gates.tsx:41
#: src/features/users/utils/filterOptions.ts:42
msgid "Nombre (Z-A)"
msgstr "Nombre (Z-A)"

#: src/features/audit/utils/parseProperty.ts:97
msgid "nombre de hardware satelital"
msgstr "nombre de hardware satelital"

#: src/features/audit/utils/parseProperty.ts:33
msgid "nombre de ICN"
msgstr "nombre de ICN"

#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:143
msgid "Nombre de la plantilla"
msgstr "Nombre de la plantilla"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:761
msgid "Nombre de la serie"
msgstr "Nombre de la serie"

#: src/features/metricsViews/components/EditViewModal.tsx:110
msgid "Nombre de la vista"
msgstr "Nombre de la vista"

#: src/features/audit/utils/parseProperty.ts:27
msgid "nombre de organización"
msgstr "nombre de organización"

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:190
msgid "Nombre de plantilla"
msgstr "Nombre de plantilla"

#: src/features/audit/utils/parseProperty.ts:46
msgid "nombre de proyecto"
msgstr "nombre de proyecto"

#: src/features/audit/utils/parseProperty.ts:89
msgid "nombre de red"
msgstr "nombre de red"

#: src/features/deviceConfiguration/data/sectionFields.ts:482
#: src/features/deviceConfiguration/data/sectionInputs.ts:506
msgid "Nombre de red"
msgstr "Nombre de red"

#: src/features/audit/utils/parseProperty.ts:98
msgid "nombre de serie satelital"
msgstr "nombre de serie satelital"

#: src/features/audit/utils/parseProperty.ts:11
#: src/features/audit/utils/parseProperty.ts:122
msgid "nombre de usuario"
msgstr "nombre de usuario"

#: src/features/api/components/ApiUsersList.tsx:60
#: src/features/api/components/CaptaApiUsersList.tsx:91
#: src/features/api/components/dialogs/GeneratedUserApiSummary.tsx:29
msgid "Nombre de Usuario"
msgstr "Nombre de Usuario"

#: src/features/deviceConfiguration/data/sectionFields.ts:509
msgid "Nombre del Hardware"
msgstr "Nombre del Hardware"

#: src/features/deviceConfiguration/data/sectionFields.ts:13
#: src/features/deviceConfiguration/data/sectionInputs.ts:21
msgid "Nombre del proyecto"
msgstr "Nombre del proyecto"

#: src/features/billing/components/service/Update.tsx:66
msgid "Nombre del servicio"
msgstr "Nombre del servicio"

#: src/features/billing/components/service/Administration.tsx:85
msgid "Nombre del servicio a agregar"
msgstr "Nombre del servicio a agregar"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:33
msgid "Nombre dispositivo"
msgstr "Nombre dispositivo"

#: src/features/sma/components/forFutureUse/DialogSmaUnitSummary.tsx:120
msgid "Nombre Parámetro SMA"
msgstr "Nombre Parámetro SMA"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:193
msgid "Nombre Plantilla"
msgstr "Nombre Plantilla"

#: src/features/deviceConfiguration/data/sectionFields.ts:29
msgid "Nombre usuario"
msgstr "Nombre usuario"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:97
msgid "Normal"
msgstr "Normal"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:376
msgid "Nota"
msgstr "Nota"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:580
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:422
msgid "Notas"
msgstr "Notas"

#: src/features/notifications/components/NotificationsDeleteModal.tsx:24
msgid "Notificación eliminada correctamente"
msgstr "Notificación eliminada correctamente"

#: src/components/layout/DashboardSidebar.tsx:268
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:141
#: src/features/alertsConfiguration/components/AlertTable.tsx:182
#: src/features/alertsNotificationsHistory/components/Charts.tsx:138
#: src/features/deviceAlertsModal/components/index.tsx:116
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:91
#: src/pages/notifications/index.tsx:10
msgid "Notificaciones"
msgstr "Notificaciones"

#: src/features/deviceAlertsModal/components/alertConfigurationTab/useUpdateForm.ts:24
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/useUpdateForm.ts:22
msgid "Notificaciones actualizadas correctamente"
msgstr "Notificaciones actualizadas correctamente"

#: src/features/notifications/components/NotificationsSaveModal.tsx:215
msgid "Notificar a todos los usuarios"
msgstr "Notificar a todos los usuarios"

#: src/features/notifications/components/NotificationsSaveModal.tsx:221
msgid "Notificar sólo a clientes"
msgstr "Notificar sólo a clientes"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:27
msgid "Noviembre"
msgstr "Noviembre"

#: src/utils/getUnitTranslation.ts:84
#: src/utils/units.ts:122
msgid "ntu"
msgstr "ntu"

#: src/utils/getUnitTranslation.ts:83
#: src/utils/units.ts:121
msgid "NTU"
msgstr "NTU"

#: src/features/gateAdministration/components/MoveGate.tsx:170
msgid "Nueva abertura para la compuerta"
msgstr "Nueva abertura para la compuerta"

#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:63
msgid "Nueva credencial API"
msgstr "Nueva credencial API"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:80
msgid "Nueva Credencial API"
msgstr "Nueva Credencial API"

#: src/components/telemetry/regis/SimplePicturePreview.tsx:16
msgid "Nueva foto de medición para"
msgstr "Nueva foto de medición para"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1143
msgid "Nueva serie"
msgstr "Nueva serie"

#: src/features/announcements/components/AnnouncementsView.tsx:166
msgid "Nuevo Anuncio"
msgstr "Nuevo Anuncio"

#: src/features/deviceConfigurationModal/components/statusTab/index.tsx:61
#: src/features/deviceConfigurationModal/components/updateDeviceStatusModal/index.tsx:65
msgid "Nuevo estado"
msgstr "Nuevo estado"

#: src/features/notifications/components/NotificationsPopup.tsx:230
msgid "Nuevos"
msgstr "Nuevos"

#: src/features/billing/components/administration/Stats.tsx:28
msgid "nuevos proyectos este año"
msgstr "nuevos proyectos este año"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:61
msgid "Nulo"
msgstr "Nulo"

#: src/features/userPreferences/components/RegionTab.tsx:274
msgid "Numérico"
msgstr "Numérico"

#: src/features/dga/components/modals/reports/TableModal.tsx:207
#: src/features/sma/components/TableModal.tsx:240
msgid "Número comprobante: {0}"
msgstr "Número comprobante: {0}"

#: src/features/audit/utils/parseProperty.ts:91
msgid "número de candado"
msgstr "número de candado"

#: src/features/deviceConfiguration/data/sectionFields.ts:17
#: src/features/deviceConfiguration/data/sectionInputs.ts:26
msgid "Número de chapa"
msgstr "Número de chapa"

#: src/features/audit/utils/parseProperty.ts:101
msgid "número de código de Widgetlord"
msgstr "número de código de Widgetlord"

#: src/features/audit/utils/parseProperty.ts:66
msgid "número de controladores de paneles solares"
msgstr "número de controladores de paneles solares"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:61
#: src/features/billing/components/payments/PaymentForm.tsx:98
msgid "Número de Factura"
msgstr "Número de Factura"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:398
#: src/features/deviceConfiguration/data/sectionInputs.ts:58
#: src/features/deviceConfiguration/data/sectionInputs.ts:87
#: src/features/deviceConfiguration/data/sectionInputs.ts:112
msgid "Número de lote"
msgstr "Número de lote"

#: src/features/deviceConfiguration/data/sectionFields.ts:284
#: src/features/deviceConfiguration/data/sectionInputs.ts:303
msgid "Número de lote CPU"
msgstr "Número de lote CPU"

#: src/features/audit/utils/parseProperty.ts:76
msgid "número de lote de CPU"
msgstr "número de lote de CPU"

#: src/features/audit/utils/parseProperty.ts:59
msgid "número de lote de sensor de flujo"
msgstr "número de lote de sensor de flujo"

#: src/features/audit/utils/parseProperty.ts:51
msgid "número de lote de sensor de nivel"
msgstr "número de lote de sensor de nivel"

#: src/features/audit/utils/parseProperty.ts:55
msgid "número de lote de sensor de velocidad"
msgstr "número de lote de sensor de velocidad"

#: src/features/audit/utils/parseProperty.ts:79
msgid "número de lote de Strato"
msgstr "número de lote de Strato"

#: src/features/audit/utils/parseProperty.ts:102
msgid "número de lote de tarjeta SIM"
msgstr "número de lote de tarjeta SIM"

#: src/features/audit/utils/parseProperty.ts:100
msgid "número de lote de Widgetlord"
msgstr "número de lote de Widgetlord"

#: src/features/deviceConfiguration/data/sectionInputs.ts:318
msgid "Número de lote placa"
msgstr "Número de lote placa"

#: src/features/deviceConfiguration/data/sectionFields.ts:308
msgid "Número de lote placa auxiliar"
msgstr "Número de lote placa auxiliar"

#: src/features/deviceConfiguration/data/sectionFields.ts:119
msgid "Número de lote sensor de flujo"
msgstr "Número de lote sensor de flujo"

#: src/features/deviceConfiguration/data/sectionFields.ts:63
msgid "Número de lote sensor de nivel"
msgstr "Número de lote sensor de nivel"

#: src/features/deviceConfiguration/data/sectionFields.ts:91
msgid "Número de lote sensor de velocidad"
msgstr "Número de lote sensor de velocidad"

#: src/features/deviceConfiguration/data/sectionInputs.ts:369
msgid "Número de lote SIM"
msgstr "Número de lote SIM"

#: src/features/deviceConfiguration/data/sectionFields.ts:350
msgid "Número de lote SIM Card"
msgstr "Número de lote SIM Card"

#: src/features/deviceConfiguration/data/sectionFields.ts:292
msgid "Número de lote Widgetlord"
msgstr "Número de lote Widgetlord"

#: src/features/audit/utils/parseProperty.ts:74
msgid "número de paneles solares"
msgstr "número de paneles solares"

#: src/features/deviceProfile/components/page/General.tsx:90
msgid "Número de proyecto"
msgstr "Número de proyecto"

#: src/features/deviceConfiguration/data/sectionFields.ts:235
#: src/features/deviceConfiguration/data/sectionFields.ts:304
#: src/features/deviceConfiguration/data/sectionInputs.ts:51
#: src/features/deviceConfiguration/data/sectionInputs.ts:76
#: src/features/deviceConfiguration/data/sectionInputs.ts:105
#: src/features/deviceConfiguration/data/sectionInputs.ts:141
#: src/features/deviceConfiguration/data/sectionInputs.ts:249
#: src/features/deviceConfiguration/data/sectionInputs.ts:313
msgid "Número de serie"
msgstr "Número de serie"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:379
msgid "Número de Serie"
msgstr "Número de Serie"

#: src/features/deviceConfiguration/data/sectionFields.ts:143
msgid "Número de serie controlador solar"
msgstr "Número de serie controlador solar"

#: src/features/audit/utils/parseProperty.ts:63
msgid "número de serie de alimentación"
msgstr "número de serie de alimentación"

#: src/features/deviceConfiguration/data/sectionInputs.ts:277
msgid "Número de serie de alimentación"
msgstr "Número de serie de alimentación"

#: src/features/audit/utils/parseProperty.ts:57
msgid "número de serie de flujo"
msgstr "número de serie de flujo"

#: src/features/audit/utils/parseProperty.ts:49
msgid "número de serie de nivel"
msgstr "número de serie de nivel"

#: src/features/audit/utils/parseProperty.ts:53
msgid "número de serie de velocidad"
msgstr "número de serie de velocidad"

#: src/features/audit/utils/parseProperty.ts:99
msgid "número de serie de Widgetlord"
msgstr "número de serie de Widgetlord"

#: src/features/deviceConfiguration/data/sectionFields.ts:259
msgid "Número de serie fuente DC"
msgstr "Número de serie fuente DC"

#: src/features/deviceConfiguration/data/sectionFields.ts:105
msgid "Número de serie sensor de flujo"
msgstr "Número de serie sensor de flujo"

#: src/features/deviceConfiguration/data/sectionFields.ts:49
msgid "Número de serie sensor de nivel"
msgstr "Número de serie sensor de nivel"

#: src/features/deviceConfiguration/data/sectionFields.ts:77
msgid "Número de serie sensor de velocidad"
msgstr "Número de serie sensor de velocidad"

#: src/features/deviceConfiguration/data/sectionFields.ts:288
msgid "Número de serie Widgetlord"
msgstr "Número de serie Widgetlord"

#: src/features/audit/utils/parseProperty.ts:78
msgid "número de Strato"
msgstr "número de Strato"

#: src/features/audit/utils/parseProperty.ts:84
msgid "número de teléfono"
msgstr "número de teléfono"

#: src/features/deviceConfiguration/data/sectionFields.ts:377
#: src/features/users/components/modals/SaveUserModal.tsx:141
#: src/features/userSaveModal/components/UserSaveModal.tsx:333
msgid "Número de teléfono"
msgstr "Número de teléfono"

#: src/features/deviceConfiguration/data/sectionFields.ts:500
msgid "Número Serial del Hardware"
msgstr "Número Serial del Hardware"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:215
msgid "Números de lote"
msgstr "Números de lote"

#: src/features/audit/components/AuditLogDetailsRow.tsx:47
msgid "Objeto (?)"
msgstr "Objeto (?)"

#: src/features/audit/utils/parseProperty.ts:90
msgid "observación"
msgstr "observación"

#: src/features/deviceConfiguration/data/sectionFields.ts:33
#: src/features/deviceConfiguration/data/sectionInputs.ts:35
msgid "Observación"
msgstr "Observación"

#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:41
msgid "Observación actualizada correctamente"
msgstr "Observación actualizada correctamente"

#: src/features/deviceObservations/components/modals/CreateObservationModal.tsx:35
msgid "Observación creada correctamente"
msgstr "Observación creada correctamente"

#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:44
msgid "Observación eliminada correctamente"
msgstr "Observación eliminada correctamente"

#: src/features/deviceProfile/components/DeviceProfileModal.tsx:43
#: src/features/deviceProfile/components/page/Observations.tsx:52
msgid "Observaciones"
msgstr "Observaciones"

#: src/utils/roles.ts:19
msgid "Observador"
msgstr "Observador"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:108
msgid "Observadores"
msgstr "Observadores"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:26
msgid "Octubre"
msgstr "Octubre"

#: src/features/audit/components/AuditLogsTimeline.tsx:279
msgid "Ocultar detalles"
msgstr "Ocultar detalles"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:314
msgid "Ocultar mapa"
msgstr "Ocultar mapa"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:510
msgid "Ocultar usuarios"
msgstr "Ocultar usuarios"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:266
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:321
msgid "Offset (H0)"
msgstr "Offset (H0)"

#: src/features/announcements/components/AnnouncementMenu.tsx:34
#: src/features/announcements/components/AnnouncementsGeneralSettings.tsx:25
msgid "Opciones"
msgstr "Opciones"

#: src/features/deviceCommands/components/custom/CustomCommandsButtons.tsx:56
msgid "Opciones avanzadas"
msgstr "Opciones avanzadas"

#: src/pages/device-commands/advanced.tsx:9
msgid "Opciones Avanzadas"
msgstr "Opciones Avanzadas"

#: src/features/audit/utils/parseProperty.ts:125
msgid "opciones de configuración"
msgstr "opciones de configuración"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:126
msgid "Opciones gráfico"
msgstr "Opciones gráfico"

#: src/components/gates/StopMovementConfirmation.tsx:59
msgid "Operación compuerta {gateName} cancelada con éxito"
msgstr "Operación compuerta {gateName} cancelada con éxito"

#: src/features/deviceSupport/data/column.ts:95
#: src/features/deviceSupport/data/fields.ts:21
#: src/utils/roles.ts:18
msgid "Operador"
msgstr "Operador"

#: src/features/audit/utils/parseProperty.ts:83
#: src/features/audit/utils/parseProperty.ts:164
msgid "operador móvil"
msgstr "operador móvil"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:36
#: src/features/deviceConfiguration/data/sectionFields.ts:368
#: src/features/deviceConfiguration/data/sectionInputs.ts:395
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:44
msgid "Operador móvil"
msgstr "Operador móvil"

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:85
msgid "Operador satelital"
msgstr "Operador satelital"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:103
msgid "Operadores"
msgstr "Operadores"

#: src/features/gateAdministration/components/index.tsx:322
#: src/features/gateAdministration/components/MoveGate.tsx:58
msgid "Operar compuerta"
msgstr "Operar compuerta"

#: src/features/integrations/components/monitoredTargetSection/Status.tsx:76
#: src/features/integrations/components/monitoredTargetSection/Status.tsx:115
msgid "Operatividad hoy"
msgstr "Operatividad hoy"

#: src/features/changeSupportStatus/data/status.ts:6
#: src/features/deviceSupport/data/status.ts:24
#: src/features/deviceSupport/data/status.ts:55
#: src/features/integrations/components/integrationBarChart/index.tsx:78
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:35
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:60
msgid "Operativo"
msgstr "Operativo"

#: src/features/controlCenter/components/window/DialogDragAndDrop.tsx:87
msgid "Orden de dispositivos actualizado correctamente."
msgstr "Orden de dispositivos actualizado correctamente."

#: src/features/controlCenter/components/window/Window.tsx:335
msgid "Orden en alerta"
msgstr "Orden en alerta"

#: src/features/controlCenter/components/window/Window.tsx:332
msgid "Orden normal"
msgstr "Orden normal"

#: src/components/filters/OrderBy.tsx:19
#: src/features/standardDesign/components/listView/StandardListViewHeader.tsx:179
msgid "Ordenar"
msgstr "Ordenar"

#: src/features/controlCenter/components/window/DialogDragAndDrop.tsx:124
#: src/features/controlCenter/components/window/Window.tsx:459
msgid "Ordenar dispositivos"
msgstr "Ordenar dispositivos"

#: src/components/DeviceModalTitle.tsx:107
msgid "ORG"
msgstr "ORG"

#: src/components/DeviceModalTitle.tsx:159
msgid "ORG:"
msgstr "ORG:"

#: src/features/deviceSupport/data/filter.ts:8
msgid "Organizacion"
msgstr "Organizacion"

#: src/features/audit/utils/getDisplayNameEntity.ts:8
msgid "organización"
msgstr "organización"

#: src/components/layout/DashboardSidebar.tsx:284
#: src/features/api/components/ApiKeysList.tsx:36
#: src/features/api/components/CaptaApiUsersList.tsx:94
#: src/features/billing/utils/list.ts:9
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:225
#: src/features/deviceConfiguration/data/tableColumns.ts:8
#: src/features/deviceProfile/components/modal/Info.tsx:110
#: src/features/organizationAccess/components/OrganizationAccess.tsx:107
#: src/features/reportProblem/components/ReportProblemDialog.tsx:132
#: src/features/sma/components/forFutureUse/TableSmaUnit.tsx:44
#: src/features/userProfile/components/UserProfile.tsx:143
#: src/features/users/components/UsersTable.tsx:76
msgid "Organización"
msgstr "Organización"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:96
msgid "Organización actualizada correctamente."
msgstr "Organización actualizada correctamente."

#: src/features/audit/components/AuditLogsSidebar.tsx:174
msgid "Organización afectada"
msgstr "Organización afectada"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:84
msgid "Organización creada correctamente."
msgstr "Organización creada correctamente."

#: src/features/deviceProfile/components/page/General.tsx:56
msgid "Organización principal"
msgstr "Organización principal"

#: src/features/access/components/AccessView.tsx:27
#: src/features/userProfile/components/UserProfileSkeleton.tsx:55
#: src/pages/organizations/index.tsx:9
msgid "Organizaciones"
msgstr "Organizaciones"

#: src/features/userProfile/components/UserProfile.tsx:168
msgid "Organizaciones adicionales"
msgstr "Organizaciones adicionales"

#: src/features/users/components/UsersTable.tsx:77
#: src/features/users/utils/filterOptions.ts:86
#: src/features/users/utils/filterOptions.ts:91
msgid "Organizaciones compartidas"
msgstr "Organizaciones compartidas"

#: src/features/userSaveModal/components/UserSaveModal.tsx:445
msgid "Organizaciones compartidas por el usuario"
msgstr "Organizaciones compartidas por el usuario"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:435
#: src/features/metricsViews/components/SaveWidgetModal.tsx:858
#: src/features/metricsViews/components/widgets/TableWidget.tsx:116
#: src/features/reports/utils/metricHelpers.ts:23
msgid "ORP"
msgstr "ORP"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:104
msgid "ORP bruto"
msgstr "ORP bruto"

#: src/features/deviceSupport/data/column.ts:128
#: src/features/deviceSupport/data/column.ts:135
#: src/features/deviceSupport/data/column.ts:142
#: src/features/deviceSupport/data/column.ts:149
#: src/features/deviceSupport/data/column.ts:157
msgid "Otros indicadores"
msgstr "Otros indicadores"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:328
#: src/features/metricsViews/components/SaveWidgetModal.tsx:440
#: src/features/metricsViews/components/SaveWidgetModal.tsx:873
msgid "Oxígeno disuelto"
msgstr "Oxígeno disuelto"

#: src/features/reports/utils/metricHelpers.ts:15
msgid "Oxígeno Disuelto"
msgstr "Oxígeno Disuelto"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:441
#: src/features/metricsViews/components/SaveWidgetModal.tsx:876
msgid "Oxígeno disuelto (%)"
msgstr "Oxígeno disuelto (%)"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:225
msgid "Oxígeno disuelto (mg/L)"
msgstr "Oxígeno disuelto (mg/L)"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:328
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:117
msgid "Oxígeno disuelto bruto"
msgstr "Oxígeno disuelto bruto"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:238
msgid "Oxígeno disuelto saturación (%)"
msgstr "Oxígeno disuelto saturación (%)"

#: src/features/billing/utils/list.ts:38
#: src/features/billing/utils/translations.ts:35
msgid "Pagado"
msgstr "Pagado"

#: src/components/TablePaginationActions.tsx:80
#: src/components/TablePaginationActions.tsx:126
msgid "Página {0} de {1}"
msgstr "Página {0} de {1}"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:485
msgid "Paginación"
msgstr "Paginación"

#: src/features/billing/components/payments/DeletePayment.tsx:27
msgid "Pago eliminado correctamente."
msgstr "Pago eliminado correctamente."

#: src/features/billing/components/CreatePaymentView.tsx:73
#: src/features/billing/components/projectService/Create.tsx:54
#: src/features/billing/components/UpdatePaymentView.tsx:87
msgid "Pago registrado correctamente."
msgstr "Pago registrado correctamente."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:40
msgid "Pagos creados correctamente!"
msgstr "Pagos creados correctamente!"

#: src/features/gates/components/list/GateListItemInfo.tsx:36
#: src/pages/gates/administration/[gateId].tsx:20
#: src/pages/gates/administration/[gateId].tsx:34
msgid "Panel de operación"
msgstr "Panel de operación"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:57
msgid "Panel solar"
msgstr "Panel solar"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:73
msgid "Panel solar encapsulado"
msgstr "Panel solar encapsulado"

#: src/features/deviceConfiguration/data/sectionFields.ts:135
#: src/features/deviceConfiguration/data/sectionInputs.ts:129
msgid "Paneles solares"
msgstr "Paneles solares"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:88
msgid "Pantalla completa"
msgstr "Pantalla completa"

#: src/features/api/components/ApiKey.tsx:26
msgid "Para acceder a la API tiene que ocupar, además de un nombre de usuario y contraseña, una <0>API Key</0>. Está es una por organización y se genera una única vez cuando crea su primera credencial de la API. En el siguiente bloque se encuentra su API Key creada:"
msgstr "Para acceder a la API tiene que ocupar, además de un nombre de usuario y contraseña, una <0>API Key</0>. Está es una por organización y se genera una única vez cuando crea su primera credencial de la API. En el siguiente bloque se encuentra su API Key creada:"

#: src/features/userProfileUpdate/components/DisableUserModal.tsx:68
msgid "Para confirmar la acción, ingresa tu contraseña y presiona \"Confirmar\""
msgstr "Para confirmar la acción, ingresa tu contraseña y presiona \"Confirmar\""

#: src/features/billing/components/payments/PaymentSummary.tsx:142
msgid "para el proyecto con ID"
msgstr "para el proyecto con ID"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:106
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:80
msgid "Para generar las credenciales de API coloque una contraseña. Al generarse la credencial, va a obtener el nombre de usuario y API Key para utilizar la API."
msgstr "Para generar las credenciales de API coloque una contraseña. Al generarse la credencial, va a obtener el nombre de usuario y API Key para utilizar la API."

#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:97
msgid "Parámetros Radar"
msgstr "Parámetros Radar"

#: src/utils/i18n/getAlertSuccessOptions.ts:24
msgid "Parcialmente exitoso"
msgstr "Parcialmente exitoso"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:62
msgid "Pasado este tiempo de 4 horas, la configuración cambiará automáticamente al valor estándar seleccionado previamente (botones)."
msgstr "Pasado este tiempo de 4 horas, la configuración cambiará automáticamente al valor estándar seleccionado previamente (botones)."

#: src/features/billing/utils/list.ts:34
#: src/features/billing/utils/translations.ts:36
#: src/features/changeSupportStatus/data/status.ts:21
#: src/features/deviceSupport/data/status.ts:32
#: src/features/deviceSupport/data/status.ts:58
msgid "Pendiente"
msgstr "Pendiente"

#: src/utils/getUnitTranslation.ts:56
#: src/utils/units.ts:87
msgid "percent"
msgstr "percent"

#: src/features/devices2/components/list/itemPanel/DeviceItemInfo.tsx:180
#: src/features/userMenu/components/UserMenu.tsx:98
msgid "Perfil"
msgstr "Perfil"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:141
msgid "Perfil actualizado correctamente"
msgstr "Perfil actualizado correctamente"

#: src/pages/devices/[id].tsx:15
msgid "Perfil de Dispositivo"
msgstr "Perfil de Dispositivo"

#: src/features/deviceSupport/components/SupportTableBody.tsx:288
msgid "Perfil de equipo"
msgstr "Perfil de equipo"

#: src/features/billing/components/table/DevicesTable.tsx:164
#: src/features/billing/components/table/ProjectsTable.tsx:82
#: src/features/billing/components/table/ProjectsTable.tsx:287
msgid "Periodicidad"
msgstr "Periodicidad"

#. Label de selector general de rango de tiempos
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:637
#: src/features/standardDesign/components/DateTimeRangePicker.tsx:292
msgid "Período"
msgstr "Período"

#: src/features/metricsViews/components/widgets/ChartWidget.tsx:627
msgid "Período / Ventana"
msgstr "Período / Ventana"

#: src/features/metricsViews/components/MetricsView.tsx:336
#: src/features/metricsViews/components/MetricsView.tsx:342
msgid "Período relativo"
msgstr "Período relativo"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:122
msgid "Permisos"
msgstr "Permisos"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:33
msgid "Permisos actualizados exitosamente"
msgstr "Permisos actualizados exitosamente"

#: src/features/organizationAccess/data/sections.ts:41
msgid "Permisos y accesos"
msgstr "Permisos y accesos"

#: src/components/layout/DashboardSidebar.tsx:292
msgid "Permisos y Accesos"
msgstr "Permisos y Accesos"

#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:114
#: src/features/standardDesign/components/DateTimeRangePicker.tsx:37
msgid "Personalizado"
msgstr "Personalizado"

#: src/utils/getUnitTranslation.ts:76
#: src/utils/units.ts:112
msgid "ph"
msgstr "ph"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:318
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:202
#: src/features/metricsViews/components/widgets/TableWidget.tsx:115
#: src/features/reports/utils/metricHelpers.ts:24
#: src/utils/getUnitTranslation.ts:75
#: src/utils/units.ts:111
msgid "pH"
msgstr "pH"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:434
#: src/features/metricsViews/components/SaveWidgetModal.tsx:855
msgid "PH"
msgstr "PH"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:318
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:94
msgid "pH bruto"
msgstr "pH bruto"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:188
msgid "Piezorresistivo"
msgstr "Piezorresistivo"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1038
msgid "Pin"
msgstr "Pin"

#: src/features/audit/utils/parseProperty.ts:153
msgid "placa auxiliar"
msgstr "placa auxiliar"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:76
#: src/features/deviceConfiguration/data/sectionFields.ts:300
#: src/features/deviceConfiguration/data/sectionInputs.ts:308
msgid "Placa auxiliar"
msgstr "Placa auxiliar"

#: src/features/audit/utils/parseProperty.ts:167
msgid "plan de datos"
msgstr "plan de datos"

#: src/features/deviceConfiguration/data/sectionFields.ts:391
msgid "Plan de datos"
msgstr "Plan de datos"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:242
msgid "Planas"
msgstr "Planas"

#: src/features/reports/components/ReportHistory.tsx:79
msgid "Plantilla"
msgstr "Plantilla"

#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:56
msgid "Plantilla editada con éxito"
msgstr "Plantilla editada con éxito"

#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:34
msgid "Plantilla eliminada de forma exitosa"
msgstr "Plantilla eliminada de forma exitosa"

#: src/features/reports/components/DataExtraction.tsx:29
msgid "Plantillas"
msgstr "Plantillas"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:69
msgid "Polinomial (hasta orden 4)"
msgstr "Polinomial (hasta orden 4)"

#: src/features/announcements/components/AnnouncementsViewModal.tsx:73
msgid "por {author}"
msgstr "por {author}"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:49
msgid "Por 4 horas el equipo se configura con los siguientes valores:"
msgstr "Por 4 horas el equipo se configura con los siguientes valores:"

#: src/features/userPreferences/components/MetricsTab.tsx:144
msgid "Por defecto"
msgstr "Por defecto"

#: src/features/recoveryPassword/components/RecoveryPassword.tsx:65
msgid "Por favor ingrese su correo electrónico para recuperar su contraseña"
msgstr "Por favor ingrese su correo electrónico para recuperar su contraseña"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:23
msgid "Porcentaje batería"
msgstr "Porcentaje batería"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:309
msgid "Porcentaje Batería"
msgstr "Porcentaje Batería"

#: src/features/devices2/components/list/itemPanel/DGAItemChart.tsx:149
#: src/features/devices2/utils/getSmaChartOptions.ts:93
msgid "Porcentaje de éxito"
msgstr "Porcentaje de éxito"

#: src/features/audit/utils/parseProperty.ts:130
msgid "posición"
msgstr "posición"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:429
#: src/features/metricsViews/components/SaveWidgetModal.tsx:822
#: src/features/metricsViews/components/widgets/TableWidget.tsx:108
#: src/features/reports/utils/metricHelpers.ts:25
#: src/utils/i18n/getMetricDisplayName.ts:8
msgid "Posición"
msgstr "Posición"

#: src/features/gateAdministration/components/index.tsx:334
#: src/features/gateAdministration/components/index.tsx:340
msgid "Posición actual"
msgstr "Posición actual"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:145
msgid "Posición compuerta"
msgstr "Posición compuerta"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:54
#: src/features/gateAdministration/components/MovementHistory.tsx:73
msgid "Posición de inicio"
msgstr "Posición de inicio"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:922
#: src/features/metricsViews/components/SaveWidgetModal.tsx:927
msgid "Posición en grilla"
msgstr "Posición en grilla"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:57
#: src/features/gateAdministration/components/index.tsx:352
#: src/features/gateAdministration/components/MovementHistory.tsx:76
msgid "Posición final"
msgstr "Posición final"

#: src/features/gateAdministration/components/GateMovementBanner.tsx:95
msgid "Posición inicial"
msgstr "Posición inicial"

#: src/features/gateAdministration/components/GateMovementBanner.tsx:96
msgid "Posición objetivo"
msgstr "Posición objetivo"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:51
#: src/features/gateAdministration/components/MovementHistory.tsx:70
msgid "Posición solicitada"
msgstr "Posición solicitada"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:39
msgid "Potencia carga"
msgstr "Potencia carga"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:312
msgid "Potencia Carga"
msgstr "Potencia Carga"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:71
msgid "Potencia Panel"
msgstr "Potencia Panel"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:433
#: src/features/metricsViews/components/SaveWidgetModal.tsx:843
#: src/features/metricsViews/components/widgets/TableWidget.tsx:114
msgid "Potencia panel solar"
msgstr "Potencia panel solar"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:314
msgid "Potencia Panel Solar"
msgstr "Potencia Panel Solar"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:69
msgid "Potencia solar"
msgstr "Potencia solar"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:65
msgid "Potencial"
msgstr "Potencial"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:321
msgid "Potencial de oxidación-reducción"
msgstr "Potencial de oxidación-reducción"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:323
msgid "Potencial de oxidación-reducción bruto"
msgstr "Potencial de oxidación-reducción bruto"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:212
msgid "Potencial reducción oxidación (ORP)"
msgstr "Potencial reducción oxidación (ORP)"

#: src/features/userMenu/components/UserMenu.tsx:104
msgid "Preferencias"
msgstr "Preferencias"

#: src/features/userPreferences/components/MetricsTab.tsx:37
#: src/features/userPreferences/components/RegionTab.tsx:34
msgid "Preferencias actualizadas correctamente"
msgstr "Preferencias actualizadas correctamente"

#: src/features/userPreferences/components/UserPreferencesModal.tsx:77
msgid "Preferencias de usuario"
msgstr "Preferencias de usuario"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:400
#: src/features/metricsViews/components/SaveWidgetModal.tsx:289
msgid "Previsualización"
msgstr "Previsualización"

#: src/components/ImagePreviewModal.tsx:20
msgid "Previsualización de imagen"
msgstr "Previsualización de imagen"

#: src/components/FileInput.tsx:74
msgid "Previsualización de la imagen"
msgstr "Previsualización de la imagen"

#: src/features/metricsViews/components/MetricsView.tsx:243
msgid "Previsualización responsiva"
msgstr "Previsualización responsiva"

#: src/features/announcements/components/AnnouncementMenu.tsx:56
msgid "Previsualizar"
msgstr "Previsualizar"

#: src/features/audit/utils/parseProperty.ts:109
msgid "primer caudal repartible"
msgstr "primer caudal repartible"

#: src/features/integrations/components/integrationSection/index.tsx:63
msgid "Problemas de integración"
msgstr "Problemas de integración"

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:43
msgid "Programación eliminada correctamente"
msgstr "Programación eliminada correctamente"

#: src/features/reports/components/templateSection/ReportTemplateList.tsx:147
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:321
msgid "Programado"
msgstr "Programado"

#: src/features/reports/components/templateSection/ReportTemplateList.tsx:258
#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:67
msgid "Programados"
msgstr "Programados"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:397
msgid "Programar"
msgstr "Programar"

#: src/features/reports/components/templateSection/ReportTemplateList.tsx:268
msgid "Programar nuevo envío"
msgstr "Programar nuevo envío"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:248
msgid "Programar Plantilla"
msgstr "Programar Plantilla"

#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:308
#: src/features/deviceConfiguration/data/tableColumns.ts:20
msgid "Progreso"
msgstr "Progreso"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:324
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:225
msgid "Promediar datos por período"
msgstr "Promediar datos por período"

#. Análisis de estaciones - etiqueta de campo de selección de ventana de promedio
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:163
msgid "Promediar por periodo"
msgstr "Promediar por periodo"

#: src/features/reports/components/ReportHistory.tsx:286
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:131
msgid "Promedio de datos"
msgstr "Promedio de datos"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:538
msgid "Propiedad"
msgstr "Propiedad"

#: src/features/dga/components/modals/reports/ChartModal.tsx:130
#: src/features/sma/components/SmaSuccessTableModal.tsx:104
msgid "Próxima Semana"
msgstr "Próxima Semana"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:528
msgid "Próximamente"
msgstr "Próximamente"

#: src/features/billing/components/table/ServicesTableForTooltip.tsx:47
msgid "Próximo pago"
msgstr "Próximo pago"

#: src/features/billing/components/projectService/Delete.tsx:90
#: src/features/billing/components/table/DevicesTable.tsx:159
#: src/features/billing/components/table/ProjectsTable.tsx:78
#: src/features/billing/utils/list.ts:13
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:191
#: src/features/deviceConfiguration/data/tableColumns.ts:14
#: src/features/deviceProfile/components/modal/Info.tsx:121
msgid "Proyecto"
msgstr "Proyecto"

#: src/features/billing/components/table/ProjectsTable.tsx:277
msgid "Proyecto {0}"
msgstr "Proyecto {0}"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:80
msgid "Proyectos"
msgstr "Proyectos"

#: src/features/billing/components/administration/Stats.tsx:34
msgid "Proyectos con deuda"
msgstr "Proyectos con deuda"

#: src/features/billing/components/administration/Stats.tsx:17
msgid "Proyectos vendidos"
msgstr "Proyectos vendidos"

#: src/utils/devices/getDeviceStatusFormat.ts:21
msgid "Prueba"
msgstr "Prueba"

#: src/features/sma/utils/echartOptions.ts:27
msgid "Publicado"
msgstr "Publicado"

#: src/features/announcements/components/AnnouncementsViewModal.tsx:65
msgid "Publicado el"
msgstr "Publicado el"

#: src/features/audit/utils/parseProperty.ts:36
msgid "público"
msgstr "público"

#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:92
msgid "Público"
msgstr "Público"

#: src/features/reports/components/CreatedReportNotification.tsx:72
msgid "Puedes descargar el reporte desde los siguientes enlaces"
msgstr "Puedes descargar el reporte desde los siguientes enlaces"

#: src/features/reports/components/creationSection/CreateReportsSection.tsx:15
msgid "Puedes solicitar un reporte de los datos de un dispositivo en específico o de todos los dispositivos de un canal."
msgstr "Puedes solicitar un reporte de los datos de un dispositivo en específico o de todos los dispositivos de un canal."

#: src/features/metricsViews/components/SaveWidgetModal.tsx:907
msgid "Punto"
msgstr "Punto"

#: src/features/alertsNotificationsHistory/hooks/useTranslations.ts:18
msgid "Push"
msgstr "Push"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:207
msgid "Radar sin contacto"
msgstr "Radar sin contacto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:339
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:294
#: src/features/reports/utils/metricHelpers.ts:29
msgid "Radiación"
msgstr "Radiación"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:339
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:208
msgid "Radiación bruta"
msgstr "Radiación bruta"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:258
msgid "Radiales"
msgstr "Radiales"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:11
msgid "radio de la compuerta (en cm)"
msgstr "radio de la compuerta (en cm)"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:88
#: src/features/gateAdministration/components/MoveGate.tsx:193
#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:52
msgid "Rango"
msgstr "Rango"

#: src/features/controlCenter/components/panel/Minicharts.tsx:298
msgid "Rango de caudal alto"
msgstr "Rango de caudal alto"

#: src/features/controlCenter/components/panel/Minicharts.tsx:309
msgid "Rango de caudal bajo"
msgstr "Rango de caudal bajo"

#: src/features/controlCenter/components/panel/Minicharts.tsx:287
msgid "Rango de caudal extremo"
msgstr "Rango de caudal extremo"

#: src/features/reports/components/ReportHistory.tsx:271
msgid "Rango de datos"
msgstr "Rango de datos"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:189
msgid "Rango de intervalo"
msgstr "Rango de intervalo"

#: src/features/controlCenter/components/panel/Minicharts.tsx:369
msgid "Rango de nivel alto"
msgstr "Rango de nivel alto"

#: src/features/controlCenter/components/panel/Minicharts.tsx:380
msgid "Rango de nivel bajo"
msgstr "Rango de nivel bajo"

#: src/features/controlCenter/components/panel/Minicharts.tsx:358
msgid "Rango de nivel extremo"
msgstr "Rango de nivel extremo"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:183
msgid "Rango de observación"
msgstr "Rango de observación"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:78
msgid "Rango de tiempo"
msgstr "Rango de tiempo"

#. Selector de tiempo - botón de rangos de tiempo recientes
#: src/features/standardDesign/components/DateTimeRangePicker.tsx:434
msgid "Rangos recientes"
msgstr "Rangos recientes"

#: src/features/deviceSupport/data/column.ts:133
#: src/features/deviceSupport/data/fields.ts:17
msgid "Ratio Buffer"
msgstr "Ratio Buffer"

#: src/features/deviceSupport/data/column.ts:140
#: src/features/deviceSupport/data/fields.ts:18
msgid "Ratio Outlier"
msgstr "Ratio Outlier"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:566
msgid "Realizado el"
msgstr "Realizado el"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1026
msgid "Rectángulo"
msgstr "Rectángulo"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1029
msgid "Rectángulo redondeado"
msgstr "Rectángulo redondeado"

#: src/features/recoveryPassword/components/RecoveryPassword.tsx:59
msgid "Recuperar contraseña"
msgstr "Recuperar contraseña"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:260
msgid "Recurrencia"
msgstr "Recurrencia"

#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:77
msgid "Recurrencia de envíos actualizada correctamente"
msgstr "Recurrencia de envíos actualizada correctamente"

#: src/pages/irrigations/index.tsx:9
msgid "Red de canales"
msgstr "Red de canales"

#: src/components/layout/DashboardSidebar.tsx:276
msgid "Red de Canales"
msgstr "Red de Canales"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:101
msgid "Red eléctrica"
msgstr "Red eléctrica"

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:40
msgid "Red móvil"
msgstr "Red móvil"

#: src/features/irrigations/components/CreateOrUpdateIrrigation.tsx:202
#: src/features/irrigations/components/Table.tsx:69
msgid "Región"
msgstr "Región"

#: src/utils/devices/formatSourceColor.ts:32
msgid "Regis"
msgstr "Regis"

#: src/pages/billing/CreatePaymentView.tsx:9
msgid "Registrar Nuevo Pago"
msgstr "Registrar Nuevo Pago"

#: src/features/billing/components/payments/Toolbar.tsx:67
msgid "Registrar pago"
msgstr "Registrar pago"

#: src/features/deviceProfile/components/page/Audit.tsx:49
msgid "Registro de cambios"
msgstr "Registro de cambios"

#: src/features/billing/components/administration/Toolbar.tsx:122
msgid "Registro de pagos"
msgstr "Registro de pagos"

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:106
msgid "Regularice ahora y evite limitaciones en el servicio."
msgstr "Regularice ahora y evite limitaciones en el servicio."

#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:120
msgid "Reintentar envío de datos"
msgstr "Reintentar envío de datos"

#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:53
#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:87
msgid "Reintentar publicación de reportes fallidos"
msgstr "Reintentar publicación de reportes fallidos"

#: src/features/access/components/devicesTab/DevicesTab.tsx:37
#: src/features/access/components/usersTab/UsersTab.tsx:36
#: src/features/deviceConfigurationModal/components/accessTab/AccessTab.tsx:26
msgid "Relaciones actualizadas correctamente"
msgstr "Relaciones actualizadas correctamente"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:62
msgid "Relaciones creadas correctamente"
msgstr "Relaciones creadas correctamente"

#: src/features/access/components/globalModals/RemoveDeviceUserRelationsModal.tsx:72
msgid "Relaciones eliminadas correctamente"
msgstr "Relaciones eliminadas correctamente"

#: src/components/layout/DashboardSidebar.tsx:171
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAlertLevelsCheckboxList.tsx:74
#: src/features/organizationAccess/data/sections.ts:45
#: src/pages/distribution/public.tsx:9
msgid "Reparto"
msgstr "Reparto"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:109
msgid "Reparto excedido"
msgstr "Reparto excedido"

#: src/features/organizationAccess/data/sections.ts:49
msgid "Reparto Maipo"
msgstr "Reparto Maipo"

#. Análisis de estaciones - botón de reportar problema
#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:29
#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:139
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:180
msgid "Reportar un problema"
msgstr "Reportar un problema"

#: src/features/reports/components/CreatedReportNotification.tsx:36
msgid "Reporte creado exitosamente"
msgstr "Reporte creado exitosamente"

#: src/features/reportDownload/components/ReportDownload.tsx:57
msgid "Reporte Descargado exitósamente"
msgstr "Reporte Descargado exitósamente"

#: src/features/reportProblem/components/ReportProblemDialog.tsx:68
msgid "Reporte enviado correctamente. Espera unos minutos para poder visualizar el evento"
msgstr "Reporte enviado correctamente. Espera unos minutos para poder visualizar el evento"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:189
msgid "Reporte programado correctamente"
msgstr "Reporte programado correctamente"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:97
msgid "Reporte solicitado con éxito. Este será enviado a los emails ingresados en breve."
msgstr "Reporte solicitado con éxito. Este será enviado a los emails ingresados en breve."

#: src/components/layout/DashboardSidebar.tsx:180
#: src/features/organizationAccess/data/sections.ts:53
#: src/pages/reports/data-extraction2.tsx:9
msgid "Reportes"
msgstr "Reportes"

#: src/components/layout/DashboardSidebar.tsx:188
#: src/features/organizationAccess/data/sections.ts:61
msgid "Reportes DGA"
msgstr "Reportes DGA"

#: src/features/reports/components/DataExtraction.tsx:14
#: src/features/reports/components/ReportHistory.tsx:35
msgid "Reportes Históricos"
msgstr "Reportes Históricos"

#: src/features/organizationAccess/data/sections.ts:57
msgid "Reportes Programados"
msgstr "Reportes Programados"

#: src/components/layout/DashboardSidebar.tsx:196
#: src/features/organizationAccess/data/sections.ts:65
msgid "Reportes SMA"
msgstr "Reportes SMA"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:70
msgid "Request ID"
msgstr "Request ID"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:69
msgid "Responsable"
msgstr "Responsable"

#: src/features/changeSupportStatus/data/status.ts:11
#: src/features/deviceSupport/data/status.ts:28
#: src/features/deviceSupport/data/status.ts:56
msgid "Responsable cliente"
msgstr "Responsable cliente"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:375
msgid "Restablecer configuración"
msgstr "Restablecer configuración"

#: src/components/modal/ModalActions.tsx:52
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:189
#: src/features/userPreferences/components/MetricsTab.tsx:303
#: src/features/userPreferences/components/RegionTab.tsx:311
msgid "Restablecer formulario"
msgstr "Restablecer formulario"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:97
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:130
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:541
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:167
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:216
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:373
msgid "Restablecer Formulario"
msgstr "Restablecer Formulario"

#: src/features/userPreferences/components/MetricsTab.tsx:294
#: src/features/userPreferences/components/RegionTab.tsx:302
msgid "Restablecer valores por defecto"
msgstr "Restablecer valores por defecto"

#: src/features/userSaveModal/components/UserSaveModal.tsx:434
#: src/features/userSaveModal/components/UserSaveModal.tsx:492
msgid "Rol"
msgstr "Rol"

#: src/utils/roles.ts:20
msgid "Rol desconocido"
msgstr "Rol desconocido"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:47
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:222
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:165
msgid "RUT"
msgstr "RUT"

#: src/features/reports/utils/schedules.ts:17
msgid "sábado"
msgstr "sábado"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:139
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:119
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:221
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:86
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:91
#: src/utils/i18n/getDgaTranslations.ts:12
msgid "Sábado"
msgstr "Sábado"

#: src/features/debtsAlert/components/DebtsAlertBanner.tsx:54
msgid "Saldo pendiente. <0>Detalles aquí.</0>"
msgstr "Saldo pendiente. <0>Detalles aquí.</0>"

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:81
msgid "Satelital"
msgstr "Satelital"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:331
msgid "Saturación de oxígeno disuelto"
msgstr "Saturación de oxígeno disuelto"

#: src/features/reports/utils/metricHelpers.ts:16
msgid "Saturación de Oxígeno Disuelto"
msgstr "Saturación de Oxígeno Disuelto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:333
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:130
msgid "Saturación de oxígeno disuelto bruto"
msgstr "Saturación de oxígeno disuelto bruto"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:480
msgid "SD Threshold"
msgstr "SD Threshold"

#: src/features/billing/components/modals/ServiceFileManager.tsx:47
msgid "Se crearán los siguientes servicios. Para guardar los cambios, presione guardar."
msgstr "Se crearán los siguientes servicios. Para guardar los cambios, presione guardar."

#: src/features/organizationDelete/components/DeleteOrganization.tsx:51
msgid "Se eliminará los usuarios asociados a la organización."
msgstr "Se eliminará los usuarios asociados a la organización."

#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:80
msgid "Se enviará la información solicitada en formato excel al correo <0>{0}</0>"
msgstr "Se enviará la información solicitada en formato excel al correo <0>{0}</0>"

#: src/features/organizationAccess/components/OrganizationAccess.tsx:40
msgid "Se ha actualizado el acceso a la organización"
msgstr "Se ha actualizado el acceso a la organización"

#: src/features/users/components/tableCells/UserStatusCell.tsx:15
msgid "Se ha actualizado el estado"
msgstr "Se ha actualizado el estado"

#: src/features/users/components/tableCells/User2FACell.tsx:15
msgid "Se ha actualizado la autenticación en 2 pasos"
msgstr "Se ha actualizado la autenticación en 2 pasos"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:23
msgid "Se ha creado el dispositivo correctamente"
msgstr "Se ha creado el dispositivo correctamente"

#: src/features/reports/components/CreatedReportNotification.tsx:38
msgid "Se ha creado el reporte con éxito y ha sido enviado a los correos electrónicos seleccionados. Por favor, revise su bandeja de entrada."
msgstr "Se ha creado el reporte con éxito y ha sido enviado a los correos electrónicos seleccionados. Por favor, revise su bandeja de entrada."

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:76
msgid "Se ha creado el usuario temporal <0><1>{0}</1></0>"
msgstr "Se ha creado el usuario temporal <0><1>{0}</1></0>"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:32
msgid "Se ha creado el usuario temporal con id {id}"
msgstr "Se ha creado el usuario temporal con id {id}"

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:36
msgid "Se ha creado un dispositivo clonado con id {0}"
msgstr "Se ha creado un dispositivo clonado con id {0}"

#: src/components/NotificationsPopover.tsx:242
msgid "Se ha detectado un evento en"
msgstr "Se ha detectado un evento en"

#: src/features/sma/components/SendReportsByEmailModal.tsx:51
msgid "Se ha enviado el reporte a tu correo"
msgstr "Se ha enviado el reporte a tu correo"

#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:44
msgid "Se ha enviado el reporte al correo {0}"
msgstr "Se ha enviado el reporte al correo {0}"

#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:21
msgid "Se ha extendido el tiempo de expiración del token"
msgstr "Se ha extendido el tiempo de expiración del token"

#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:23
msgid "Se ha extendido el tiempo de expiración del usuario"
msgstr "Se ha extendido el tiempo de expiración del usuario"

#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:26
msgid "Se intentará publicar los datos nuevamente."
msgstr "Se intentará publicar los datos nuevamente."

#: src/features/recoveryPassword/components/RecoveryPassword.tsx:31
msgid "Se le ha enviado un correo electrónico para cambiar la contraseña. (revisar correos de spam)"
msgstr "Se le ha enviado un correo electrónico para cambiar la contraseña. (revisar correos de spam)"

#: src/features/billing/components/table/ProjectsTable.tsx:114
msgid "Se modificó la periodicidad correctamente"
msgstr "Se modificó la periodicidad correctamente"

#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:98
msgid "Se van a realizar los siguientes cambios:"
msgstr "Se van a realizar los siguientes cambios:"

#: src/features/organizationAccess/components/OrganizationAccessTable.tsx:28
msgid "Sección"
msgstr "Sección"

#: src/features/announcements/components/AnnouncementsView.tsx:292
msgid "Seguir leyendo"
msgstr "Seguir leyendo"

#: src/features/audit/utils/parseProperty.ts:110
msgid "segundo caudal repartible"
msgstr "segundo caudal repartible"

#: src/features/sma/components/SendReportsByEmailModal.tsx:85
msgid "Selecciona el rango de fechas para generar el excel"
msgstr "Selecciona el rango de fechas para generar el excel"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:132
msgid "Selecciona una organización para filtrar dispositivos"
msgstr "Selecciona una organización para filtrar dispositivos"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:144
msgid "Selecciona una organización para filtrar usuarios"
msgstr "Selecciona una organización para filtrar usuarios"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:265
#: src/features/billing/components/modals/ServiceFileManager.tsx:206
msgid "Seleccionar Archivo"
msgstr "Seleccionar Archivo"

#: src/features/deviceCommands/components/DeviceSelector.tsx:48
#: src/features/deviceCommands/components/DeviceSelector.tsx:52
msgid "Seleccionar dispositivos"
msgstr "Seleccionar dispositivos"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:432
msgid "Seleccionar Dispositivos"
msgstr "Seleccionar Dispositivos"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:299
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:148
msgid "Seleccionar todos"
msgstr "Seleccionar todos"

#: src/features/billing/components/payments/PaymentForm.tsx:169
msgid "Seleccionar un archivo"
msgstr "Seleccionar un archivo"

#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:108
msgid "Seleccione los dispositivos para el reporte"
msgstr "Seleccione los dispositivos para el reporte"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:458
msgid "Seleccione un dispositivo para ver sus métricas disponibles."
msgstr "Seleccione un dispositivo para ver sus métricas disponibles."

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:165
msgid "Seleccione una organización"
msgstr "Seleccione una organización"

#: src/features/alertsNotificationsHistory/components/Charts.tsx:307
msgid "Semana"
msgstr "Semana"

#: src/features/metricsViews/components/widgets/ChartWidget.tsx:38
msgid "Semana {0}"
msgstr "Semana {0}"

#: src/features/dga/components/modals/reports/ChartModal.tsx:116
#: src/features/sma/components/SmaSuccessTableModal.tsx:90
msgid "Semana Anterior"
msgstr "Semana Anterior"

#: src/features/sma/components/SmaSuccessTableModal.tsx:73
msgid "Semana del <0>{0}</0> al <1>{1}</1>"
msgstr "Semana del <0>{0}</0> al <1>{1}</1>"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:76
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:178
msgid "Semanal"
msgstr "Semanal"

#: src/utils/i18n/getDgaTranslations.ts:38
msgid "Semanal ({weekday} {hourString})"
msgstr "Semanal ({weekday} {hourString})"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:99
msgid "Semanalmente"
msgstr "Semanalmente"

#: src/features/reports/utils/schedules.ts:47
msgid "Semanalmente los días {daysOfWeekStr} a las {hoursMinutesStr} horas."
msgstr "Semanalmente los días {daysOfWeekStr} a las {hoursMinutesStr} horas."

#: src/features/billing/utils/translations.ts:11
#: src/features/billing/utils/translations.ts:26
msgid "Semestral"
msgstr "Semestral"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:351
msgid "Sensor"
msgstr "Sensor"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:48
msgid "Sensor de ángulo"
msgstr "Sensor de ángulo"

#: src/features/audit/utils/parseProperty.ts:160
msgid "sensor de caudal"
msgstr "sensor de caudal"

#: src/features/audit/utils/parseProperty.ts:56
msgid "sensor de flujo"
msgstr "sensor de flujo"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:40
#: src/features/deviceConfiguration/data/sectionFields.ts:98
#: src/features/deviceConfiguration/data/sectionInputs.ts:98
msgid "Sensor de flujo"
msgstr "Sensor de flujo"

#: src/features/audit/utils/parseProperty.ts:48
#: src/features/audit/utils/parseProperty.ts:151
msgid "sensor de nivel"
msgstr "sensor de nivel"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:32
#: src/features/deviceConfiguration/data/sectionFields.ts:42
#: src/features/deviceConfiguration/data/sectionInputs.ts:44
msgid "Sensor de nivel"
msgstr "Sensor de nivel"

#: src/features/audit/utils/parseProperty.ts:52
#: src/features/audit/utils/parseProperty.ts:159
msgid "sensor de velocidad"
msgstr "sensor de velocidad"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:44
#: src/features/deviceConfiguration/data/sectionFields.ts:70
#: src/features/deviceConfiguration/data/sectionInputs.ts:65
msgid "Sensor de velocidad"
msgstr "Sensor de velocidad"

#: src/features/audit/utils/parseProperty.ts:103
msgid "sensores"
msgstr "sensores"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:258
#: src/features/deviceConfiguration/data/sectionFields.ts:125
#: src/features/deviceConfiguration/data/sectionInputs.ts:118
#: src/features/deviceProfile/components/page/modularComponents/index.tsx:40
msgid "Sensorización"
msgstr "Sensorización"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:25
msgid "Septiembre"
msgstr "Septiembre"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:742
msgid "Series"
msgstr "Series"

#: src/features/billing/components/payments/PaymentRow.tsx:97
#: src/features/billing/components/table/ServicesTableForTooltip.tsx:45
#: src/features/billing/utils/list.ts:21
msgid "Servicio"
msgstr "Servicio"

#: src/features/billing/components/projectService/Delete.tsx:117
msgid "Servicio a eliminar"
msgstr "Servicio a eliminar"

#: src/features/billing/components/service/Update.tsx:37
msgid "Servicio actualizado correctamente."
msgstr "Servicio actualizado correctamente."

#: src/features/billing/components/service/Administration.tsx:40
#: src/features/billing/components/service/Delete.tsx:30
msgid "Servicio creado correctamente."
msgstr "Servicio creado correctamente."

#: src/features/billing/components/projectService/Delete.tsx:44
msgid "Servicio eliminado correctamente"
msgstr "Servicio eliminado correctamente"

#: src/features/billing/components/projectService/Create.tsx:61
msgid "Servicio existente para el proyecto ingresado. El servicio debe ser único."
msgstr "Servicio existente para el proyecto ingresado. El servicio debe ser único."

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:39
#: src/features/billing/components/table/DevicesTable.tsx:160
#: src/features/billing/components/table/ProjectsTable.tsx:80
msgid "Servicios"
msgstr "Servicios"

#: src/features/billing/components/table/OrganizationsTable.tsx:70
msgid "Servicios activos"
msgstr "Servicios activos"

#: src/features/billing/components/modals/ServiceFileManager.tsx:34
msgid "Servicios creados correctamente!"
msgstr "Servicios creados correctamente!"

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:54
msgid "Severidad"
msgstr "Severidad"

#: src/features/audit/components/AuditLogDetailsRow.tsx:23
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:103
msgid "Sí"
msgstr "Sí"

#: src/pages/AuthorizationRequired.tsx:59
msgid "Si necesitas acceder a esta página, ponte en contacto con dev@captahydro.com para habilitar tu cuenta"
msgstr "Si necesitas acceder a esta página, ponte en contacto con dev@captahydro.com para habilitar tu cuenta"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:95
msgid "Si pierdes el link de activación puedes volver a consultarlo en el perfil del usuario"
msgstr "Si pierdes el link de activación puedes volver a consultarlo en el perfil del usuario"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/DeleteCurveModal.tsx:30
msgid "Si quieres deshacer esta acción, presiona <0>Restablecer Formulario</0>"
msgstr "Si quieres deshacer esta acción, presiona <0>Restablecer Formulario</0>"

#: src/features/deviceSupport/data/fields.ts:20
msgid "SIM Megas"
msgstr "SIM Megas"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:254
#: src/features/metricsViews/components/SaveWidgetModal.tsx:1015
msgid "Símbolo"
msgstr "Símbolo"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:725
msgid "Simple"
msgstr "Simple"

#: src/features/users/components/modals/SimulateUserModal.tsx:71
#: src/features/users/components/tableCells/UserActionsCell.tsx:53
msgid "Simular"
msgstr "Simular"

#: src/features/users/components/modals/SimulateUserModal.tsx:92
msgid "Simular usuario"
msgstr "Simular usuario"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:87
msgid "Sin acceso"
msgstr "Sin acceso"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:44
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:56
msgid "Sin asignar"
msgstr "Sin asignar"

#: src/features/users/utils/filterOptions.ts:103
msgid "Sin autenticación en 2 pasos"
msgstr "Sin autenticación en 2 pasos"

#: src/features/controlCenter/components/window/StationListItem.tsx:410
msgid "Sin conexión hace más de un día"
msgstr "Sin conexión hace más de un día"

#: src/features/deviceProfile/components/modal/Status.tsx:195
msgid "Sin configuración de hardware"
msgstr "Sin configuración de hardware"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:172
msgid "Sin contacto"
msgstr "Sin contacto"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:269
#: src/features/deviceProfile/components/page/Support.tsx:179
#: src/features/deviceProfile/components/page/Support.tsx:184
#: src/features/devicesAnalysis/components/LastData.tsx:67
#: src/features/integrations/components/monitoredTargetSection/Status.tsx:35
msgid "Sin datos"
msgstr "Sin datos"

#: src/features/controlCenter/components/window/StationListItem.tsx:419
#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:96
msgid "Sin datos hace más de un día"
msgstr "Sin datos hace más de un día"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:95
msgid "Sin datos registrados"
msgstr "Sin datos registrados"

#: src/features/deviceSupport/data/dga.ts:15
msgid "Sin DGA"
msgstr "Sin DGA"

#: src/utils/i18n/getAlertSuccessOptions.ts:17
msgid "Sin envíos"
msgstr "Sin envíos"

#: src/features/controlCenter/components/window/StationListItem.tsx:385
msgid "sin fecha de medición"
msgstr "sin fecha de medición"

#: src/features/deviceProfile/components/modal/Info.tsx:66
msgid "Sin imagen de perfil"
msgstr "Sin imagen de perfil"

#: src/features/deviceSupport/components/SupportTableBody.tsx:53
#: src/features/users/components/tableCells/UserLastAccessCell.tsx:13
msgid "Sin información"
msgstr "Sin información"

#: src/features/deviceProfile/components/page/Support.tsx:112
msgid "Sin información reciente de batería"
msgstr "Sin información reciente de batería"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:274
msgid "Sin nombre"
msgstr "Sin nombre"

#: src/utils/i18n/getAlertSuccessOptions.ts:23
msgid "Sin notificaciones configuradas"
msgstr "Sin notificaciones configuradas"

#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:218
msgid "Sin número de teléfono"
msgstr "Sin número de teléfono"

#: src/features/standardDesign/components/listView/StandardListViewHeader.tsx:177
msgid "Sin opciones"
msgstr "Sin opciones"

#: src/components/DeviceModalTitle.tsx:109
#: src/components/tooltips/DeviceTooltip.tsx:41
#: src/features/access/components/devicesTab/DevicesListItem.tsx:77
#: src/features/access/components/usersTab/UsersListItem.tsx:92
#: src/features/users/components/tableCells/OrganizationCellDisplay.tsx:27
msgid "Sin organización"
msgstr "Sin organización"

#: src/features/users/components/tableCells/UserSharedOrganizationsCell.tsx:15
msgid "Sin organizaciones adicionales"
msgstr "Sin organizaciones adicionales"

#: src/features/users/utils/filterOptions.ts:93
msgid "Sin organizaciones compartidas"
msgstr "Sin organizaciones compartidas"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:36
msgid "Sin registrar"
msgstr "Sin registrar"

#: src/features/controlCenter/components/window/StationListItem.tsx:447
#: src/features/deviceProfile/components/modal/Info.tsx:138
msgid "Sin ubicación"
msgstr "Sin ubicación"

#: src/features/controlCenter/components/window/StationListItem.tsx:326
msgid "Sistema"
msgstr "Sistema"

#: src/pages/distribution/maipo.tsx:9
msgid "Sistema de Reparto JV Río Maipo 1° sección"
msgstr "Sistema de Reparto JV Río Maipo 1° sección"

#: src/components/layout/DashboardSidebar.tsx:163
msgid "Sistema Reparte Maipo"
msgstr "Sistema Reparte Maipo"

#: src/components/layout/DashboardSidebar.tsx:300
#: src/pages/systems/index.tsx:9
msgid "Sistemas"
msgstr "Sistemas"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:157
msgid "Sitio"
msgstr "Sitio"

#: src/features/deviceConfigurationModal/components/publicTab/index.tsx:57
msgid "Sitio público"
msgstr "Sitio público"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:75
msgid "Sitio web"
msgstr "Sitio web"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:248
msgid "Sitio web (opcional)"
msgstr "Sitio web (opcional)"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:129
#: src/features/alertsConfiguration/components/AlertTable.tsx:208
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:114
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:117
#: src/features/alertsNotificationsHistory/hooks/useTranslations.ts:17
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:62
msgid "SMS"
msgstr "SMS"

#: src/features/deviceSupport/data/column.ts:63
msgid "SOC mínimo"
msgstr "SOC mínimo"

#: src/features/deviceProfile/components/page/Support.tsx:115
#: src/features/deviceSupport/data/fields.ts:13
msgid "SOC mínimo de batería"
msgstr "SOC mínimo de batería"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:45
#: src/features/gateAdministration/components/MovementHistory.tsx:67
msgid "Solicitado por"
msgstr "Solicitado por"

#: src/features/audit/utils/getActionTypeOptions.ts:292
msgid "Solicitar reporte de pagos."
msgstr "Solicitar reporte de pagos."

#: src/features/reports/components/creationSection/CreateReportsSection.tsx:11
msgid "Solicitar un nuevo reporte"
msgstr "Solicitar un nuevo reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:376
msgid "solicitó un reporte de pagos."
msgstr "solicitó un reporte de pagos."

#: src/features/gateAdministration/components/DeleteRequestModal.tsx:43
msgid "Solicitud de movimiento eliminada correctamente"
msgstr "Solicitud de movimiento eliminada correctamente"

#: src/pages/reports/create.tsx:8
msgid "Solicitud de Nuevo Reporte"
msgstr "Solicitud de Nuevo Reporte"

#: src/features/deviceSupport/data/column.ts:47
msgid "Soporte"
msgstr "Soporte"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1095
msgid "Start"
msgstr "Start"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1087
msgid "Step"
msgstr "Step"

#: src/features/audit/utils/parseProperty.ts:77
msgid "Strato"
msgstr "Strato"

#: src/features/reportDownload/components/ReportDownload.tsx:50
msgid "Su descarga debería comenzar en breve..."
msgstr "Su descarga debería comenzar en breve..."

#: src/features/login/components/Login.tsx:66
msgid "Su usuario está desactivado. Comunicate con el administrador de tu organización o contacta a soporte."
msgstr "Su usuario está desactivado. Comunicate con el administrador de tu organización o contacta a soporte."

#: src/features/metricsViews/components/SaveWidgetModal.tsx:988
msgid "Suavizar curva"
msgstr "Suavizar curva"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:188
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:131
#: src/utils/i18n/getDgaTranslations.ts:55
msgid "Subterránea"
msgstr "Subterránea"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:223
msgid "Sumergido"
msgstr "Sumergido"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:186
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:129
#: src/utils/i18n/getDgaTranslations.ts:51
msgid "Superficial"
msgstr "Superficial"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:187
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:130
#: src/utils/i18n/getDgaTranslations.ts:53
msgid "Superficial con flujómetro"
msgstr "Superficial con flujómetro"

#: src/features/audit/utils/getActionTypeOptions.ts:199
msgid "Suplantar Usuario"
msgstr "Suplantar Usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:161
msgid "suplantó al usuario"
msgstr "suplantó al usuario"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:218
msgid "Tabla"
msgstr "Tabla"

#: src/features/events/components/EventsTable.tsx:83
msgid "Tabla de eventos"
msgstr "Tabla de eventos"

#: src/features/devices2/components/list/DGAItem.tsx:84
msgid "Tabla de reportes"
msgstr "Tabla de reportes"

#: src/features/dga/components/modals/reports/TableModal.tsx:135
#: src/features/dga/components/modals/reports/TableModal.tsx:313
msgid "Tabla de reportes DGA"
msgstr "Tabla de reportes DGA"

#: src/features/devices2/components/list/itemPanel/SMAItemMenu.tsx:82
msgid "Tabla de reportes históricos"
msgstr "Tabla de reportes históricos"

#: src/features/sma/components/TableModal.tsx:168
#: src/features/sma/components/TableModal.tsx:324
msgid "Tabla de reportes SMA"
msgstr "Tabla de reportes SMA"

#: src/features/deviceSupport/data/filter.ts:13
msgid "Tags"
msgstr "Tags"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:467
msgid "Tamaño de ventana"
msgstr "Tamaño de ventana"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1052
msgid "Tamano del símbolo"
msgstr "Tamano del símbolo"

#: src/features/audit/utils/parseProperty.ts:155
msgid "tecnología"
msgstr "tecnología"

#: src/features/deviceConfiguration/data/sectionFields.ts:187
#: src/features/deviceConfiguration/data/sectionInputs.ts:185
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:85
msgid "Tecnología"
msgstr "Tecnología"

#: src/features/audit/utils/parseProperty.ts:69
msgid "tecnología de batería"
msgstr "tecnología de batería"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:28
msgid "Tecnología de batería"
msgstr "Tecnología de batería"

#: src/features/audit/utils/parseProperty.ts:117
msgid "teléfono"
msgstr "teléfono"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:145
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:238
#: src/features/organizationsManagement/components/OrganizationsTable.tsx:78
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:349
msgid "Teléfono"
msgstr "Teléfono"

#: src/features/audit/utils/parseProperty.ts:116
msgid "teléfono completo"
msgstr "teléfono completo"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:53
#: src/features/gateAdministration/components/index.tsx:525
#: src/pages/organization-charts/[name].tsx:13
msgid "Telemetría"
msgstr "Telemetría"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:316
#: src/features/devicesAnalysis/components/panel/Chart.tsx:338
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:182
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:281
#: src/features/metricsViews/components/SaveWidgetModal.tsx:438
#: src/features/metricsViews/components/SaveWidgetModal.tsx:867
#: src/features/metricsViews/components/widgets/TableWidget.tsx:119
#: src/features/reports/utils/metricHelpers.ts:32
msgid "Temperatura"
msgstr "Temperatura"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:316
#: src/features/devicesAnalysis/components/panel/Chart.tsx:338
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:71
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:195
msgid "Temperatura bruta"
msgstr "Temperatura bruta"

#: src/features/reports/utils/metricHelpers.ts:30
msgid "Temperatura de Nieve"
msgstr "Temperatura de Nieve"

#: src/features/deviceProfile/components/page/lifeHistory/index.tsx:58
msgid "testing"
msgstr "testing"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:120
msgid "Ticket DGA - ID"
msgstr "Ticket DGA - ID"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:90
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:229
msgid "Tiempo para comenzar a notificar"
msgstr "Tiempo para comenzar a notificar"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:237
msgid "Tiempo para enviar la primera notificación en caso de falla"
msgstr "Tiempo para enviar la primera notificación en caso de falla"

#: src/features/integrations/components/monitoredTargetSection/index.tsx:18
#: src/features/integrations/components/monitoredTargetSection/index.tsx:36
msgid "Tiempos de respuesta"
msgstr "Tiempos de respuesta"

#: src/features/audit/utils/parseProperty.ts:121
msgid "tiene deuda"
msgstr "tiene deuda"

#: src/features/audit/utils/parseProperty.ts:21
msgid "tipo"
msgstr "tipo"

#: src/components/DeviceModalTitle.tsx:104
#: src/components/filters/TypeFilter.tsx:19
#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:274
#: src/features/billing/components/modals/ServiceFileManager.tsx:55
#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:106
#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:111
#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:38
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:235
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:600
#: src/features/deviceProfile/components/modal/Info.tsx:102
#: src/features/deviceProfile/components/page/General.tsx:35
#: src/features/devices2/components/DevicesHeader.tsx:111
#: src/features/deviceSupport/data/column.ts:31
#: src/features/deviceSupport/data/fields.ts:9
#: src/features/deviceSupport/data/filter.ts:10
msgid "Tipo"
msgstr "Tipo"

#: src/features/alertsConfiguration/components/AlertTable.tsx:198
#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:166
#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:263
#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:53
msgid "Tipo de alerta"
msgstr "Tipo de alerta"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:116
msgid "Tipo de Alerta"
msgstr "Tipo de Alerta"

#: src/features/audit/utils/parseProperty.ts:147
msgid "tipo de conexión de datos"
msgstr "tipo de conexión de datos"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:56
msgid "Tipo de conexión de datos"
msgstr "Tipo de conexión de datos"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:209
msgid "Tipo de curva"
msgstr "Tipo de curva"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:538
#: src/features/metricsViews/components/SaveWidgetModal.tsx:540
#: src/features/metricsViews/components/SaveWidgetModal.tsx:802
msgid "Tipo de dato"
msgstr "Tipo de dato"

#: src/features/deviceConfiguration/components/DeviceConfiguration.tsx:212
#: src/features/userPreferences/components/MetricsTab.tsx:225
msgid "Tipo de dispositivo"
msgstr "Tipo de dispositivo"

#: src/features/userPreferences/utils/metricsValidationSchema.ts:51
msgid "Tipo de dispositivo repetido"
msgstr "Tipo de dispositivo repetido"

#: src/features/audit/utils/parseProperty.ts:154
msgid "tipo de energía"
msgstr "tipo de energía"

#: src/features/deviceSupport/data/column.ts:87
#: src/features/deviceSupport/data/fields.ts:19
msgid "Tipo de energización"
msgstr "Tipo de energización"

#: src/features/notifications/components/NotificationsSaveModal.tsx:98
msgid "Tipo de entidad no soportado"
msgstr "Tipo de entidad no soportado"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:30
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:194
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:137
msgid "Tipo de extracción"
msgstr "Tipo de extracción"

#: src/features/audit/utils/parseProperty.ts:10
msgid "tipo de extracción DGA"
msgstr "tipo de extracción DGA"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:205
msgid "Tipo de fórmula"
msgstr "Tipo de fórmula"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:417
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:421
msgid "Tipo de mensaje"
msgstr "Tipo de mensaje"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:68
msgid "Tipo de Moneda"
msgstr "Tipo de Moneda"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:196
msgid "Tipo de moneda en la que se realiza el pago. Los valores aceptados son CLP, USD, UF, BTC."
msgstr "Tipo de moneda en la que se realiza el pago. Los valores aceptados son CLP, USD, UF, BTC."

#: src/features/billing/components/modals/ServiceFileManager.tsx:153
msgid "Tipo de moneda. Los valores aceptados son CLP, USD, UF, BTC."
msgstr "Tipo de moneda. Los valores aceptados son CLP, USD, UF, BTC."

#: src/features/audit/utils/parseProperty.ts:85
msgid "tipo de plan de datos"
msgstr "tipo de plan de datos"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:60
msgid "Tipo de plan de datos"
msgstr "Tipo de plan de datos"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:689
msgid "Tipo de selector"
msgstr "Tipo de selector"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:890
#: src/features/metricsViews/components/SaveWidgetModal.tsx:894
msgid "Tipo de serie"
msgstr "Tipo de serie"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:74
#: src/features/billing/components/table/ServicesTable.tsx:54
msgid "Tipo de Servicio"
msgstr "Tipo de Servicio"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:206
msgid "Tipo de servicio proporcionado. Los valores aceptados incluyen DGA, RENTAL, INTEGRATION, entre otros."
msgstr "Tipo de servicio proporcionado. Los valores aceptados incluyen DGA, RENTAL, INTEGRATION, entre otros."

#: src/features/audit/utils/parseProperty.ts:18
msgid "tipo de usuario"
msgstr "tipo de usuario"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:244
msgid "Tipo de Widget"
msgstr "Tipo de Widget"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:105
msgid "Tipo energía"
msgstr "Tipo energía"

#: src/features/audit/utils/parseProperty.ts:94
msgid "tipo satelital"
msgstr "tipo satelital"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:68
#: src/features/deviceConfiguration/data/sectionFields.ts:491
msgid "Tipo satelital"
msgstr "Tipo satelital"

#: src/features/deviceConfiguration/data/sectionInputs.ts:519
msgid "Tipo Satelital"
msgstr "Tipo Satelital"

#: src/components/DeviceModalTitle.tsx:151
msgid "Tipo:"
msgstr "Tipo:"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:186
#: src/features/alertsNotificationsHistory/components/Filters.tsx:335
msgid "Tipos de alerta"
msgstr "Tipos de alerta"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:198
#: src/features/alertsNotificationsHistory/components/Filters.tsx:359
msgid "Tipos de notificación"
msgstr "Tipos de notificación"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:240
#: src/features/metricsViews/components/SaveWidgetModal.tsx:268
msgid "Título"
msgstr "Título"

#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:68
msgid "Tnano Invierno"
msgstr "Tnano Invierno"

#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:67
msgid "Tnano Verano"
msgstr "Tnano Verano"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:339
msgid "Todas las curvas activadas"
msgstr "Todas las curvas activadas"

#: src/features/integrations/components/integrationsStatus/index.tsx:37
msgid "Todas las integraciones en línea"
msgstr "Todas las integraciones en línea"

#: src/components/filters/NamingFilter.tsx:28
#: src/components/filters/StatusFilter.tsx:16
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:101
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:122
#: src/features/billing/utils/list.ts:30
#: src/features/deviceProfile/components/page/Audit.tsx:56
#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:77
#: src/features/deviceSupport/data/dga.ts:7
#: src/features/deviceSupport/data/status.ts:20
#: src/features/gates/components/Gates.tsx:87
#: src/features/integrations/components/devicesList/index.tsx:107
msgid "Todos"
msgstr "Todos"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:93
msgid "Todos los roles"
msgstr "Todos los roles"

#: src/features/alertsNotificationsHistory/components/Charts.tsx:130
#: src/features/alertsNotificationsHistory/components/Charts.tsx:145
#: src/features/billing/components/payments/PaymentRow.tsx:101
#: src/features/billing/components/payments/PaymentSummary.tsx:117
msgid "Total"
msgstr "Total"

#: src/features/billing/components/payments/PaymentsTable.tsx:46
#: src/features/billing/components/payments/PaymentSummary.tsx:122
msgid "Total con descuento"
msgstr "Total con descuento"

#: src/features/billing/components/payments/PaymentsTable.tsx:43
msgid "Total de servicios"
msgstr "Total de servicios"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:211
msgid "Total del servicio antes de aplicar el descuento, en la moneda indicada."
msgstr "Total del servicio antes de aplicar el descuento, en la moneda indicada."

#: src/features/billing/components/payments/PaymentsTable.tsx:42
#: src/features/billing/components/payments/PaymentSummary.tsx:127
msgid "Total descuento de servicios"
msgstr "Total descuento de servicios"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:100
#: src/features/billing/components/payments/PaymentRow.tsx:98
msgid "Total estimado"
msgstr "Total estimado"

#: src/components/LastDistributionData.tsx:87
msgid "Total Reparto"
msgstr "Total Reparto"

#: src/features/billing/components/table/DevicesTable.tsx:161
#: src/features/billing/components/table/ProjectsTable.tsx:81
msgid "Total Servicios"
msgstr "Total Servicios"

#: src/features/billing/components/payments/PaymentsTable.tsx:41
msgid "Total sin descuento"
msgstr "Total sin descuento"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:56
#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:115
msgid "Totalizador caudalímetro"
msgstr "Totalizador caudalímetro"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:1032
msgid "Triángulo"
msgstr "Triángulo"

#: src/features/billing/utils/translations.ts:10
#: src/features/billing/utils/translations.ts:22
msgid "Trimestral"
msgstr "Trimestral"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:326
msgid "Tuberías (flujómetro)"
msgstr "Tuberías (flujómetro)"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:258
msgid "Turbidez (FNU)"
msgstr "Turbidez (FNU)"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:248
msgid "Turbidez (NTU)"
msgstr "Turbidez (NTU)"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:327
#: src/features/reports/utils/metricHelpers.ts:33
msgid "Turbidez FNU"
msgstr "Turbidez FNU"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:327
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:156
msgid "Turbidez FNU bruta"
msgstr "Turbidez FNU bruta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:326
#: src/features/reports/utils/metricHelpers.ts:34
msgid "Turbidez NTU"
msgstr "Turbidez NTU"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:326
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:143
msgid "Turbidez NTU bruta"
msgstr "Turbidez NTU bruta"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:436
#: src/features/metricsViews/components/SaveWidgetModal.tsx:861
#: src/features/metricsViews/components/widgets/TableWidget.tsx:117
msgid "Turbiedad FNU"
msgstr "Turbiedad FNU"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:437
#: src/features/metricsViews/components/SaveWidgetModal.tsx:864
#: src/features/metricsViews/components/widgets/TableWidget.tsx:118
msgid "Turbiedad NTU"
msgstr "Turbiedad NTU"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:275
#: src/features/deviceProfile/components/modal/Info.tsx:124
#: src/features/deviceProfile/components/page/General.tsx:75
msgid "Ubicación"
msgstr "Ubicación"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:557
msgid "Última calidad de señal"
msgstr "Última calidad de señal"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:593
msgid "Última conductividad"
msgstr "Última conductividad"

#: src/features/deviceProfile/components/page/Support.tsx:174
msgid "Última conexión"
msgstr "Última conexión"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:566
msgid "Última corriente panel solar"
msgstr "Última corriente panel solar"

#: src/features/devices2/components/list/itemPanel/DeviceItemPicture.tsx:81
msgid "Última foto de {name}"
msgstr "Última foto de {name}"

#: src/features/gateAdministration/components/index.tsx:61
#: src/features/metricsViews/constants/queryOptions.ts:28
#: src/features/standardDesign/components/DateTimeRangePicker.tsx:47
msgid "Última hora"
msgstr "Última hora"

#. El placeholder es tiempo relativo, e.g. 'hace 1 hora', 'hace 3 días'
#. El placeholder es tiempo relativo, e.g. 'hace 1 hora', 'hace 3 días'
#: src/features/gates/components/list/GateListItemMetrics.tsx:57
#: src/features/gates/components/list/GateListItemMetrics.tsx:121
msgid "Última medición <0/>"
msgstr "Última medición <0/>"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:554
msgid "Última posición"
msgstr "Última posición"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:572
msgid "Última potencia panel solar"
msgstr "Última potencia panel solar"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:590
msgid "Última temperatura"
msgstr "Última temperatura"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:584
msgid "Última turbiedad FNU"
msgstr "Última turbiedad FNU"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:587
msgid "Última turbiedad NTU"
msgstr "Última turbiedad NTU"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:548
msgid "Última velocidad"
msgstr "Última velocidad"

#: src/features/gateAdministration/components/index.tsx:71
#: src/features/standardDesign/components/DateTimeRangePicker.tsx:62
msgid "Últimas 12 horas"
msgstr "Últimas 12 horas"

#: src/features/gateAdministration/components/index.tsx:76
msgid "Últimas 24 horas"
msgstr "Últimas 24 horas"

#: src/features/standardDesign/components/DateTimeRangePicker.tsx:52
msgid "Últimas 4 horas"
msgstr "Últimas 4 horas"

#: src/features/gateAdministration/components/index.tsx:66
#: src/features/metricsViews/constants/queryOptions.ts:35
msgid "Últimas 6 horas"
msgstr "Últimas 6 horas"

#: src/features/standardDesign/components/DateTimeRangePicker.tsx:57
msgid "Últimas 8 horas"
msgstr "Últimas 8 horas"

#: src/features/deviceProfile/components/page/Alerts.tsx:118
msgid "Últimas alertas de {0} gatilladas"
msgstr "Últimas alertas de {0} gatilladas"

#: src/features/users/components/UsersTable.tsx:75
#: src/features/users/utils/filterOptions.ts:116
#: src/features/users/utils/filterOptions.ts:121
#: src/features/users/utils/filterOptions.ts:126
msgid "Último acceso"
msgstr "Último acceso"

#: src/features/users/utils/filterOptions.ts:63
msgid "Último acceso (Asc)"
msgstr "Último acceso (Asc)"

#: src/features/users/utils/filterOptions.ts:70
msgid "Último acceso (Desc)"
msgstr "Último acceso (Desc)"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:551
msgid "Último ángulo"
msgstr "Último ángulo"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:542
msgid "Último caudal"
msgstr "Último caudal"

#. Análisis de estaciones - texto en widget de último dato
#: src/features/devicesAnalysis/components/LastData.tsx:53
#: src/features/deviceSupport/data/column.ts:126
#: src/features/deviceSupport/data/fields.ts:16
#: src/features/gateAdministration/components/index.tsx:416
msgid "Último dato"
msgstr "Último dato"

#: src/features/metricsViews/constants/queryOptions.ts:42
#: src/features/standardDesign/components/DateTimeRangePicker.tsx:67
msgid "Último día"
msgstr "Último día"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:560
msgid "Último estado de conexión"
msgstr "Último estado de conexión"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:39
msgid "Último movimiento"
msgstr "Último movimiento"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:545
msgid "Último nivel"
msgstr "Último nivel"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:581
msgid "Último ORP"
msgstr "Último ORP"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:596
msgid "Último oxígeno disuelto"
msgstr "Último oxígeno disuelto"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:599
msgid "Último oxígeno disuelto (%)"
msgstr "Último oxígeno disuelto (%)"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:578
msgid "Último pH"
msgstr "Último pH"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:563
msgid "Último porcentaje de batería"
msgstr "Último porcentaje de batería"

#: src/components/LastDistributionData.tsx:162
msgid "Último reparto"
msgstr "Último reparto"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:569
msgid "Último voltaje panel solar"
msgstr "Último voltaje panel solar"

#: src/features/standardDesign/components/DateTimeRangePicker.tsx:82
msgid "Últimos 10 días"
msgstr "Últimos 10 días"

#: src/features/standardDesign/components/DateTimeRangePicker.tsx:87
msgid "Últimos 15 días"
msgstr "Últimos 15 días"

#: src/features/metricsViews/constants/queryOptions.ts:21
#: src/features/standardDesign/components/DateTimeRangePicker.tsx:42
msgid "Últimos 15 minutos"
msgstr "Últimos 15 minutos"

#: src/features/gateAdministration/components/index.tsx:81
#: src/features/metricsViews/constants/queryOptions.ts:49
#: src/features/standardDesign/components/DateTimeRangePicker.tsx:72
msgid "Últimos 3 días"
msgstr "Últimos 3 días"

#: src/features/standardDesign/components/DateTimeRangePicker.tsx:92
msgid "Últimos 30 días"
msgstr "Últimos 30 días"

#: src/features/gateAdministration/components/index.tsx:56
msgid "Últimos 30 minutos"
msgstr "Últimos 30 minutos"

#: src/features/gateAdministration/components/index.tsx:51
#: src/features/metricsViews/constants/queryOptions.ts:14
msgid "Últimos 5 minutos"
msgstr "Últimos 5 minutos"

#: src/features/standardDesign/components/DateTimeRangePicker.tsx:97
msgid "Últimos 60 días"
msgstr "Últimos 60 días"

#: src/features/metricsViews/constants/queryOptions.ts:56
#: src/features/standardDesign/components/DateTimeRangePicker.tsx:77
msgid "Últimos 7 días"
msgstr "Últimos 7 días"

#: src/features/standardDesign/components/DateTimeRangePicker.tsx:102
msgid "Últimos 90 días"
msgstr "Últimos 90 días"

#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:143
msgid "Últimos datos"
msgstr "Últimos datos"

#: src/features/deviceProfile/components/page/events/index.tsx:172
msgid "Últimos eventos"
msgstr "Últimos eventos"

#: src/features/gateAdministration/components/MovementHistory.tsx:43
msgid "Últimos movimientos"
msgstr "Últimos movimientos"

#: src/features/audit/components/AuditLogsTimeline.tsx:227
#: src/features/deviceProfile/components/modal/RecentActivity.tsx:38
#: src/features/deviceProfile/components/page/Audit.tsx:160
msgid "Un captiano"
msgstr "Un captiano"

#: src/features/sma/components/forFutureUse/DialogSmaUnitSummary.tsx:129
msgid "Unidad a reportar"
msgstr "Unidad a reportar"

#: src/features/userPreferences/components/MetricsTab.tsx:165
#: src/features/userPreferences/components/MetricsTab.tsx:249
msgid "Unidad de medida"
msgstr "Unidad de medida"

#: src/features/userPreferences/components/MetricsTab.tsx:109
msgid "Unidad de medida y precisión"
msgstr "Unidad de medida y precisión"

#: src/features/userPreferences/components/UserPreferencesModal.tsx:42
msgid "Unidades de medida"
msgstr "Unidades de medida"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:145
#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:61
msgid "URL copiada correctamente"
msgstr "URL copiada correctamente"

#: src/features/audit/utils/parseProperty.ts:44
msgid "URL de Google Drive"
msgstr "URL de Google Drive"

#: src/features/deviceConfiguration/data/sectionFields.ts:9
#: src/features/deviceConfiguration/data/sectionInputs.ts:17
msgid "URL Google Drive"
msgstr "URL Google Drive"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:20
msgid "URL inválida"
msgstr "URL inválida"

#: src/features/audit/utils/getDisplayNameEntity.ts:7
msgid "usuario"
msgstr "usuario"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:34
#: src/features/events/components/HeaderTable.tsx:31
msgid "Usuario"
msgstr "Usuario"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:59
msgid "Usuario activado correctamente"
msgstr "Usuario activado correctamente"

#: src/features/userSaveModal/components/UserSaveModal.tsx:129
msgid "Usuario actualizado correctamente."
msgstr "Usuario actualizado correctamente."

#: src/features/audit/components/AuditLogsSidebar.tsx:157
msgid "Usuario afectado"
msgstr "Usuario afectado"

#: src/features/userSaveModal/components/UserSaveModal.tsx:118
msgid "Usuario creado correctamente."
msgstr "Usuario creado correctamente."

#: src/features/userProfile/components/UserProfile.tsx:118
msgid "Usuario creado el {0}"
msgstr "Usuario creado el {0}"

#: src/features/audit/utils/parseProperty.ts:8
msgid "usuario de obra DGA"
msgstr "usuario de obra DGA"

#: src/features/userProfileUpdate/components/DisableUserModal.tsx:33
msgid "Usuario deshabilitado correctamente"
msgstr "Usuario deshabilitado correctamente"

#: src/features/users/components/modals/DeleteUserModal.tsx:29
msgid "Usuario eliminado correctamente"
msgstr "Usuario eliminado correctamente"

#: src/features/api/components/RowCaptaApiUser.tsx:46
msgid "Usuario inhabilitado"
msgstr "Usuario inhabilitado"

#: src/features/users/utils/filterOptions.ts:138
msgid "Usuario no temporal"
msgstr "Usuario no temporal"

#: src/features/audit/components/AuditLogsSidebar.tsx:123
msgid "Usuario responsable"
msgstr "Usuario responsable"

#: src/features/users/utils/filterOptions.ts:131
#: src/features/users/utils/filterOptions.ts:133
#: src/features/users/utils/filterOptions.ts:136
msgid "Usuario temporal"
msgstr "Usuario temporal"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:93
msgid "Usuario temporal <0>activo</0>"
msgstr "Usuario temporal <0>activo</0>"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:77
msgid "Usuario temporal <0>expirado</0>"
msgstr "Usuario temporal <0>expirado</0>"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:109
#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:125
msgid "Usuario temporal <0>sin activar</0>"
msgstr "Usuario temporal <0>sin activar</0>"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:72
msgid "Usuario temporal creado con éxito"
msgstr "Usuario temporal creado con éxito"

#: src/components/layout/DashboardSidebar.tsx:318
#: src/features/access/components/AccessView.tsx:17
#: src/features/organizationAccess/data/sections.ts:69
msgid "Usuarios"
msgstr "Usuarios"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:71
msgid "Usuarios a notificar"
msgstr "Usuarios a notificar"

#: src/features/deviceConfigurationModal/components/gateTab/alarm/UpdateAlarm.tsx:34
msgid "Usuarios a notificar actualizados correctamente"
msgstr "Usuarios a notificar actualizados correctamente"

#: src/features/deviceProfile/components/page/Permissions.tsx:37
msgid "Usuarios con acceso"
msgstr "Usuarios con acceso"

#: src/features/deviceConfigurationModal/components/accessTab/AccessTab.tsx:54
msgid "Usuarios con acceso al dispositivo"
msgstr "Usuarios con acceso al dispositivo"

#: src/features/notifications/components/Notifications.tsx:91
msgid "Usuarios notificados"
msgstr "Usuarios notificados"

#: src/features/notifications/components/NotificationsSaveModal.tsx:71
msgid "Usuarios notificados correctamente"
msgstr "Usuarios notificados correctamente"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:277
msgid "Usuarios notificados por correo electrónico"
msgstr "Usuarios notificados por correo electrónico"

#: src/features/api/components/dialogs/GeneratedUserApiSummary.tsx:17
msgid "Utilice los siguientes valores junto con su contraseña para acceder a la API:"
msgstr "Utilice los siguientes valores junto con su contraseña para acceder a la API:"

#: src/utils/getUnitTranslation.ts:71
#: src/utils/units.ts:106
msgid "V"
msgstr "V"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:75
#: src/features/billing/components/modals/ServiceFileManager.tsx:57
#: src/features/billing/components/table/ServicesTable.tsx:55
#: src/features/billing/components/table/ServicesTableForTooltip.tsx:46
#: src/features/deviceCommands/components/calendar/CustomCommandsSelector.tsx:39
#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:36
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:541
msgid "Valor"
msgstr "Valor"

#: src/features/audit/components/AuditLogDetails.tsx:89
msgid "Valor antiguo"
msgstr "Valor antiguo"

#: src/features/deviceCommands/components/custom/SendStandardCommandToDevices.tsx:54
msgid "Valor de configuración"
msgstr "Valor de configuración"

#: src/features/deviceDataConfigurationModal/utils/ratingFactory.ts:27
msgid "Valor fuera de rango"
msgstr "Valor fuera de rango"

#: src/features/billing/components/administration/SpiderChart.tsx:58
#: src/features/billing/components/administration/SpiderChart.tsx:126
msgid "Valor medio"
msgstr "Valor medio"

#: src/features/audit/components/AuditLogDetails.tsx:92
msgid "Valor nuevo"
msgstr "Valor nuevo"

#: src/features/billing/components/table/OrganizationsTable.tsx:71
msgid "Valor recurrencias"
msgstr "Valor recurrencias"

#: src/features/billing/components/administration/SpiderChart.tsx:58
#: src/features/billing/components/administration/SpiderChart.tsx:143
msgid "Valor total"
msgstr "Valor total"

#: src/features/audit/components/AuditLogDetails.tsx:83
#: src/features/deviceCommands/components/calendar/CustomCommandsSelector.tsx:23
#: src/features/deviceCommands/components/calendar/CustomCommandsSelector.tsx:27
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:440
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:444
msgid "Variable"
msgstr "Variable"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:155
msgid "Variables disponibles:"
msgstr "Variables disponibles:"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:717
#: src/features/metricsViews/components/SaveWidgetModal.tsx:721
msgid "Variante de grilla"
msgstr "Variante de grilla"

#: src/features/audit/utils/parseProperty.ts:141
msgid "vatios"
msgstr "vatios"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:324
#: src/features/metricsViews/components/SaveWidgetModal.tsx:425
#: src/features/metricsViews/components/SaveWidgetModal.tsx:816
#: src/features/metricsViews/components/widgets/TableWidget.tsx:106
#: src/features/reports/utils/metricHelpers.ts:35
#: src/utils/i18n/getMetricDisplayName.ts:10
msgid "Velocidad"
msgstr "Velocidad"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:41
#: src/features/devicesAnalysis/components/panel/Chart.tsx:300
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:134
msgid "Velocidad superficial"
msgstr "Velocidad superficial"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:302
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:58
msgid "Velocidad superficial bruta"
msgstr "Velocidad superficial bruta"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:242
msgid "Ventana de agregación"
msgstr "Ventana de agregación"

#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:500
#: src/features/metricsViews/components/MetricsViewList.tsx:67
msgid "Ver"
msgstr "Ver"

#: src/features/metricsViews/constants/queryOptions.ts:100
msgid "Ver 1 mes agrupado por día."
msgstr "Ver 1 mes agrupado por día."

#: src/features/metricsViews/constants/queryOptions.ts:92
msgid "Ver 1 mes agrupado por semana."
msgstr "Ver 1 mes agrupado por semana."

#: src/features/metricsViews/constants/queryOptions.ts:84
msgid "Ver 1 semana agrupado por día."
msgstr "Ver 1 semana agrupado por día."

#: src/features/deviceProfile/components/modal/Status.tsx:135
msgid "Ver configuración de alertas"
msgstr "Ver configuración de alertas"

#: src/components/NotificationsPopover.tsx:275
#: src/features/audit/components/AuditLogsTimeline.tsx:281
msgid "Ver detalles"
msgstr "Ver detalles"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:445
msgid "Ver detalles de todos los usuarios"
msgstr "Ver detalles de todos los usuarios"

#: src/features/billing/components/administration/Filters.tsx:65
msgid "Ver en CLP"
msgstr "Ver en CLP"

#: src/features/deviceProfile/components/modal/Info.tsx:134
msgid "Ver en mapa"
msgstr "Ver en mapa"

#: src/features/devicesAnalysis/components/panel/index.tsx:81
msgid "Ver Eventos"
msgstr "Ver Eventos"

#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:91
msgid "Ver filtros"
msgstr "Ver filtros"

#: src/features/gates/components/list/GateListItemMetrics.tsx:145
msgid "Ver gráfico aquí"
msgstr "Ver gráfico aquí"

#: src/features/controlCenter/components/window/StationListItem.tsx:260
msgid "Ver gráfico de telemetría"
msgstr "Ver gráfico de telemetría"

#: src/pages/alerts/index.tsx:21
msgid "Ver histórico"
msgstr "Ver histórico"

#: src/features/deviceProfile/components/modal/Info.tsx:60
msgid "Ver imagen completa"
msgstr "Ver imagen completa"

#: src/features/controlCenter/components/window/StationListItem.tsx:260
msgid "Ver información del sitema"
msgstr "Ver información del sitema"

#: src/features/deviceProfile/components/DeviceProfileModal.tsx:79
#: src/features/gateAdministration/components/GateMovementBanner.tsx:146
msgid "Ver más"
msgstr "Ver más"

#: src/features/deviceProfile/components/page/Audit.tsx:195
msgid "Ver más registros en auditoría"
msgstr "Ver más registros en auditoría"

#: src/features/deviceMenu/components/DeviceMenu.tsx:146
msgid "Ver tabla de datos"
msgstr "Ver tabla de datos"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:41
msgid "Ver todos los movimientos"
msgstr "Ver todos los movimientos"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:90
msgid "Verificación de autenticación"
msgstr "Verificación de autenticación"

#: src/features/audit/utils/parseProperty.ts:120
#: src/features/audit/utils/parseProperty.ts:127
msgid "verificar autentificación"
msgstr "verificar autentificación"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:49
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:61
msgid "Versión 1"
msgstr "Versión 1"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:50
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:62
msgid "Versión 2"
msgstr "Versión 2"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:63
msgid "Versión 3"
msgstr "Versión 3"

#: src/features/audit/utils/parseProperty.ts:96
msgid "versión de hardware satelital"
msgstr "versión de hardware satelital"

#: src/features/audit/utils/parseProperty.ts:92
msgid "versión de imagen"
msgstr "versión de imagen"

#: src/features/deviceConfiguration/data/sectionFields.ts:312
#: src/features/deviceConfiguration/data/sectionInputs.ts:323
msgid "Versión de imagen"
msgstr "Versión de imagen"

#: src/features/audit/utils/parseProperty.ts:95
msgid "versión de software satelital"
msgstr "versión de software satelital"

#: src/features/audit/utils/parseProperty.ts:22
msgid "versión de tipo"
msgstr "versión de tipo"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:376
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:381
msgid "Versión del Filtro de Outliers"
msgstr "Versión del Filtro de Outliers"

#: src/features/deviceConfiguration/data/sectionFields.ts:518
msgid "Versión del Hardware"
msgstr "Versión del Hardware"

#: src/features/audit/utils/parseProperty.ts:139
msgid "versión del sensor"
msgstr "versión del sensor"

#: src/features/deviceConfiguration/data/sectionFields.ts:530
msgid "Versión del Software"
msgstr "Versión del Software"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:330
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:335
msgid "Versión del Tópico"
msgstr "Versión del Tópico"

#: src/features/reports/utils/schedules.ts:16
msgid "viernes"
msgstr "viernes"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:138
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:118
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:220
#: src/features/metricsViews/components/widgets/ChartWidget.tsx:85
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:90
#: src/utils/i18n/getDgaTranslations.ts:11
msgid "Viernes"
msgstr "Viernes"

#: src/utils/devices/formatSourceColor.ts:20
#: src/utils/formatSource.ts:11
msgid "Virtual"
msgstr "Virtual"

#: src/components/layout/DashboardSidebar.tsx:204
msgid "Vista de Métricas"
msgstr "Vista de Métricas"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:48
msgid "Vista Previa de Pagos a Crear."
msgstr "Vista Previa de Pagos a Crear."

#: src/features/billing/components/modals/ServiceFileManager.tsx:42
msgid "Vista Previa de Servicios a Crear."
msgstr "Vista Previa de Servicios a Crear."

#: src/features/deviceProfile/components/page/MetricsViews.tsx:26
msgid "Vistas de métricas"
msgstr "Vistas de métricas"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:297
msgid "Visualización de curvas de aforo"
msgstr "Visualización de curvas de aforo"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:514
msgid "Visualización de Filtros"
msgstr "Visualización de Filtros"

#: src/pages/metrics-views/[id].tsx:17
msgid "Visualización de métricas"
msgstr "Visualización de métricas"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:131
#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:131
#: src/features/organizationAccess/data/sections.ts:73
msgid "Visualización métricas"
msgstr "Visualización métricas"

#: src/features/organizationAccess/data/sections.ts:77
msgid "Visualizar dotación"
msgstr "Visualizar dotación"

#: src/utils/getUnitTranslation.ts:72
#: src/utils/units.ts:107
msgid "volt"
msgstr "volt"

#: src/features/audit/utils/parseProperty.ts:158
msgid "voltaje"
msgstr "voltaje"

#: src/features/deviceConfiguration/data/sectionFields.ts:199
#: src/features/deviceConfiguration/data/sectionInputs.ts:199
msgid "Voltaje"
msgstr "Voltaje"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:31
msgid "Voltaje batería"
msgstr "Voltaje batería"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:310
msgid "Voltaje Batería"
msgstr "Voltaje Batería"

#: src/features/audit/utils/parseProperty.ts:61
msgid "voltaje de alimentación"
msgstr "voltaje de alimentación"

#: src/features/deviceConfiguration/data/sectionInputs.ts:261
msgid "Voltaje de alimentación"
msgstr "Voltaje de alimentación"

#: src/features/audit/utils/parseProperty.ts:71
msgid "voltaje de batería"
msgstr "voltaje de batería"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:16
msgid "Voltaje de batería"
msgstr "Voltaje de batería"

#: src/features/audit/utils/parseProperty.ts:157
msgid "voltaje del sistema"
msgstr "voltaje del sistema"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:109
msgid "Voltaje fuente"
msgstr "Voltaje fuente"

#: src/features/deviceConfiguration/data/sectionFields.ts:243
msgid "Voltaje fuente DC"
msgstr "Voltaje fuente DC"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:55
msgid "Voltaje Panel"
msgstr "Voltaje Panel"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:432
#: src/features/metricsViews/components/SaveWidgetModal.tsx:840
#: src/features/metricsViews/components/widgets/TableWidget.tsx:113
msgid "Voltaje panel solar"
msgstr "Voltaje panel solar"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:315
msgid "Voltaje Panel Solar"
msgstr "Voltaje Panel Solar"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:93
msgid "Voltaje sistema"
msgstr "Voltaje sistema"

#: src/features/controlCenter/components/panel/Minicharts.tsx:426
#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:345
#: src/features/gates/components/list/GateListItemMinichart.tsx:102
msgid "Voltaje solar"
msgstr "Voltaje solar"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:71
#: src/features/metricsViews/components/SaveWidgetModal.tsx:705
msgid "Volumen"
msgstr "Volumen"

#: src/features/dga/components/modals/reports/TableModal.tsx:253
msgid "Volumen ac."
msgstr "Volumen ac."

#: src/features/devicesAnalysis/components/panel/Chart.tsx:294
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarDGACheckboxList.tsx:53
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:42
#: src/utils/i18n/getMetricDisplayName.ts:11
msgid "Volumen acumulado"
msgstr "Volumen acumulado"

#: src/features/reports/utils/metricHelpers.ts:8
msgid "Volumen Acumulado"
msgstr "Volumen Acumulado"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:849
msgid "Volumen acumulado calculado"
msgstr "Volumen acumulado calculado"

#: src/features/reports/utils/metricHelpers.ts:12
msgid "Volumen Acumulado DGA"
msgstr "Volumen Acumulado DGA"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:61
#: src/features/devicesAnalysis/components/panel/Chart.tsx:353
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:29
msgid "Volumen almacenado"
msgstr "Volumen almacenado"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:207
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:62
#: src/utils/i18n/getMetricDisplayName.ts:12
msgid "Volumen día"
msgstr "Volumen día"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:194
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:52
#: src/utils/i18n/getMetricDisplayName.ts:13
msgid "Volumen hora"
msgstr "Volumen hora"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:220
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:72
#: src/utils/i18n/getMetricDisplayName.ts:14
msgid "Volumen mes"
msgstr "Volumen mes"

#: src/features/reports/utils/metricHelpers.ts:40
msgid "Volumen por día"
msgstr "Volumen por día"

#: src/features/reports/utils/metricHelpers.ts:39
msgid "Volumen por hora"
msgstr "Volumen por hora"

#: src/features/reports/utils/metricHelpers.ts:41
msgid "Volumen por mes"
msgstr "Volumen por mes"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:575
msgid "Volumen total calculado del mes"
msgstr "Volumen total calculado del mes"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:846
msgid "Volumen/Período calculado"
msgstr "Volumen/Período calculado"

#: src/pages/gates/administration/[gateId].tsx:39
#: src/pages/systems/administrator.tsx:67
msgid "Volver"
msgstr "Volver"

#: src/features/announcements/components/AnnouncementSkeleton.tsx:10
#: src/features/announcements/components/AnnouncementView.tsx:30
#: src/features/announcements/components/AnnouncementView.tsx:41
msgid "Volver a anuncios"
msgstr "Volver a anuncios"

#: src/features/alertsNotificationsHistory/components/AlertsNotificationsHistory.tsx:54
msgid "Volver a configuraciones"
msgstr "Volver a configuraciones"

#: src/pages/AuthorizationRequired.tsx:72
msgid "Volver a Login"
msgstr "Volver a Login"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:132
msgid "Volver atrás"
msgstr "Volver atrás"

#: src/utils/getUnitTranslation.ts:63
#: src/utils/units.ts:96
msgid "W"
msgstr "W"

#: src/utils/getUnitTranslation.ts:67
#: src/utils/units.ts:101
msgid "W/m²"
msgstr "W/m²"

#: src/utils/getUnitTranslation.ts:64
#: src/utils/units.ts:97
msgid "watt"
msgstr "watt"

#: src/utils/getUnitTranslation.ts:68
#: src/utils/units.ts:102
msgid "watt per square meter"
msgstr "watt per square meter"

#: src/features/deviceConfiguration/data/sectionFields.ts:227
#: src/features/deviceConfiguration/data/sectionInputs.ts:237
msgid "Watts"
msgstr "Watts"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:133
#: src/features/alertsConfiguration/components/AlertTable.tsx:212
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:117
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:123
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:63
msgid "Whatsapp"
msgstr "Whatsapp"

#: src/features/alertsNotificationsHistory/hooks/useTranslations.ts:19
msgid "WhatsApp"
msgstr "WhatsApp"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:139
msgid "Widget actualizado"
msgstr "Widget actualizado"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:139
msgid "Widget agregado"
msgstr "Widget agregado"

#: src/features/metricsViews/components/MetricsView.tsx:144
msgid "Widget eliminado correctamente"
msgstr "Widget eliminado correctamente"

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:69
msgid "Wifi"
msgstr "Wifi"

#: src/features/reports/utils/schedules.ts:37
msgid "y"
msgstr "y"

#: src/features/billing/components/table/OrganizationsTable.tsx:175
msgid "y {moreServicesCount} más"
msgstr "y {moreServicesCount} más"

#: src/features/userPreferences/components/RegionTab.tsx:165
msgid "Zona horaria"
msgstr "Zona horaria"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:334
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:215
msgid "Zona Horaria"
msgstr "Zona Horaria"

#: src/components/PicturePreview.tsx:68
msgid "Zoom por defecto"
msgstr "Zoom por defecto"

#: src/utils/getUnitTranslation.ts:103
#: src/utils/units.ts:146
msgid "µS/cm"
msgstr "µS/cm"
